// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
import React from 'react'

import { makeIcon } from './makeIcon'

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIcon100Small = makeIcon({
  displayName: 'NoteIcon100Small',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.975 5.765c-.597-.063-1.034-.306-1.31-.73a1.665 1.665 0 0 1-.198-.53 3.783 3.783 0 0 1-.207.547c-.21.42-.483.73-.82.929-.333.198-.715.275-1.149.23-.597-.063-1.033-.306-1.31-.73-.272-.423-.284-1.371-.205-2.118.063-.606.2-1.12.41-1.54.21-.421.48-.731.813-.93a1.83 1.83 0 0 1 1.148-.23c.602.064 1.039.309 1.31.737.075.115.138.242.187.382.05-.144.106-.279.17-.405.209-.421.48-.731.812-.93a1.83 1.83 0 0 1 1.149-.23c.601.064 1.038.31 1.31.737.276.423.375 1.005.298 1.747-.064.606-.23 1.485-.44 1.906-.209.42-.482.73-.82.928-.332.199-.715.275-1.148.23Zm.135-1c.245.025.451-.133.619-.476.172-.342.323-1.22.395-1.903.04-.385.021-.67-.057-.853a.479.479 0 0 0-.42-.314c-.245-.026-.454.135-.627.482-.168.347-.287.858-.358 1.531-.04.386-.05 1.037.027 1.225a.48.48 0 0 0 .42.307Zm-3.684.445c.245.025.452-.133.62-.475.171-.342.378-1.22.45-1.903.04-.385.022-.67-.056-.853a.479.479 0 0 0-.42-.314c-.245-.026-.454.134-.627.481-.168.348-.287.858-.358 1.532-.04.385-.107 1.036-.03 1.225a.48.48 0 0 0 .42.307Z"
        />
        <path d="M1.518 7.067a.669.669 0 0 0 1.329.155l.631-5.302c.034-.206 0-.369-.104-.488a.57.57 0 0 0-.43-.204 1.329 1.329 0 0 0-.642.137l-1.264.588a.51.51 0 0 0-.292.43.597.597 0 0 0 .117.402.483.483 0 0 0 .358.192.584.584 0 0 0 .302-.058l.496-.22-.5 4.368ZM9.26 8.912c-2.188-.364-3.536-.228-4.487.176A.7.7 0 0 1 4.226 7.8c1.299-.552 2.951-.654 5.264-.269a.7.7 0 1 1-.23 1.381ZM2.899 11.911c1.066-.453 3.905-1.415 7.074-.71a.7.7 0 1 0 .304-1.367c-3.582-.796-6.743.286-7.926.789a.7.7 0 0 0 .548 1.288Z" />
      </g>
    </>
  ),
})

export const NoteIcon100 = makeIcon({
  displayName: 'NoteIcon100',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.704 7.175c-.743-.078-1.287-.38-1.631-.908a2.074 2.074 0 0 1-.246-.66 4.712 4.712 0 0 1-.258.68c-.261.524-.601.91-1.021 1.156-.414.247-.89.343-1.43.286-.743-.078-1.286-.38-1.63-.908-.34-.526-.354-1.707-.256-2.636.08-.755.25-1.394.51-1.918.261-.524.599-.91 1.012-1.156.42-.247.897-.342 1.43-.286.749.078 1.292.384 1.63.916.094.144.172.303.233.476a4.28 4.28 0 0 1 .21-.504c.262-.524.6-.91 1.013-1.157.42-.247.896-.342 1.43-.286.748.079 1.292.384 1.63.916.344.527.467 1.252.37 2.175-.079.755-.285 1.848-.546 2.372-.26.524-.6.91-1.02 1.156-.414.247-.89.342-1.43.286Zm.167-1.246c.306.032.563-.165.771-.591.215-.426.402-1.518.491-2.37.05-.478.027-.832-.07-1.06a.596.596 0 0 0-.522-.392c-.306-.032-.566.168-.78.6-.21.432-.358 1.068-.447 1.907-.05.479-.063 1.29.034 1.524a.598.598 0 0 0 .523.382Zm-4.585.554c.305.033.562-.165.77-.59.215-.427.473-1.519.562-2.37.05-.479.027-.833-.07-1.06a.596.596 0 0 0-.522-.392c-.306-.032-.566.168-.781.6-.21.432-.358 1.067-.446 1.906-.05.48-.133 1.29-.037 1.524a.598.598 0 0 0 .524.382Z"
        fill="currentcolor"
      />
      <path
        d="M2.422 8.796a.832.832 0 0 0 1.653.193l.786-6.6c.042-.257 0-.46-.13-.607-.122-.154-.3-.239-.534-.255-.247-.017-.513.04-.8.17l-1.573.733a.634.634 0 0 0-.364.536.742.742 0 0 0 .146.5.601.601 0 0 0 .445.24.727.727 0 0 0 .377-.074l.617-.274-.623 5.438ZM12.377 11.535c-2.933-.489-4.77-.312-6.083.247a.75.75 0 0 1-.587-1.38c1.686-.718 3.85-.858 6.916-.347a.75.75 0 1 1-.246 1.48ZM3.794 15.282c1.437-.611 5.264-1.91 9.543-.958a.75.75 0 1 0 .326-1.464c-4.721-1.05-8.894.377-10.456 1.042a.75.75 0 1 0 .587 1.38Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIcon100Small,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconWarningSmall = makeIcon({
  displayName: 'NoteIconWarningSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M6 4.25a.75.75 0 0 1 .75.75v2.125a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 6 4.25ZM6 9.938a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.309 1.043c.68-1.42 2.702-1.42 3.382 0l3.963 8.272A1.875 1.875 0 0 1 9.964 12H2.035a1.875 1.875 0 0 1-1.69-2.685l3.963-8.272Zm2.03.648a.375.375 0 0 0-.677 0L1.698 9.963a.375.375 0 0 0 .338.537h7.927a.375.375 0 0 0 .339-.537L6.338 1.691Z"
        />
      </g>
    </>
  ),
})

export const NoteIconWarning = makeIcon({
  displayName: 'NoteIconWarning',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M8 5.25a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 8 5.25ZM8 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.994 1.296c.833-1.643 3.179-1.643 4.012 0l5.557 10.945c.76 1.497-.328 3.269-2.007 3.269H2.444c-1.679 0-2.766-1.772-2.007-3.269L5.994 1.296Zm2.675.678a.75.75 0 0 0-1.338 0L1.775 12.92a.75.75 0 0 0 .669 1.09h11.112a.75.75 0 0 0 .67-1.09L8.668 1.974Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconWarningSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconWhiteCheckMarkSmall = makeIcon({
  displayName: 'NoteIconWhiteCheckMarkSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.418 1.5a.75.75 0 0 1 .552.22l1.81 1.81a.75.75 0 0 1 .029 1.03l-6.155 6.88a.75.75 0 0 1-1.066.053L.243 7.51a.75.75 0 0 1-.05-1.055l1.629-1.81a.75.75 0 0 1 1.045-.068l1.977 1.694 4.036-4.52a.75.75 0 0 1 .538-.25Zm.053 1.842L4.984 8.367 2.447 6.192l-.642.714 3.237 2.968 5.176-5.785-.747-.747Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconWhiteCheckMark = makeIcon({
  displayName: 'NoteIconWhiteCheckMark',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.729 1.25a.75.75 0 0 1 .551.22l2.5 2.5A.75.75 0 0 1 15.81 5l-8.5 9.5a.75.75 0 0 1-1.066.053l-6-5.5a.75.75 0 0 1-.05-1.055l2.25-2.5a.75.75 0 0 1 1.045-.067L6.43 7.952 12.19 1.5a.75.75 0 0 1 .539-.25Zm.052 1.842L6.57 10.048 3.068 7.046 1.805 8.449l4.892 4.485 7.521-8.405-1.437-1.437Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconWhiteCheckMarkSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconCalendarSmall = makeIcon({
  displayName: 'NoteIconCalendarSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M5.728 4.228a.651.651 0 0 1 1.11.46V8.1h.474a.65.65 0 0 1 0 1.3h-2.25a.65.65 0 0 1 0-1.3h.475V6.258l-.202.202a.65.65 0 0 1-.92-.92l1.313-1.312Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.625.05a.7.7 0 0 1 .7.7v.3h.8c1.008 0 1.825.817 1.825 1.825v7.25a1.825 1.825 0 0 1-1.825 1.825h-8.25A1.825 1.825 0 0 1 .05 10.125v-7.25c0-1.008.817-1.825 1.825-1.825h.8v-.3a.7.7 0 0 1 1.4 0v.3h3.85v-.3a.7.7 0 0 1 .7-.7Zm-6.75 2.4a.425.425 0 0 0-.425.425v7.25c0 .235.19.425.425.425h8.25c.235 0 .425-.19.425-.425v-7.25a.425.425 0 0 0-.425-.425h-.8v1.112a.7.7 0 0 1-1.4 0V2.45h-3.85v1.112a.7.7 0 0 1-1.4 0V2.45h-.8Z"
        />
      </g>
    </>
  ),
})

export const NoteIconCalendar = makeIcon({
  displayName: 'NoteIconCalendar',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M9 6.25a.75.75 0 0 0-1.28-.53L5.97 7.47a.75.75 0 0 0 1.06 1.06l.47-.47v3.44h-.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5H9V6.25Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25.75a.75.75 0 0 0-1.5 0v1h-1.5A2.25 2.25 0 0 0 0 4v9.75A2.25 2.25 0 0 0 2.25 16h11.5A2.25 2.25 0 0 0 16 13.75V4a2.25 2.25 0 0 0-2.25-2.25h-1.5v-1a.75.75 0 0 0-1.5 0v1h-5.5v-1Zm5.5 3.75V3.25h-5.5V4.5a.75.75 0 0 1-1.5 0V3.25h-1.5A.75.75 0 0 0 1.5 4v9.75c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75h-1.5V4.5a.75.75 0 0 1-1.5 0Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconCalendarSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconHammerSmall = makeIcon({
  displayName: 'NoteIconHammerSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.21 2.023a.75.75 0 0 1-.027 1.057L7.81 5.353l3.528 3.296a1.836 1.836 0 1 1-2.599 2.592L5.407 7.655 3.631 9.356a.75.75 0 0 1-1.049-.01L.224 6.985a.75.75 0 0 1 .02-1.08l4.594-4.263a.75.75 0 0 1 .457-.199l.095-.006A3.75 3.75 0 0 0 7.215.81L7.82.405a.75.75 0 0 1 .963.107l1.427 1.511ZM6.49 6.617l3.348 3.603a.336.336 0 1 0 .476-.475l-3.59-3.353-.233.225Zm-4.655-.14 1.289 1.288 5.483-5.253-.48-.508-.076.051a5.25 5.25 0 0 1-2.383.864L1.835 6.476Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconHammer = makeIcon({
  displayName: 'NoteIconHammer',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.41 2.467a.75.75 0 0 1-.011 1.071L9.885 6.905l5.197 4.65a2.169 2.169 0 1 1-3.063 3.063l-4.7-5.254-2.656 2.544a.75.75 0 0 1-1.049-.011L.47 8.75a.75.75 0 0 1 .02-1.08l6.126-5.685a.75.75 0 0 1 .562-.198l.196.013a4.25 4.25 0 0 0 2.688-.728L10.71.63a.75.75 0 0 1 .953.09l1.747 1.747ZM8.402 8.325l4.735 5.291a.669.669 0 1 0 .945-.944L8.799 7.945l-.397.38ZM2.081 8.24l2.075 2.075 7.651-7.33-.765-.766-.135.092a5.75 5.75 0 0 1-3.507.993L2.08 8.241Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconHammerSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconRocketSmall = makeIcon({
  displayName: 'NoteIconRocketSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M8.927 4.562a.98.98 0 1 1-1.386-1.386.98.98 0 0 1 1.386 1.386Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.896 2.03A2.2 2.2 0 0 0 9.951.084L9.878.076A6.7 6.7 0 0 0 3.672 2.87 3.136 3.136 0 0 0 .386 3.993l-.243.317a.7.7 0 0 0 .259 1.06l1.59.744-.197.406a.7.7 0 0 0 .134.802l.053.053a2.144 2.144 0 0 0-.618.43c-.256.257-.398.604-.485.884-.092.3-.15.62-.188.903a9.486 9.486 0 0 0-.077 1.043V10.662a.7.7 0 0 0 .703.704l-.004-.7.005.7h.027l.066-.001a9.348 9.348 0 0 0 .976-.077c.283-.037.605-.095.903-.187.28-.087.628-.23.884-.486.183-.182.327-.392.43-.617l.055.054a.7.7 0 0 0 .802.134l.404-.197.743 1.59a.7.7 0 0 0 1.06.259l.318-.244A3.136 3.136 0 0 0 9.109 8.31a6.7 6.7 0 0 0 2.795-6.208l-.008-.072Zm-2.099-.554a.8.8 0 0 1 .708.707l.008.073a5.3 5.3 0 0 1-2.944 5.343L5.295 8.71 3.272 6.685l1.11-2.273a5.3 5.3 0 0 1 5.343-2.944l.072.008Zm-8.484 9.19-.7-.004.7.004Zm6.164-.534-.354-.757.688-.336c.015.39-.102.776-.334 1.093Zm-4.87-5.276.335-.688a1.739 1.739 0 0 0-1.093.333l.758.355Zm-.253 3.94c.294-.294.692-.261.891-.061.2.2.233.597-.06.89 0 0-.022.02-.079.049-.056.029-.132.06-.23.089-.194.06-.431.105-.673.137a6.93 6.93 0 0 1-.14.018c.004-.047.01-.094.016-.142.032-.241.077-.478.138-.673.03-.097.06-.173.089-.23.029-.056.048-.078.048-.078Z"
        />
      </g>
    </>
  ),
})

export const NoteIconRocket = makeIcon({
  displayName: 'NoteIconRocket',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M11.977 5.908a1.324 1.324 0 1 1-1.873-1.873 1.324 1.324 0 0 1 1.873 1.873Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.36.053a2.75 2.75 0 0 1 2.433 2.433l.021.195A8.75 8.75 0 0 1 12 10.901a4.043 4.043 0 0 1-1.413 4.356l-.429.329a.75.75 0 0 1-1.136-.277l-1.09-2.33-.725.354a.75.75 0 0 1-.859-.144l-.283-.283a2.7 2.7 0 0 1-.649 1.045c-.312.312-.744.493-1.114.607-.39.12-.812.197-1.188.247a12.604 12.604 0 0 1-1.387.103h-.035l-.004-.75-.75-.004v-.035a8.256 8.256 0 0 1 .015-.397c.013-.256.039-.61.089-.99.05-.376.126-.798.247-1.187.114-.37.295-.802.607-1.114a2.7 2.7 0 0 1 1.044-.65L2.657 9.5a.75.75 0 0 1-.143-.859l.355-.728-2.331-1.09A.75.75 0 0 1 .26 5.687l.329-.428a4.043 4.043 0 0 1 4.356-1.413 8.75 8.75 0 0 1 8.22-3.813l.195.021Zm.942 2.597a1.25 1.25 0 0 0-1.106-1.106l-.195-.021a7.25 7.25 0 0 0-7.31 4.026L4.096 8.817 7.03 11.75l3.268-1.595a7.25 7.25 0 0 0 4.026-7.31l-.021-.195ZM9.28 12.32l1.356-.661c.12.77-.121 1.564-.665 2.139l-.69-1.478ZM4.188 5.208a2.544 2.544 0 0 0-2.14.665l1.479.69.661-1.355Zm-1.233 6.283c.465-.464 1.127-.436 1.482-.082.354.355.382 1.017-.082 1.481-.05.05-.199.143-.497.235-.278.086-.61.149-.942.193-.151.02-.299.036-.436.048.012-.138.028-.285.048-.436.044-.332.107-.664.193-.942.092-.298.184-.447.234-.497Z"
        />
        <path d="m.937 14.154.75.005.004.75a.75.75 0 0 1-.754-.755Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconRocketSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconWritingHandSmall = makeIcon({
  displayName: 'NoteIconWritingHandSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.107.987a1.775 1.775 0 1 1 3.068 1.785l-.136.232 3.337 1.161a.651.651 0 0 1-.428 1.229L7.375 4.15 6.257 6.1h1.806a.65.65 0 0 1 0 1.3H5.348a.475.475 0 0 0 0 .95h1.967c.205 0 .408.04.598.115l.05.02c.552.221 1.183.255 1.687.106.49-.145.811-.44.92-.873a.65.65 0 0 1 1.261.314c-.245.979-.989 1.561-1.811 1.805-.809.24-1.74.175-2.54-.144l-.05-.02a.31.31 0 0 0-.115-.022H5.348c-.36 0-.693-.11-.971-.292l-.831 1.439a.649.649 0 0 1-.312.274l-1.859.778a.65.65 0 0 1-.9-.57l-.09-1.902a.651.651 0 0 1 .087-.354l.212-.37A1.476 1.476 0 0 1 .09 6.982l.914-2.926a3.114 3.114 0 0 1 3.412-2.154l.145.021.545-.937ZM1.693 9.506l.037.786.801-.335L3.59 8.121a1.776 1.776 0 0 1 1.094-1.894l.003-.003 1.428-2.488-.821-.48-3.6 6.25Zm2.146-6.33a1.815 1.815 0 0 0-1.594 1.269L1.331 7.37a.174.174 0 0 0 .014.136l2.494-4.33Zm3.04-1.706a.476.476 0 0 0-.648.17l-.286.492.82.479.287-.492a.475.475 0 0 0-.173-.65Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconWritingHand = makeIcon({
  displayName: 'NoteIconWritingHand',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.984.562a2.25 2.25 0 0 0-3.073.823l-.755 1.308-.283-.04A4.036 4.036 0 0 0 1.45 5.444l-1.218 3.9c-.27.866.124 1.742.838 2.157l-.34.588a.75.75 0 0 0-.099.41l.12 2.537a.75.75 0 0 0 1.038.656l2.479-1.036a.75.75 0 0 0 .36-.317l1.17-2.026c.371.274.832.437 1.332.437h2.675c.049 0 .097.008.143.023l1.381.46a3.614 3.614 0 0 0 4.649-2.551.75.75 0 0 0-1.455-.364 2.114 2.114 0 0 1-2.72 1.493l-1.38-.46c-.2-.067-.408-.1-.618-.1H7.13a.75.75 0 1 1 0-1.5h3.62a.75.75 0 0 0 0-1.5H8.144l1.648-2.855 5.212 1.812a.75.75 0 1 0 .492-1.416l-4.94-1.719.252-.438A2.25 2.25 0 0 0 9.984.562ZM6.328 8.398a.764.764 0 0 1 .023-.042L8.72 4.252l-1.3-.75-5.28 9.147.059 1.246 1.256-.525 1.453-2.515a2.258 2.258 0 0 1 1.42-2.457ZM1.821 10.2l3.515-6.089a2.536 2.536 0 0 0-2.454 1.78l-1.219 3.9a.353.353 0 0 0 .158.41ZM9.47 2.953l-1.3-.75.04-.068a.75.75 0 0 1 1.299.75l-.04.068Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconWritingHandSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconDartSmall = makeIcon({
  displayName: 'NoteIconDartSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.562 1.358a.65.65 0 0 0-.92-.92l-.488.489-.087-.337A.65.65 0 0 0 8.981.292L7.366 1.914a.653.653 0 0 0-.17.623l.276 1.072-1.061 1.06a1.377 1.377 0 1 0 .919.92L8.39 4.53l1.067.276a.647.647 0 0 0 .62-.17l1.615-1.622a.653.653 0 0 0-.297-1.09l-.317-.083.484-.483ZM9.346 2.643a.651.651 0 0 0 .31.176l.315.081-.55.552-.696-.18-.18-.7.55-.552.082.317a.652.652 0 0 0 .169.306Z"
        />
        <path d="M1.389 5.989A4.622 4.622 0 0 1 6.842 1.44.65.65 0 0 0 7.074.16a5.922 5.922 0 1 0 4.778 4.842.65.65 0 1 0-1.282.215 4.622 4.622 0 1 1-9.181.77Z" />
        <path d="M3.57 5.989a2.44 2.44 0 0 1 2.441-2.441.65.65 0 0 0 0-1.3 3.74 3.74 0 1 0 3.74 3.74.65.65 0 1 0-1.3 0 2.44 2.44 0 1 1-4.88 0Z" />
      </g>
    </>
  ),
})

export const NoteIconDart = makeIcon({
  displayName: 'NoteIconDart',
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.53 1.53A.75.75 0 0 0 14.47.47l-.85.85-.181-.707a.746.746 0 0 0-1.254-.344L9.965 2.5a.754.754 0 0 0-.196.719l.4 1.553-1.58 1.58a1.75 1.75 0 1 0 1.06 1.06l1.577-1.577 1.548.4a.747.747 0 0 0 .716-.196l2.22-2.23a.753.753 0 0 0-.343-1.259l-.68-.176.843-.843Zm-3.024 1.466a.75.75 0 0 0 .553.509l.665.172-.99.995-1.12-.29-.289-1.124.992-.996.176.686a.722.722 0 0 0 .013.048Z"
        />
        <path d="M1.5 8a6.5 6.5 0 0 1 7.668-6.396.75.75 0 1 0 .268-1.476 8 8 0 1 0 6.454 6.54.75.75 0 0 0-1.48.248A6.5 6.5 0 1 1 1.5 8Z" />
        <path d="M4.5 8A3.5 3.5 0 0 1 8 4.5.75.75 0 0 0 8 3a5 5 0 1 0 5 5 .75.75 0 0 0-1.5 0 3.5 3.5 0 1 1-7 0Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconDartSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBulbSmall = makeIcon({
  displayName: 'NoteIconBulbSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 .1c2.58 0 4.775 1.806 4.775 4.526 0 1.527-.849 2.671-1.53 3.468a2.208 2.208 0 0 0-.5 1.011 1.346 1.346 0 0 1-.87 1.01v.01c0 .35-.24.64-.563.723v.102a.75.75 0 0 1-.75.75H5.438a.75.75 0 0 1-.75-.75v-.102a.747.747 0 0 1-.562-.723v-.006a1.355 1.355 0 0 1-.875-1 2.09 2.09 0 0 0-.426-.895c-.683-.838-1.6-2.016-1.6-3.598C1.225 1.906 3.422.1 6 .1Zm0 1.3c-1.977 0-3.475 1.334-3.475 3.226 0 1.073.613 1.925 1.306 2.775.344.422.581.92.692 1.453a.055.055 0 0 0 .054.043h.01v-1.85l-.799-.964a.6.6 0 0 1 .924-.766l.937 1.131a.6.6 0 0 1 .138.383v2.065h.363V6.833a.6.6 0 0 1 .138-.383l.938-1.13a.6.6 0 0 1 .923.765l-.8.964v1.847h.073a.047.047 0 0 0 .046-.039c.118-.605.4-1.154.789-1.609.652-.76 1.218-1.594 1.218-2.622C9.475 2.734 7.977 1.4 6 1.4Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconBulb = makeIcon({
  displayName: 'NoteIconBulb',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 .05c3.407 0 6.2 2.64 6.2 6.118 0 1.972-1.096 3.457-2.002 4.515a3.114 3.114 0 0 0-.704 1.425c-.108.557-.493 1-.994 1.2v.192a.999.999 0 0 1-.75.967v.133a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1v-.133a.999.999 0 0 1-.75-.967v-.187a1.64 1.64 0 0 1-1.003-1.189 2.955 2.955 0 0 0-.602-1.265C2.982 9.741 1.8 8.212 1.8 6.168 1.8 2.69 4.593.05 8 .05Zm0 1.4c-2.668 0-4.8 2.047-4.8 4.718 0 1.496.856 2.674 1.78 3.807.441.541.745 1.18.887 1.864a.24.24 0 0 0 .236.19H6.3V9.36L5.21 8.047a.7.7 0 0 1 1.08-.893l1.25 1.508a.701.701 0 0 1 .16.446v2.92h.6V9.11c0-.163.057-.32.16-.446l1.25-1.508a.7.7 0 0 1 1.08.893L9.7 9.363v2.664h.196a.23.23 0 0 0 .224-.185 4.513 4.513 0 0 1 1.016-2.07c.873-1.02 1.664-2.17 1.664-3.604 0-2.671-2.132-4.718-4.8-4.718Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconBulbSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconComputerSmall = makeIcon({
  displayName: 'NoteIconComputerSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M4.688 3.75a.75.75 0 0 1 .75-.75h1.125a.75.75 0 0 1 0 1.5H5.438a.75.75 0 0 1-.75-.75Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.563 3A2.25 2.25 0 0 1 2.813.75h6.374A2.25 2.25 0 0 1 11.438 3v4.524A.75.75 0 0 1 12 8.25V9a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 0 9v-.75a.75.75 0 0 1 .563-.726V3Zm1.5 4.5h7.874V3a.75.75 0 0 0-.75-.75H2.814a.75.75 0 0 0-.75.75v4.5Zm.187 2.25A.75.75 0 0 1 1.5 9h9a.75.75 0 0 1-.75.75h-7.5Z"
        />
      </g>
    </>
  ),
})

export const NoteIconComputer = makeIcon({
  displayName: 'NoteIconComputer',
  content: (
    <>
      <path
        d="M6.5 5a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 6.5 5Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4.25A2.25 2.25 0 0 1 3.25 2h9.5A2.25 2.25 0 0 1 15 4.25v6h.25A.75.75 0 0 1 16 11v.5a2.25 2.25 0 0 1-2.25 2.25H2.25A2.25 2.25 0 0 1 0 11.5V11a.75.75 0 0 1 .75-.75H1v-6Zm.543 7.5c.103.291.38.5.707.5h11.5a.75.75 0 0 0 .707-.5H1.543Zm11.957-1.5h-11v-6a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 .75.75v6Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconComputerSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconSpeechBalloonSmall = makeIcon({
  displayName: 'NoteIconSpeechBalloonSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M3.375 5.813a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM6.75 5.063a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM8.625 5.813a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.179.25A2.179 2.179 0 0 0 0 2.429v5.297C0 8.93.975 9.905 2.179 9.905h1.696l1.59 1.62a.75.75 0 0 0 1.07 0l1.59-1.62h1.696A2.179 2.179 0 0 0 12 7.726V2.43A2.179 2.179 0 0 0 9.821.25H2.18ZM1.5 2.429c0-.375.304-.679.679-.679H9.82c.375 0 .679.304.679.679v5.297a.679.679 0 0 1-.679.679h-2.01a.75.75 0 0 0-.536.225L6 9.93l-1.275-1.3a.75.75 0 0 0-.535-.225H2.179a.679.679 0 0 1-.679-.679V2.43Z"
        />
      </g>
    </>
  ),
})

export const NoteIconSpeechBalloon = makeIcon({
  displayName: 'NoteIconSpeechBalloon',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M4.5 7.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9 6.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11.5 7.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75.25A2.75 2.75 0 0 0 0 3v7.417a2.75 2.75 0 0 0 2.75 2.75h2.432l2.279 2.355a.75.75 0 0 0 1.078 0l2.279-2.355h2.432a2.75 2.75 0 0 0 2.75-2.75V3A2.75 2.75 0 0 0 13.25.25H2.75ZM1.5 3c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v7.417c0 .69-.56 1.25-1.25 1.25H10.5a.75.75 0 0 0-.539.228L8 13.922l-1.961-2.027a.75.75 0 0 0-.539-.228H2.75c-.69 0-1.25-.56-1.25-1.25V3Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconSpeechBalloonSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMemoSmall = makeIcon({
  displayName: 'NoteIconMemoSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.125.1a.65.65 0 0 1 .65.65v.85h.338a2.12 2.12 0 0 1 2.833-.42l.174.13c.717.6.948 1.598.593 2.445v6.37c0 .98-.795 1.775-1.776 1.775H8.25a.65.65 0 0 1 0-1.3h1.687a.474.474 0 0 0 .475-.475V5.724l-3.676 5.332a.944.944 0 0 1-.608.392l-1.81.327a.75.75 0 0 1-.869-.587l-.368-1.793a.944.944 0 0 1 .147-.725L7.206 2.9H1.875a.475.475 0 0 0-.475.475v6.75c0 .262.213.475.475.475H2a.65.65 0 0 1 0 1.3h-.125c-.98 0-1.776-.795-1.776-1.775v-6.75C.1 2.395.895 1.6 1.875 1.6h.1V.75a.65.65 0 0 1 1.3 0v.85h.95V.75a.65.65 0 0 1 1.3 0v.85h.95V.75a.65.65 0 0 1 .65-.65Zm-2.74 9.182.229 1.12 1.137-.207L9.37 4.943l-1.36-.92-3.625 5.26Zm5.832-7.025a.822.822 0 0 0-1.136.214l-.333.482 1.36.92.312-.452a.643.643 0 0 1 .144-.335.82.82 0 0 0-.347-.83Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconMemo = makeIcon({
  displayName: 'NoteIconMemo',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.25.75a.75.75 0 1 0-1.5 0v1h-1.5v-1a.75.75 0 0 0-1.5 0v1h-1.5v-1a.75.75 0 0 0-1.5 0v1h-.5A2.25 2.25 0 0 0 0 4v9.75A2.25 2.25 0 0 0 2.25 16h.25a.75.75 0 1 0 0-1.5h-.25a.75.75 0 0 1-.75-.75V4a.75.75 0 0 1 .75-.75h7.783l-5.73 8.31c-.193.282-.264.63-.195.965l.49 2.392a1 1 0 0 0 1.158.784l2.415-.437c.33-.06.621-.248.81-.523L14 7.461v6.29a.75.75 0 0 1-.75.75H11a.75.75 0 0 0 0 1.5h2.25a2.25 2.25 0 0 0 2.25-2.25V5.5a.751.751 0 0 0-.026-.198 2.829 2.829 0 0 0-4.285-3.553h-.94v-1Zm1.666 2.411c.02-.028.04-.056.062-.083a.753.753 0 0 0 .13-.139 1.329 1.329 0 0 1 1.995 1.73l-.564.819-2.2-1.489.577-.838Zm-1.43 2.073-4.888 7.092.372 1.812 1.834-.332 4.883-7.083-2.2-1.489Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconMemoSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMegaSmall = makeIcon({
  displayName: 'NoteIconMegaSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5.1a1.4 1.4 0 0 1 1.4 1.4v7.688a1.4 1.4 0 0 1-1.4 1.4H10a1.4 1.4 0 0 1-1.343-1.004L5.65 8.832v1.293a1.776 1.776 0 0 1-3.55 0V8.52c-.037.002-.073.005-.11.005h-.5a1.4 1.4 0 0 1-1.4-1.4v-3a1.4 1.4 0 0 1 1.4-1.4h.5c.36 0 .686.136.934.359L8.734.905A1.4 1.4 0 0 1 10 .1h.5ZM3.4 10.125a.474.474 0 1 0 .95 0V8.507L3.4 8.27v1.855ZM10 1.4a.1.1 0 0 0-.1.1v7.688a.1.1 0 0 0 .1.1h.5a.1.1 0 0 0 .1-.1V1.5a.1.1 0 0 0-.1-.1H10ZM3.39 4.297v2.63L8.6 8.229V2.344L3.39 4.297Zm-1.9-.272a.1.1 0 0 0-.1.1v3a.1.1 0 0 0 .1.1h.5a.1.1 0 0 0 .1-.1v-3a.1.1 0 0 0-.1-.1h-.5Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconMega = makeIcon({
  displayName: 'NoteIconMega',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.05 12.67 7 11.578V13.5a2.25 2.25 0 0 1-4.5 0v-2.268a1.762 1.762 0 0 1-.25.018h-.5A1.75 1.75 0 0 1 0 9.5v-4c0-.966.784-1.75 1.75-1.75h.5c.433 0 .83.157 1.135.418l8.659-2.808A1.75 1.75 0 0 1 13.75 0h.5C15.216 0 16 .784 16 1.75v10.5A1.75 1.75 0 0 1 14.25 14h-.5a1.75 1.75 0 0 1-1.7-1.33ZM12 2.95 4 5.546v3.85l8 1.73V2.95Zm1.5-1.2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v10.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25V1.75Zm-8 9.504L4 10.93v2.57a.75.75 0 0 0 1.5 0v-2.246ZM1.75 5.25a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25h-.5Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconMegaSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconHammerAndWrenchSmall = makeIcon({
  displayName: 'NoteIconHammerAndWrenchSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.095.971a.75.75 0 0 1-.238.696l-.965.862c-.105.118-.133.357.055.545.194.194.442.159.556.045l.03-.029.986-.88a.75.75 0 0 1 1.201.293c.455 1.197.24 2.6-.72 3.561-.844.844-2.03 1.112-3.118.856L3.32 10.843A1.972 1.972 0 1 1 .772 7.832l4.415-3.674c-.222-1.064.054-2.21.876-3.031.96-.96 2.363-1.175 3.56-.72a.75.75 0 0 1 .472.564Zm.246 3.399c-.752.544-1.799.42-2.455-.235-.596-.596-.752-1.516-.367-2.243a1.714 1.714 0 0 0-.396.296c-.502.502-.645 1.267-.378 1.967a.75.75 0 0 1-.222.843L1.732 8.985a.472.472 0 1 0 .61.72l4.874-4.19a.75.75 0 0 1 .755-.133c.7.266 1.466.124 1.968-.379.182-.182.317-.398.402-.633Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconHammerAndWrench = makeIcon({
  displayName: 'NoteIconHammerAndWrench',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.253 1.635a.75.75 0 0 1-.238.696l-1.33 1.188c-.262.276-.284.78.073 1.138.363.363.878.335 1.151.062a.78.78 0 0 1 .03-.03l1.35-1.204a.75.75 0 0 1 1.2.293c.588 1.547.307 3.35-.922 4.579-1.116 1.115-2.702 1.45-4.142 1.064l-6.35 5.46a2.422 2.422 0 1 1-3.128-3.699l6.17-5.133c-.35-1.417-.007-2.963 1.086-4.056 1.23-1.23 3.032-1.51 4.579-.922a.75.75 0 0 1 .47.564Zm1.03 3.867-.33.294c-.915.896-2.368.809-3.255-.078-.893-.893-.976-2.358-.062-3.272l.031-.03.13-.115a2.663 2.663 0 0 0-1.534.753c-.771.772-.98 1.935-.58 2.985a.75.75 0 0 1-.222.843l-6.555 5.454a.922.922 0 1 0 1.19 1.408l6.67-5.734a.75.75 0 0 1 .755-.133c1.05.4 2.213.191 2.985-.58a2.683 2.683 0 0 0 .777-1.795Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconHammerAndWrenchSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconGearSmall = makeIcon({
  displayName: 'NoteIconGearSmall',
  viewBox: 12,
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M5.957 3.62a2.38 2.38 0 1 0 0 4.76 2.38 2.38 0 0 0 0-4.76Zm0 3.26a.88.88 0 1 1 0-1.76.88.88 0 0 1 0 1.76Z" />
        <path d="M5.458 0c-.83 0-1.513.59-1.699 1.372l-.111.47-.41-.122a1.728 1.728 0 0 0-2.012.842l-.5.909a1.84 1.84 0 0 0 .294 2.167l.358.364-.358.365a1.84 1.84 0 0 0-.294 2.167l.5.909a1.728 1.728 0 0 0 2.012.842l.41-.124.111.467C3.945 11.41 4.63 12 5.458 12h.998c.83 0 1.513-.59 1.699-1.372l.11-.467.41.124c.797.24 1.622-.13 2.013-.842l.5-.91a1.84 1.84 0 0 0-.294-2.166l-.358-.365.358-.364a1.84 1.84 0 0 0 .293-2.167l-.499-.91a1.728 1.728 0 0 0-2.013-.841l-.408.123-.112-.471C7.969.59 7.285 0 6.456 0h-.998Zm-.24 1.719c.037-.153.153-.219.24-.219h.998c.087 0 .203.066.24.219l.295 1.245a.75.75 0 0 0 .946.544l1.17-.352c.085-.025.199.005.266.128l.5.909a.34.34 0 0 1-.048.393l-.876.89a.75.75 0 0 0 0 1.052l.876.89a.34.34 0 0 1 .048.394l-.5.909c-.067.123-.18.153-.265.127l-1.172-.352a.75.75 0 0 0-.946.544l-.295 1.241c-.036.153-.152.219-.239.219h-.998c-.087 0-.203-.066-.24-.219l-.294-1.24a.75.75 0 0 0-.946-.545l-1.172.352c-.084.026-.198-.004-.265-.127l-.5-.91a.34.34 0 0 1 .048-.392l.876-.89a.75.75 0 0 0 0-1.053l-.876-.89a.34.34 0 0 1-.048-.393l.5-.91c.067-.122.18-.152.265-.127l1.171.352a.75.75 0 0 0 .946-.544l.296-1.245Z" />
      </g>
    </>
  ),
})

export const NoteIconGear = makeIcon({
  displayName: 'NoteIconGear',
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" />
        <path d="M7.31 0C6.308 0 5.473.715 5.244 1.675l-.224.945-.855-.257c-.965-.29-1.97.156-2.447 1.026l-.69 1.256a2.256 2.256 0 0 0 .359 2.654l.692.704-.692.704a2.256 2.256 0 0 0-.359 2.654l.69 1.256c.478.87 1.482 1.316 2.446 1.026l.857-.257.223.94C5.472 15.285 6.307 16 7.311 16h1.378c1.004 0 1.84-.715 2.068-1.675l.223-.94.856.258c.965.29 1.97-.155 2.447-1.026l.69-1.256a2.256 2.256 0 0 0-.359-2.654l-.692-.704.692-.704a2.256 2.256 0 0 0 .358-2.654l-.689-1.256c-.478-.87-1.482-1.316-2.447-1.026l-.854.257-.225-.945C10.529.715 9.693 0 8.689 0H7.311Zm-.607 2.022c.078-.331.346-.522.608-.522h1.378c.262 0 .53.19.608.522l.41 1.719a.75.75 0 0 0 .945.545l1.616-.487c.253-.076.546.03.7.312l.69 1.256a.756.756 0 0 1-.113.88l-1.21 1.23a.75.75 0 0 0 0 1.052l1.21 1.23c.218.222.273.589.113.88l-.69 1.256c-.154.282-.447.388-.7.312l-1.618-.487a.75.75 0 0 0-.945.545l-.408 1.713c-.078.331-.346.522-.608.522H7.311c-.262 0-.53-.19-.608-.522l-.408-1.713a.75.75 0 0 0-.945-.545l-1.619.487c-.252.076-.545-.03-.7-.312l-.689-1.256a.756.756 0 0 1 .113-.88l1.21-1.23a.75.75 0 0 0 0-1.052l-1.21-1.23a.756.756 0 0 1-.113-.88l.69-1.256c.154-.281.447-.388.7-.312l1.616.487a.75.75 0 0 0 .946-.545l.409-1.72Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconGearSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconFileFolderSmall = makeIcon({
  displayName: 'NoteIconFileFolderSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.75a1.5 1.5 0 0 1 1.5-1.5h2.667a1.5 1.5 0 0 1 1.218.625l.276.383h4.464c1.036 0 1.875.84 1.875 1.875v5.142c0 1.035-.84 1.875-1.875 1.875h-8.47v-.013A1.875 1.875 0 0 1 0 9.275V2.75Zm1.875 6.9h.103a.375.375 0 0 0 .375-.375v-2.65c0-1.036.84-1.875 1.875-1.875H10.5v-.617a.375.375 0 0 0-.375-.375h-4.85a.75.75 0 0 1-.608-.312l-.5-.696H1.5v6.525c0 .207.168.375.375.375Zm8.625-3.4H4.228a.375.375 0 0 0-.375.375v2.65c0 .128-.012.254-.037.375h6.309a.375.375 0 0 0 .375-.375V6.25Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconFileFolder = makeIcon({
  displayName: 'NoteIconFileFolder',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 2.25a.25.25 0 0 0-.25.25v10c0 .414.336.75.75.75h.25a.75.75 0 0 0 .75-.75v-5A2.25 2.25 0 0 1 5.5 5.25h9V4.5a.75.75 0 0 0-.75-.75H7a.75.75 0 0 1-.624-.334l-.703-1.055a.25.25 0 0 0-.208-.111H1.75Zm12.75 4.5h-9a.75.75 0 0 0-.75.75v5c0 .263-.045.515-.128.75h9.128a.75.75 0 0 0 .75-.75V6.75Zm-12.5 8v-.014A2.25 2.25 0 0 1 0 12.5v-10C0 1.534.784.75 1.75.75h3.715a1.75 1.75 0 0 1 1.456.78l.48.72h6.349A2.25 2.25 0 0 1 16 4.5v8a2.25 2.25 0 0 1-2.25 2.25H2Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconFileFolderSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconArtSmall = makeIcon({
  displayName: 'NoteIconArtSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M4.67 4.243a.785.785 0 1 0 0-1.57.785.785 0 0 0 0 1.57ZM8.138 3.335a.785.785 0 1 1-1.571 0 .785.785 0 0 1 1.57 0ZM8.898 6.353a.785.785 0 1 0 0-1.57.785.785 0 0 0 0 1.57ZM3.045 6.353a.785.785 0 1 0 0-1.57.785.785 0 0 0 0 1.57Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.805.054C2.837-.059-.215 2.377.012 5.9c.19 2.967 2.047 4.78 3.607 5.731.674.41 1.49.247 2.001-.249.477-.463.61-1.176.33-1.78l-.558-1.207a.376.376 0 0 1 .06-.407.094.094 0 0 1 .158.028l.398.99c.523 1.3 2.074 1.927 3.346 1.218.194-.108.387-.22.52-.312.31-.216.83-.723 1.273-1.446A5.616 5.616 0 0 0 12 5.526c0-1.573-.652-2.928-1.777-3.896C9.11.671 7.569.122 5.805.054Zm-4.296 5.75c-.162-2.508 2.026-4.335 4.239-4.25 1.493.056 2.689.517 3.497 1.213.799.687 1.255 1.63 1.255 2.758 0 .862-.287 1.596-.631 2.156-.352.573-.734.918-.85.997a5.753 5.753 0 0 1-.396.236c-.435.242-1.017.046-1.223-.467L7 7.456a1.594 1.594 0 0 0-2.672-.463 1.876 1.876 0 0 0-.299 2.032l.559 1.208a.064.064 0 0 1-.014.073.2.2 0 0 1-.107.056.099.099 0 0 1-.07-.012c-1.311-.8-2.74-2.237-2.89-4.546Z"
        />
      </g>
    </>
  ),
})

export const NoteIconArt = makeIcon({
  displayName: 'NoteIconArt',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M6.094 5.405a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM11.062 4.105a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM12.151 8.429a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM3.767 8.428a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.723-.005C3.813-.155-.194 3.057.103 7.679c.254 3.928 2.708 6.333 4.79 7.602.803.488 1.781.298 2.399-.302.567-.55.724-1.4.393-2.117l-.763-1.647a.786.786 0 0 1 .126-.851.402.402 0 0 1 .673.116l.544 1.352c.655 1.63 2.595 2.406 4.177 1.524.265-.148.518-.295.686-.412.39-.269 1.073-.932 1.66-1.89.597-.97 1.124-2.29 1.124-3.869 0-2.064-.854-3.838-2.328-5.107C12.119.818 10.079.085 7.724-.005ZM1.601 7.582c-.232-3.606 2.91-6.209 6.065-6.088 2.087.08 3.78.724 4.94 1.721 1.148.989 1.806 2.35 1.806 3.97 0 1.238-.413 2.289-.901 3.084-.497.809-1.043 1.309-1.236 1.442-.102.07-.298.187-.563.335-.746.416-1.716.07-2.056-.774L9.113 9.92a1.902 1.902 0 0 0-3.188-.552 2.286 2.286 0 0 0-.364 2.477l.762 1.647a.361.361 0 0 1-.076.41c-.184.18-.42.19-.573.098-1.835-1.118-3.863-3.148-4.073-6.418Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconArtSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconSparklesSmall = makeIcon({
  displayName: 'NoteIconSparklesSmall',
  viewBox: 12,
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M4.125.1a.65.65 0 0 1 .62.455L5.754 3.76a1.6 1.6 0 0 0 .82.956l1.212.595a.651.651 0 0 1-.01 1.172l-1.16.541a1.601 1.601 0 0 0-.857.996l-1.01 3.414a.65.65 0 0 1-1.247 0L2.492 8.02a1.601 1.601 0 0 0-.857-.996l-1.16-.54a.651.651 0 0 1-.011-1.173l1.212-.595a1.6 1.6 0 0 0 .82-.956L3.505.555l.04-.097A.65.65 0 0 1 4.125.1Zm-.389 4.05A2.9 2.9 0 0 1 2.25 5.88c.72.36 1.259 1 1.487 1.772l.388 1.309.388-1.309a2.9 2.9 0 0 1 1.486-1.771 2.9 2.9 0 0 1-1.485-1.73l-.389-1.236-.389 1.235ZM9.438 6.475a.65.65 0 0 1 .606.417l.262.68c.168.437.536.768.989.89a.65.65 0 0 1 .14 1.2l-.347.187c-.319.172-.57.447-.712.78l-.34.8a.65.65 0 0 1-1.196 0l-.34-.8a1.601 1.601 0 0 0-.713-.78L7.44 9.66a.65.65 0 0 1 .14-1.2c.453-.121.82-.452.99-.89l.261-.68.043-.09a.65.65 0 0 1 .564-.326Zm0 2.194a2.77 2.77 0 0 1-.431.47c.162.152.307.322.43.507a2.9 2.9 0 0 1 .43-.507 2.77 2.77 0 0 1-.43-.47ZM9.438.1a.65.65 0 0 1 .606.417l.262.68c.168.437.536.768.989.89a.65.65 0 0 1 .14 1.2l-.347.187c-.319.172-.57.447-.712.78l-.34.8a.65.65 0 0 1-1.196 0l-.34-.8a1.601 1.601 0 0 0-.713-.78l-.347-.188a.65.65 0 0 1 .14-1.2c.453-.121.82-.452.99-.89l.261-.68.043-.09A.65.65 0 0 1 9.438.1Zm0 2.194a2.77 2.77 0 0 1-.431.47c.162.152.307.322.43.507a2.9 2.9 0 0 1 .43-.507 2.77 2.77 0 0 1-.43-.47Z" />
      </g>
    </>
  ),
})

export const NoteIconSparkles = makeIcon({
  displayName: 'NoteIconSparkles',
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.965.775a.75.75 0 0 0-1.43 0L3.19 5.049a2.25 2.25 0 0 1-1.155 1.344L.42 7.187A.75.75 0 0 0 .432 8.54l1.546.722a2.25 2.25 0 0 1 1.205 1.4l1.348 4.55a.75.75 0 0 0 1.438 0l1.348-4.55a2.25 2.25 0 0 1 1.204-1.4l1.546-.722a.75.75 0 0 0 .014-1.353l-1.616-.794A2.25 2.25 0 0 1 7.31 5.05L5.965.775ZM4.62 5.499l.63-2 .63 2a3.75 3.75 0 0 0 1.923 2.24l.211.104-.128.06a3.75 3.75 0 0 0-2.008 2.333l-.628 2.122-.628-2.122a3.75 3.75 0 0 0-2.008-2.333l-.128-.06.21-.103A3.75 3.75 0 0 0 4.62 5.5Z"
        />
        <path d="M13 .25c.31 0 .588.19.7.48l.35.907a2.078 2.078 0 0 0 1.396 1.258.747.747 0 0 1 .517.957.747.747 0 0 1-.356.427L13 .25Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m13 .25 2.605 4.03-.46.249c-.448.242-.8.629-1 1.097l-.455 1.068a.75.75 0 0 1-1.38 0l-.455-1.068a2.25 2.25 0 0 0-1-1.097l-.462-.25a.75.75 0 0 1 .161-1.384 2.078 2.078 0 0 0 1.397-1.258L12.3.73A.75.75 0 0 1 13 .25Zm.75 3.431a3.578 3.578 0 0 1-.75-.824c-.206.314-.46.591-.75.824.294.257.548.56.75.896a3.75 3.75 0 0 1 .75-.896Z"
        />
        <path d="M13 8.75c.31 0 .588.19.7.48l.35.907a2.078 2.078 0 0 0 1.396 1.258.747.747 0 0 1 .517.957.747.747 0 0 1-.356.427L13 8.75Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m13 8.75 2.605 4.03-.46.249c-.448.242-.8.629-1 1.097l-.455 1.068a.75.75 0 0 1-1.38 0l-.455-1.068a2.25 2.25 0 0 0-1-1.097l-.462-.25a.75.75 0 0 1 .161-1.384 2.078 2.078 0 0 0 1.397-1.258l.35-.907A.75.75 0 0 1 13 8.75Zm.75 3.431a3.58 3.58 0 0 1-.75-.824 3.58 3.58 0 0 1-.75.824c.294.257.548.56.75.896a3.75 3.75 0 0 1 .75-.896Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconSparklesSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconZapSmall = makeIcon({
  displayName: 'NoteIconZapSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.416.074a.75.75 0 0 1 .41.82l-.629 3.204 2.903.39a.75.75 0 0 1 .473 1.227l-5.091 6.02a.75.75 0 0 1-1.31-.626l.63-3.297-2.879-.297a.75.75 0 0 1-.496-1.23L6.518.265a.75.75 0 0 1 .898-.19ZM3.49 6.17l2.28.234a.75.75 0 0 1 .659.887l-.247 1.294 2.361-2.792-2.335-.313a.75.75 0 0 1-.636-.888l.226-1.15L3.49 6.168Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconZap = makeIcon({
  displayName: 'NoteIconZap',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.136.094a.75.75 0 0 1 .367.828l-1.081 4.6 5.167.618a.75.75 0 0 1 .444 1.272l-8.272 8.365a.75.75 0 0 1-1.265-.694l1.082-4.748-5.147-.473a.75.75 0 0 1-.464-1.274L9.239.223a.75.75 0 0 1 .897-.13ZM3.15 8.514l4.419.406a.75.75 0 0 1 .662.913l-.688 3.02 5.346-5.406-4.478-.536a.75.75 0 0 1-.641-.916l.663-2.824L3.15 8.514Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconZapSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconHandshakeSmall = makeIcon({
  displayName: 'NoteIconHandshakeSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.88 8.465a1.453 1.453 0 0 1-1.608 2.13 1.378 1.378 0 0 1-1.56.523 1.41 1.41 0 0 1-1.584.438c-.572.585-1.64.66-2.204-.199a238.233 238.233 0 0 1-1.842-2.825 10.732 10.732 0 0 1-.785-1.47 3.895 3.895 0 0 1 2.932-5.304l.086-.122A3.579 3.579 0 0 1 7.808.499l1.68.824c.435.214.84.486 1.202.81a3.768 3.768 0 0 1-.021 5.637l-.79.695ZM9.144 7.38l.665-.585a2.468 2.468 0 0 0 .013-3.693 4.026 4.026 0 0 0-.909-.612l-1.679-.824a2.279 2.279 0 0 0-2.86.724l-.756 1.06a.367.367 0 0 0 .575.454l.896-1.026a.655.655 0 0 1 .03-.032l.37-.368a.65.65 0 0 1 .93.907L9.145 7.38ZM5.516 4.367l-.343.393a1.667 1.667 0 0 1-2.92-1.169 2.594 2.594 0 0 0-.759 2.966c.076.178.285.638.69 1.286.242.386 1.015 1.567 1.826 2.8.016.024.029.035.036.04a.06.06 0 0 0 .02.01.123.123 0 0 0 .075-.009.124.124 0 0 0 .06-.048.068.068 0 0 0 .003-.006l-.623-1.02a.65.65 0 0 1 1.109-.677l.83 1.356a.111.111 0 1 0 .189-.117l-.117-.189-.8-1.255A.65.65 0 0 1 5.89 8.03l.797 1.25.387.571a.08.08 0 1 0 .132-.09l-1.02-1.485-.15-.23a.65.65 0 0 1 1.086-.714l.144.22 1.227 1.72a.153.153 0 0 0 .25-.174L5.517 4.367Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconHandshake = makeIcon({
  displayName: 'NoteIconHandshake',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.093 11.076a1.788 1.788 0 0 1-2.024 2.71 1.688 1.688 0 0 1-2.1.703 1.73 1.73 0 0 1-2.133.594c-.676.799-2.064.942-2.785-.153a324.3 324.3 0 0 1-2.493-3.825C.96 10.148.638 9.45.506 9.137a4.312 4.312 0 0 1-.13-.36c-.96-2.984.976-6.1 4.041-6.592l.161-.226A4.67 4.67 0 0 1 10.44.475l2.276 1.117c.576.283 1.11.643 1.589 1.07a4.925 4.925 0 0 1-.028 7.37l-1.184 1.044Zm-.796-1.166 1.055-.929a3.525 3.525 0 0 0 .02-5.275 5.636 5.636 0 0 0-1.273-.857L9.823 1.732A3.27 3.27 0 0 0 5.719 2.77L4.695 4.208a.678.678 0 0 0 1.063.84l1.215-1.391a.698.698 0 0 1 .032-.035l.5-.5a.7.7 0 0 1 .99.99l-.09.09 3.892 5.708ZM7.432 5.26l-.62.708A2.078 2.078 0 0 1 3.23 4.105a3.7 3.7 0 0 0-1.433 4.488c.106.25.394.882.949 1.77.328.525 1.378 2.128 2.476 3.797.062.095.128.13.18.144.063.016.14.012.219-.02a.346.346 0 0 0 .168-.142.272.272 0 0 0 .035-.138l-.878-1.436a.7.7 0 1 1 1.194-.73l1.124 1.837a.332.332 0 1 0 .565-.347l-.159-.257-1.083-1.702a.7.7 0 0 1 1.18-.752l1.081 1.697.528.776a.29.29 0 1 0 .477-.327L8.476 10.76l-.21-.318a.7.7 0 1 1 1.171-.768l.198.3L11.3 12.31a.388.388 0 0 0 .636-.444L7.432 5.259Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconHandshakeSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconWorldMapSmall = makeIcon({
  displayName: 'NoteIconWorldMapSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M8.625 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.875 0c-1.675 0-3 1.387-3 3.058 0 .833.353 1.645.737 2.295.392.664.868 1.244 1.216 1.633.563.629 1.53.629 2.094 0 .348-.389.824-.969 1.216-1.633.384-.65.737-1.462.737-2.295 0-1.671-1.325-3.058-3-3.058Zm-1.5 3.058c0-.879.69-1.558 1.5-1.558s1.5.68 1.5 1.558c0 .437-.197.97-.529 1.532-.3.507-.67.972-.971 1.316a8.989 8.989 0 0 1-.971-1.316c-.332-.562-.529-1.095-.529-1.532Z"
        />
        <path d="M3.558 2.69a.75.75 0 0 0-.366-1.454l-2.059.519A1.5 1.5 0 0 0 0 3.209v6.877a1.5 1.5 0 0 0 2.12 1.366l1.961-.89 3.297 1.274a1.5 1.5 0 0 0 1.16-.033l2.582-1.17A1.5 1.5 0 0 0 12 9.265V7a.75.75 0 0 0-1.5 0v2.266l-2.581 1.17-3.297-1.272a1.5 1.5 0 0 0-1.16.033l-1.962.89V3.208l2.058-.519Z" />
        <path d="M3.594 5.254a.7.7 0 1 0-1.188.742c.073.116.147.229.222.338a.7.7 0 0 0 1.153-.795 7.494 7.494 0 0 1-.187-.285ZM5.036 6.897a.7.7 0 0 0-.87 1.098c.23.181.458.338.68.474a.7.7 0 1 0 .728-1.197 5.312 5.312 0 0 1-.538-.375ZM7.237 7.899a.7.7 0 0 0-.211 1.383 4.092 4.092 0 0 0 .425.043h.03l.011.001H7.5v-.7.7a.7.7 0 0 0 .005-1.4H7.5l-.047-.003a2.697 2.697 0 0 1-.215-.024Z" />
      </g>
    </>
  ),
})

export const NoteIconWorldMap = makeIcon({
  displayName: 'NoteIconWorldMap',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M10.5 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.75 3.827C6.75 1.73 8.411 0 10.5 0s3.75 1.731 3.75 3.827c0 1.034-.436 2.081-.931 2.952-.504.886-1.118 1.676-1.577 2.216a1.62 1.62 0 0 1-2.484 0c-.459-.54-1.073-1.33-1.577-2.216-.495-.87-.931-1.918-.931-2.952ZM10.5 1.5c-1.225 0-2.25 1.024-2.25 2.327 0 .647.286 1.42.735 2.21.44.775.99 1.486 1.416 1.988.034.04.07.05.099.05.029 0 .065-.01.099-.05a13.48 13.48 0 0 0 1.416-1.987c.449-.79.735-1.564.735-2.211 0-1.303-1.025-2.327-2.25-2.327Z"
        />
        <path d="M5.23 2.446a.75.75 0 0 1-.558.901l-2.98.701a.25.25 0 0 0-.192.244v9.19c0 .18.184.3.349.23l2.891-1.24a1.75 1.75 0 0 1 1.321-.025l4.418 1.706a.25.25 0 0 0 .189-.003l3.68-1.58a.25.25 0 0 0 .152-.23V7.5a.75.75 0 0 1 1.5 0v4.84c0 .7-.417 1.333-1.06 1.609l-3.68 1.58a1.75 1.75 0 0 1-1.321.024L5.52 13.845a.25.25 0 0 0-.189.004L2.44 15.09A1.75 1.75 0 0 1 0 13.483v-9.19a1.75 1.75 0 0 1 1.35-1.704l2.978-.7a.75.75 0 0 1 .902.558Z" />
        <path d="M3.603 6.864a.75.75 0 0 1 1.033.239c.084.133.168.262.254.386a.75.75 0 1 1-1.235.852c-.098-.143-.195-.29-.291-.443a.75.75 0 0 1 .239-1.034ZM5.547 9.463A.75.75 0 0 1 6.6 9.34c.25.198.497.367.737.513a.75.75 0 1 1-.78 1.282 8.743 8.743 0 0 1-.887-.618.75.75 0 0 1-.123-1.054ZM9.627 10.7a.75.75 0 1 0-.197 1.488c.378.05.739.073 1.08.076a.75.75 0 1 0 .012-1.5 7.278 7.278 0 0 1-.895-.063Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconWorldMapSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconWaveSmall = makeIcon({
  displayName: 'NoteIconWaveSmall',
  viewBox: 12,
  content: (
    <>
      <path
        d="M6.58 1.977A.65.65 0 1 0 7.6 1.17 3.052 3.052 0 0 0 5.455.02a.65.65 0 1 0-.108 1.296c.47.039.92.264 1.234.66Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.032 3.52a1.34 1.34 0 0 1 2.13-1.559 1.449 1.449 0 0 1 2.147-.085L7.692 4.31c.045-.295.09-.622.134-.956.18-1.356 1.917-1.88 2.79-.788.175.22.27.492.27.773v4.218c0 .831-.193 1.65-.564 2.394a3.543 3.543 0 0 1-4.129 1.826l-.196-.055a5.505 5.505 0 0 1-2.006-1.048l-.546-.45-2.63-2.63C.187 6.967.342 6.097.862 5.615a1.374 1.374 0 0 1 .17-2.094Zm1.455 1.973 1.81 1.698a.6.6 0 0 1-.82.875L1.764 6.461a.113.113 0 0 0-.036.006.18.18 0 0 0-.086.072.18.18 0 0 0-.032.106c.001.022.008.056.053.1l2.589 2.59.502.412c.46.379.994.658 1.568.82l.196.055a2.343 2.343 0 0 0 2.73-1.208 4.153 4.153 0 0 0 .439-1.857V3.339a.038.038 0 0 0-.008-.024c-.194-.242-.619-.141-.663.196-.112.85-.246 1.759-.365 2.2a.6.6 0 0 1-1.008.264l-3.191-3.26a.248.248 0 0 0-.388.042.079.079 0 0 0 .011.098l1.513 1.48.796.797a.6.6 0 1 1-.848.848l-.79-.79-2.4-2.347V2.84l-.014-.013a.14.14 0 1 0-.194.2l.806.775 2.384 2.384a.6.6 0 1 1-.848.849l-2.37-2.37-.161-.153a.173.173 0 1 0-.238.253l.755.708a.598.598 0 0 1 .02.02Z"
        fill="currentcolor"
      />
      <path
        d="M.811 8.765a.65.65 0 0 1 .811.433c.157.516.557.89 1.04 1.035a.65.65 0 1 1-.375 1.245A2.849 2.849 0 0 1 .378 9.576a.65.65 0 0 1 .433-.81Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconWave = makeIcon({
  displayName: 'NoteIconWave',
  content: (
    <>
      <path
        d="M10.464 3.132a.7.7 0 0 0 1.098-.87A4.67 4.67 0 0 0 7.507.508a.7.7 0 0 0 .116 1.395 3.27 3.27 0 0 1 2.841 1.23Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79 7.75c-.668.578-.885 1.668-.104 2.449l3.307 3.307.686.564a6.872 6.872 0 0 0 2.504 1.308l.246.07a4.402 4.402 0 0 0 5.13-2.27 6.68 6.68 0 0 0 .706-2.987V4.885c0-.342-.116-.673-.33-.939-1.067-1.334-3.193-.695-3.412.965-.06.461-.124.912-.185 1.312l-3.075-3.14a1.768 1.768 0 0 0-2.658.15l-.014-.014-.002-.002-.018-.018A1.63 1.63 0 0 0 2.992 5.13a1.673 1.673 0 0 0-.212 2.61l.01.009Zm1.526-1.235 2.982 2.982a.7.7 0 1 0 .99-.99L5.294 5.513l-1.02-.98a.23.23 0 1 1 .32-.33l.018.016.001.002 3.02 2.954.993.994a.7.7 0 1 0 .99-.99L8.614 6.177 6.711 4.315a.154.154 0 0 1-.022-.192.367.367 0 0 1 .574-.062l4.014 4.102a.7.7 0 0 0 1.177-.308c.148-.551.316-1.691.457-2.761.062-.471.656-.617.931-.273.015.018.023.04.023.064v5.306c0 .82-.191 1.628-.558 2.362A3.002 3.002 0 0 1 9.81 14.1l-.247-.07a5.473 5.473 0 0 1-1.993-1.041l-.634-.521-3.259-3.26c-.065-.065-.08-.12-.083-.16a.28.28 0 0 1 .05-.168.28.28 0 0 1 .135-.111.202.202 0 0 1 .087-.011l2.17 2.034a.7.7 0 0 0 .957-1.021L4.713 7.634a.699.699 0 0 0-.024-.022l-.951-.892a.273.273 0 1 1 .374-.398l.204.193Z"
        fill="currentcolor"
      />
      <path
        d="M1.797 11.496a.7.7 0 0 1 .873.466 3.27 3.27 0 0 0 2.193 2.185.7.7 0 0 1-.402 1.341 4.67 4.67 0 0 1-3.13-3.119.7.7 0 0 1 .466-.873Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconWaveSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconStudioMicrophoneSmall = makeIcon({
  displayName: 'NoteIconStudioMicrophoneSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 .05A2.95 2.95 0 0 0 3.05 3v2.25a2.95 2.95 0 0 0 5.9 0V3A2.95 2.95 0 0 0 6 .05Zm1.55 5.2a1.55 1.55 0 0 1-3.013.512h.9a.7.7 0 1 0 0-1.4H4.45V3.95h.988a.7.7 0 1 0 0-1.4h-.922A1.55 1.55 0 0 1 7.55 3v2.25Z"
        />
        <path d="M6.7 10.214a5.014 5.014 0 0 0 4.312-4.964v-.188a.7.7 0 0 0-1.4 0v.188a3.612 3.612 0 1 1-7.224 0v-.188a.7.7 0 0 0-1.4 0v.188A5.014 5.014 0 0 0 5.3 10.214v.336h-.8a.7.7 0 1 0 0 1.4h3a.7.7 0 1 0 0-1.4h-.8v-.336Z" />
      </g>
    </>
  ),
})

export const NoteIconStudioMicrophone = makeIcon({
  displayName: 'NoteIconStudioMicrophone',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0a3.75 3.75 0 0 0-3.75 3.75V7a3.75 3.75 0 1 0 7.5 0V3.75A3.75 3.75 0 0 0 8 0Zm2.25 7a2.25 2.25 0 0 1-4.444.5H7.25a.75.75 0 0 0 0-1.5h-1.5V5h1.5a.75.75 0 0 0 0-1.5H5.764a2.25 2.25 0 0 1 4.486.25V7Z"
        fill="currentcolor"
      />
      <path
        d="M8.75 13.457A6.501 6.501 0 0 0 14.5 7v-.25a.75.75 0 0 0-1.5 0V7A5 5 0 0 1 3 7v-.25a.75.75 0 0 0-1.5 0V7a6.501 6.501 0 0 0 5.75 6.457V14.5H6A.75.75 0 0 0 6 16h4a.75.75 0 0 0 0-1.5H8.75v-1.043Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconStudioMicrophoneSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconFireSmall = makeIcon({
  displayName: 'NoteIconFireSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.323 5.056a.7.7 0 0 0-.56.174 3.52 3.52 0 0 0-.884 1.237 2.1 2.1 0 0 1-.125-.086.7.7 0 0 0-1.082.344A2.454 2.454 0 0 0 6 9.95a2.454 2.454 0 0 0 2.45-2.458 2.455 2.455 0 0 0-2.127-2.436ZM6 8.55c-.362 0-.683-.185-.872-.468l.038.01a.7.7 0 0 0 .859-.574c.056-.366.206-.702.425-.982.354.17.6.533.6.956C7.05 8.08 6.577 8.55 6 8.55Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.768.364A.7.7 0 0 0 5.714.232c-.873.792-1.506 1.883-1.784 3.122a3.972 3.972 0 0 1-.374-.5.7.7 0 0 0-1.125-.077C1.6 3.757 1.1 5.073 1.1 6.507c0 2.924 2.116 5.443 4.9 5.443 2.784 0 4.9-2.52 4.9-5.443 0-1.771-.94-3.059-1.706-3.816-.298-.294-.621-.562-.917-.807l-.11-.091a9.218 9.218 0 0 1-.892-.817 5.595 5.595 0 0 1-.507-.612ZM5.173 4.707c.016-1.116.387-2.122.976-2.888l.096.106c.33.357.692.665 1.027.944l.11.091c.301.25.576.479.828.728.63.621 1.29 1.572 1.29 2.82 0 2.314-1.645 4.042-3.5 4.042-1.856 0-3.5-1.728-3.5-4.043 0-.77.186-1.484.505-2.09.33.348.706.648 1.118.886a.7.7 0 0 0 1.05-.596Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconFire = makeIcon({
  displayName: 'NoteIconFire',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.368.006a.75.75 0 0 1 .517.31c.18.25.512.61.89.984.367.365.781.694 1.231 1.04l.205.156c.382.293.789.604 1.171.94C13.52 4.436 15 6.211 15 8.701 15 12.699 11.899 16 8 16s-7-3.301-7-7.3c0-1.945.731-3.72 1.93-5.032a.75.75 0 0 1 1.172.083c.287.419.624.795 1.003 1.12A7.958 7.958 0 0 1 7.79.176a.75.75 0 0 1 .577-.171Zm-.156 1.837a6.546 6.546 0 0 0-1.734 4.37.75.75 0 0 1-1.104.65 7.053 7.053 0 0 1-1.887-1.477A5.988 5.988 0 0 0 2.5 8.7C2.5 11.937 4.995 14.5 8 14.5s5.5-2.563 5.5-5.8c0-1.86-1.109-3.258-2.108-4.138-.34-.299-.7-.574-1.084-.867l-.216-.166c-.454-.349-.933-.727-1.374-1.164a16.735 16.735 0 0 1-.506-.522Zm-.35 4.551a.75.75 0 0 1 .616-.196c1.784.246 3.113 1.83 3.113 3.694 0 2.025-1.575 3.727-3.591 3.727s-3.59-1.702-3.59-3.727c0-.402.06-.79.175-1.155a.75.75 0 0 1 1.175-.369c.194.15.401.281.62.39.29-.917.806-1.729 1.481-2.364Zm.759 1.371a4.093 4.093 0 0 0-.962 2.1.75.75 0 0 1-.928.617 5.11 5.11 0 0 1-.802-.278C6.073 11.311 6.972 12.12 8 12.12c1.122 0 2.09-.964 2.09-2.227 0-1.02-.635-1.85-1.47-2.127Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconFireSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconChartSmall = makeIcon({
  displayName: 'NoteIconChartSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M1.5.75a.75.75 0 0 0-1.5 0V9a3 3 0 0 0 3 3h7.75a.75.75 0 0 0 0-1.5H3A1.5 1.5 0 0 1 1.5 9V.75Z" />
        <path d="M11.448 1.333a.75.75 0 0 0-.94-.554l-2.31.667a.75.75 0 0 0 .415 1.441l.487-.14L7.15 6.02 5.87 4.93a.75.75 0 0 0-1.098.135l-2.133 3a.75.75 0 0 0 1.222.87L5.52 6.602l1.332 1.135a.75.75 0 0 0 1.131-.186l2.42-4.06.116.51a.75.75 0 1 0 1.462-.335l-.533-2.333Z" />
      </g>
    </>
  ),
})

export const NoteIconChart = makeIcon({
  displayName: 'NoteIconChart',
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M.75 0a.75.75 0 0 1 .75.75V12a2.25 2.25 0 0 0 2.25 2.25h11.5a.75.75 0 0 1 0 1.5H3.75A3.75 3.75 0 0 1 0 12V.75A.75.75 0 0 1 .75 0Z" />
        <path d="M14.88.353a.75.75 0 0 1 .353.49l.75 3.5a.75.75 0 0 1-1.466.314l-.333-1.554-3.78 6.763a.75.75 0 0 1-1.159.189L7.141 8.141l-2.517 3.775a.75.75 0 1 1-1.248-.832l3-4.5a.75.75 0 0 1 1.128-.139L9.556 8.31l3.377-6.043-1.462.45a.75.75 0 0 1-.442-1.434l3.25-1a.75.75 0 0 1 .6.07Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconChartSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconSpiralNotePadSmall = makeIcon({
  displayName: 'NoteIconSpiralNotePadSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75.75a.75.75 0 0 0-1.5 0v.5h-.375C.839 1.25 0 2.09 0 3.125v6.983c0 1.035.84 1.875 1.875 1.875h5.573a.75.75 0 0 0 .53-.22l3.802-3.802a.75.75 0 0 0 .22-.53V3.125c0-1.036-.84-1.875-1.875-1.875H9.75v-.5a.75.75 0 0 0-1.5 0v.5h-1.5v-.5a.75.75 0 0 0-1.5 0v.5h-1.5v-.5Zm4.5 2h-1.5v.063a.75.75 0 0 1-1.5 0V2.75h-1.5v.063a.75.75 0 0 1-1.5 0V2.75h-.375a.375.375 0 0 0-.375.375v6.983c0 .207.168.375.375.375h4.823V8.18a1.5 1.5 0 0 1 1.5-1.5H10.5V3.125a.375.375 0 0 0-.375-.375H9.75v.063a.75.75 0 0 1-1.5 0V2.75Zm-.052 5.431H9.44L8.2 9.422V8.181Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconSpiralNotePad = makeIcon({
  displayName: 'NoteIconSpiralNotePad',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 0a.75.75 0 0 1 .75.75v1h1.5v-1a.75.75 0 0 1 1.5 0v1h1.5v-1a.75.75 0 0 1 1.5 0v1h1.5v-1a.75.75 0 0 1 1.5 0v1h.5A2.25 2.25 0 0 1 16 4v6a.75.75 0 0 1-.22.53l-5.25 5.25A.75.75 0 0 1 10 16H2.25A2.25 2.25 0 0 1 0 13.75V4a2.25 2.25 0 0 1 2.25-2.25h.5v-1A.75.75 0 0 1 3.5 0Zm8.25 3.25v.25a.75.75 0 0 0 1.5 0v-.25h.5a.75.75 0 0 1 .75.75v5.25H11A1.75 1.75 0 0 0 9.25 11v3.5h-7a.75.75 0 0 1-.75-.75V4a.75.75 0 0 1 .75-.75h.5v.25a.75.75 0 0 0 1.5 0v-.25h1.5v.25a.75.75 0 0 0 1.5 0v-.25h1.5v.25a.75.75 0 0 0 1.5 0v-.25h1.5Zm1.69 7.5H11a.25.25 0 0 0-.25.25v2.44l2.69-2.69Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconSpiralNotePadSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMoneybagSmall = makeIcon({
  displayName: 'NoteIconMoneybagSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m6.542 9.15-.07.31-.072.259a.475.475 0 0 1-.356.144.486.486 0 0 1-.493-.498v-.169a2.508 2.508 0 0 1-.391-.076 3.408 3.408 0 0 1-.457-.16.523.523 0 0 1-.258-.24l-.002-.003a.6.6 0 0 1-.053-.304v-.005a.604.604 0 0 1 .115-.284.47.47 0 0 1 .258-.179.533.533 0 0 1 .368.038l.01.004c.062.035.162.075.306.118.138.037.312.056.526.056.149 0 .256-.014.328-.038h.001c.082-.027.121-.056.138-.078a.15.15 0 0 0 .037-.096c0-.034-.008-.054-.02-.068l-.007-.01a.194.194 0 0 0-.084-.063l-.005-.002a.995.995 0 0 0-.23-.078l-.624-.132c-.354-.08-.633-.217-.823-.419l-.001-.001c-.187-.208-.277-.473-.277-.786 0-.24.058-.457.176-.649.121-.193.288-.35.498-.468.143-.08.3-.14.472-.179v-.208a.486.486 0 0 1 .492-.498.486.486 0 0 1 .498.498v.181c.066.012.134.027.203.046.169.042.32.102.45.182a.48.48 0 0 1 .224.233.524.524 0 0 1 .048.296s-.01.135-.112.267a.465.465 0 0 1-.258.165l-.003.001a.597.597 0 0 1-.36-.05h-.002a1.349 1.349 0 0 0-.264-.082h-.005a1.572 1.572 0 0 0-.37-.036c-.182 0-.307.033-.388.086-.076.052-.105.109-.105.176 0 .038.013.07.047.1a.862.862 0 0 0 .29.105l.627.137c.236.052.438.128.602.231.086.055.163.117.227.188.192.2.284.459.284.765 0 .24-.058.455-.177.644-.117.186-.28.337-.486.451a1.771 1.771 0 0 1-.458.179h-.014Z"
        fill="currentcolor"
      />
      <path
        d="m6.542 9.15-.07.31-.072.259a.486.486 0 0 0 .142-.354V9.15Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.166 0a1.5 1.5 0 0 0-1.423 1.974l.237.713a4.876 4.876 0 0 0-2.855 4.438V10.5a1.5 1.5 0 0 0 1.5 1.5h6.75a1.5 1.5 0 0 0 1.5-1.5V7.125c0-1.972-1.17-3.67-2.855-4.438l.237-.713A1.5 1.5 0 0 0 6.834 0H5.166Zm1.407 2.283.261-.783H5.166l.26.783a4.928 4.928 0 0 1 1.147 0ZM6 3.75a3.375 3.375 0 0 0-3.375 3.375V10.5h6.75V7.125A3.375 3.375 0 0 0 6 3.75Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconMoneybag = makeIcon({
  displayName: 'NoteIconMoneybag',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.06 13.65a.648.648 0 0 0 .664-.664v-.28c.229-.055.439-.135.628-.243.274-.153.492-.353.648-.602.159-.251.236-.54.236-.858 0-.409-.123-.754-.378-1.021-.249-.27-.624-.452-1.106-.558l-.836-.184c-.208-.047-.329-.096-.386-.138a.17.17 0 0 1-.063-.134c0-.09.038-.166.14-.235.107-.07.274-.114.518-.114.21 0 .372.017.493.047h.006c.133.029.25.065.352.11h.002c.167.07.33.1.48.067l.005-.002a.62.62 0 0 0 .344-.22.656.656 0 0 0 .15-.355.698.698 0 0 0-.064-.395.639.639 0 0 0-.298-.312 2.191 2.191 0 0 0-.602-.242 3.16 3.16 0 0 0-.27-.061v-.242a.648.648 0 0 0-.664-.664.648.648 0 0 0-.657.664v.278a2.403 2.403 0 0 0-.628.238 1.83 1.83 0 0 0-.664.625 1.616 1.616 0 0 0-.236.865c0 .417.12.77.37 1.047l.002.003c.252.269.624.45 1.097.557l.83.177c.14.033.241.068.308.104l.006.003c.069.032.1.063.114.084l.004.007.005.006c.015.018.026.045.026.09 0 .041-.013.083-.048.128l-.001.001c-.023.029-.075.068-.184.103H8.4a1.45 1.45 0 0 1-.437.052c-.285 0-.518-.027-.701-.075a2.238 2.238 0 0 1-.41-.157l-.012-.006a.71.71 0 0 0-.49-.05.627.627 0 0 0-.344.238.805.805 0 0 0-.153.378l-.001.007a.8.8 0 0 0 .072.405l.002.005c.072.144.19.249.343.32h.001c.161.073.365.143.608.213.159.045.333.079.523.101v.225a.648.648 0 0 0 .657.664Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.887 0a1.75 1.75 0 0 0-1.66 2.303l.536 1.61A6.252 6.252 0 0 0 1.75 9.75v4.5c0 .966.784 1.75 1.75 1.75h9a1.75 1.75 0 0 0 1.75-1.75v-4.5a6.252 6.252 0 0 0-4.014-5.838l.537-1.609A1.75 1.75 0 0 0 9.113 0H6.887Zm1.89 3.548a.754.754 0 0 1 .011-.035l.562-1.684a.25.25 0 0 0-.237-.329H6.887a.25.25 0 0 0-.237.33l.562 1.683a.763.763 0 0 1 .01.035 6.311 6.311 0 0 1 1.556 0ZM8 5a4.75 4.75 0 0 0-4.75 4.75v4.5c0 .138.112.25.25.25h9a.25.25 0 0 0 .25-.25v-4.5A4.75 4.75 0 0 0 8 5Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconMoneybagSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBriefcaseSmall = makeIcon({
  displayName: 'NoteIconBriefcaseSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.313 0C4.173 0 3.25.923 3.25 2.063H1.125C.504 2.063 0 2.566 0 3.187v2.25a2.625 2.625 0 0 0 2.625 2.625H4V8.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 8 8.5v-.438h1.375A2.625 2.625 0 0 0 12 5.438v-2.25c0-.622-.504-1.126-1.125-1.126H8.75C8.75.923 7.827 0 6.687 0H5.313ZM8 6v.563h1.375c.621 0 1.125-.504 1.125-1.125V3.563h-9v1.874c0 .622.504 1.125 1.125 1.125H4V6a.75.75 0 0 1 .75-.75h2.5A.75.75 0 0 1 8 6Zm-.75-3.938a.563.563 0 0 0-.563-.562H5.313a.563.563 0 0 0-.562.563h2.5ZM5.5 7.75v-1h1v1h-1Z"
        />
        <path d="M.563 7.062v3.688c0 .621.503 1.125 1.125 1.125h8.624c.622 0 1.126-.504 1.126-1.125V7.062c-.37.468-.897.808-1.5.94v2.373H2.061V8.002a2.625 2.625 0 0 1-1.5-.94Z" />
      </g>
    </>
  ),
})

export const NoteIconBriefcase = makeIcon({
  displayName: 'NoteIconBriefcase',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 2.75A2.5 2.5 0 0 1 7.5.25h1a2.5 2.5 0 0 1 2.5 2.5h3.5a1.5 1.5 0 0 1 1.5 1.5v3c0 .954-.381 1.818-1 2.45v3.8a2.25 2.25 0 0 1-2.25 2.25h-9.5A2.25 2.25 0 0 1 1 13.5V9.7a3.489 3.489 0 0 1-1-2.45v-3a1.5 1.5 0 0 1 1.5-1.5H5Zm3.5-1a1 1 0 0 1 1 1h-3a1 1 0 0 1 1-1h1Zm-7 2.5h13v3a2 2 0 0 1-2 2h-2.25V8.5a1 1 0 0 0-1-1h-2.5a1 1 0 0 0-1 1v.75H3.5a2 2 0 0 1-2-2v-3Zm4.25 6.5H3.5a3.5 3.5 0 0 1-1-.145V13.5c0 .414.336.75.75.75h9.5a.75.75 0 0 0 .75-.75v-2.895a3.5 3.5 0 0 1-1 .145h-2.25V11a1 1 0 0 1-1 1h-2.5a1 1 0 0 1-1-1v-.25ZM7.25 9v1.5h1.5V9h-1.5Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconBriefcaseSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBooksSmall = makeIcon({
  displayName: 'NoteIconBooksSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.313.85a.649.649 0 0 1 .117 1.288l-.117.336a1.6 1.6 0 0 0 0 1.052l.113.324h.824a.647.647 0 0 1 .323 1.21l-.143.405a1.6 1.6 0 0 0 0 1.07l.143.403a.648.648 0 0 1-.323 1.212h-.824l-.113.324a1.6 1.6 0 0 0 0 1.052l.117.335a.65.65 0 0 1-.117 1.29H2.25a2.15 2.15 0 0 1-1.073-4.013 2.138 2.138 0 0 1 0-2.277A2.148 2.148 0 0 1 2.25.85h8.063ZM2.25 8.15a.85.85 0 1 0 0 1.7h6.805a2.894 2.894 0 0 1 0-1.7H7.65v.35a.65.65 0 0 1-1.061.503l-.964-.79-.964.79A.65.65 0 0 1 3.6 8.5v-.35H2.25ZM4.9 7.128l.314-.256.411-.337.411.337.314.256V5.15H4.9v1.978Zm2.75-.278h2.518a2.894 2.894 0 0 1 0-1.7H7.65v1.7ZM3 5.15a.85.85 0 1 0 0 1.7h.6v-1.7H3Zm-.75-3a.85.85 0 1 0 0 1.7h6.805a2.894 2.894 0 0 1 0-1.7H2.25Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconBooks = makeIcon({
  displayName: 'NoteIconBooks',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.75 1.3a.698.698 0 0 1 .034 1.396l-.19.547c-.17.49-.17 1.024 0 1.514l.19.543h1.466a.698.698 0 0 1 .021 1.397l-.188.533a2.302 2.302 0 0 0 0 1.54l.188.532a.699.699 0 0 1-.021 1.398h-1.467l-.19.543c-.17.49-.17 1.024 0 1.514l.191.546a.699.699 0 0 1-.034 1.397h-11a2.7 2.7 0 0 1-1-5.208A2.687 2.687 0 0 1 1.3 8c0-.552.166-1.065.45-1.493a2.7 2.7 0 0 1 1-5.207h11Zm-11 9.4a1.3 1.3 0 1 0 0 2.6h9.55l-.029-.083a3.7 3.7 0 0 1 0-2.434l.03-.083H9.7V12a.7.7 0 0 1-1.196.495L7.5 11.49l-1.005 1.005A.7.7 0 0 1 5.3 12v-1.3H2.75Zm3.95-.39.8-.8.8.8V6.7H6.7v3.61Zm3-1.01h4.086l-.022-.063a3.699 3.699 0 0 1 0-2.474l.022-.063H9.7v2.6ZM4 6.7a1.3 1.3 0 1 0 0 2.6h1.3V6.7H4Zm-1.25-4a1.3 1.3 0 1 0 0 2.6h9.55l-.029-.083a3.7 3.7 0 0 1 0-2.434l.03-.083H2.75Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconBooksSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconQuestionSmall = makeIcon({
  displayName: 'NoteIconQuestionSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.513.05c-.967 0-1.917.253-2.732.735l-.39.231a1.4 1.4 0 0 0-.407 2.047l.265.353a1.4 1.4 0 0 0 1.832.364l.535-.316c.26-.154.572-.24.897-.24.337 0 .473.227.473.347v.097c0 .135-.1.321-.354.406l-1.334.444c-.638.212-1.13.784-1.13 1.494V7a1.4 1.4 0 0 0 1.4 1.4h.614a1.4 1.4 0 0 0 1.393-1.267l.21-.07c1.53-.509 2.615-1.838 2.615-3.395V3.57C10.4 1.555 8.584.05 6.513.05Zm-2.07 1.854a4.08 4.08 0 0 1 2.07-.554C8.017 1.35 9.1 2.415 9.1 3.57v.097c0 .917-.646 1.803-1.726 2.162l-.648.215a.65.65 0 0 0-.444.617V7a.1.1 0 0 1-.1.1h-.614a.1.1 0 0 1-.1-.1v-.988c0-.07.054-.199.24-.26l1.334-.444c.706-.235 1.244-.865 1.244-1.64V3.57c0-.98-.87-1.646-1.773-1.646-.55 0-1.092.144-1.56.42l-.533.316a.1.1 0 0 1-.131-.026l-.266-.354a.1.1 0 0 1 .029-.146l.391-.231ZM5.25 8.7a1.3 1.3 0 0 0-1.3 1.3v.625a1.3 1.3 0 0 0 1.3 1.3h1.125a1.3 1.3 0 0 0 1.3-1.3V10a1.3 1.3 0 0 0-1.3-1.3H5.25Zm1.125 1.925H5.25V10h1.125v.625Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconQuestion = makeIcon({
  displayName: 'NoteIconQuestion',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.684.1c-1.252 0-2.48.328-3.532.95l-.521.309a1.65 1.65 0 0 0-.48 2.411l.355.472a1.65 1.65 0 0 0 2.159.429l.712-.422c.381-.225.836-.349 1.307-.349.543 0 .848.375.848.679v.128c0 .288-.206.61-.621.748l-1.778.591c-.776.258-1.36.947-1.36 1.787V9.75c0 .911.74 1.65 1.65 1.65h.82a1.65 1.65 0 0 0 1.65-1.65v-.582l.417-.139c1.967-.654 3.34-2.352 3.34-4.322V4.58C13.65 2.034 11.351.1 8.684.1Zm-2.87 2.07c.844-.5 1.843-.77 2.87-.77 2.1 0 3.666 1.494 3.666 3.179v.128c0 1.33-.934 2.585-2.45 3.089l-.863.287a.65.65 0 0 0-.445.617v1.05a.35.35 0 0 1-.35.35h-.818a.35.35 0 0 1-.35-.35V7.833c0-.2.145-.445.47-.553l1.777-.591c.867-.289 1.51-1.054 1.51-1.982V4.58c0-1.164-1.036-1.979-2.147-1.979-.695 0-1.38.182-1.968.53l-.713.422a.35.35 0 0 1-.458-.091l-.354-.472a.35.35 0 0 1 .101-.511l.522-.309ZM7 11.95a1.3 1.3 0 0 0-1.3 1.3v1.25A1.3 1.3 0 0 0 7 15.8h1.5a1.3 1.3 0 0 0 1.3-1.3v-1.25a1.3 1.3 0 0 0-1.3-1.3H7Zm0 1.3h1.5v1.25H7v-1.25Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconQuestionSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBarChartSmall = makeIcon({
  displayName: 'NoteIconBarChartSmall',
  viewBox: 12,
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M2 1.55a1.7 1.7 0 0 1 1.7 1.7v8.001a.7.7 0 0 1-.7.7H.75a.7.7 0 0 1-.7-.7V3.25a1.7 1.7 0 0 1 1.7-1.7H2Zm-.25 1.4a.3.3 0 0 0-.3.3v7.3h.85v-7.3a.3.3 0 0 0-.3-.3h-.25ZM6 5.408a1.7 1.7 0 0 1 1.7 1.7v4.143a.7.7 0 0 1-.7.7H5a.7.7 0 0 1-.7-.7V7.108a1.7 1.7 0 0 1 1.7-1.7Zm0 1.4a.3.3 0 0 0-.3.3v3.443h.6V7.108a.3.3 0 0 0-.3-.3ZM10.25.425a1.7 1.7 0 0 1 1.7 1.7v9.125a.7.7 0 0 1-.7.7H9a.7.7 0 0 1-.7-.7V2.125a1.7 1.7 0 0 1 1.7-1.7h.25Zm-.25 1.4a.3.3 0 0 0-.3.3v8.425h.85V2.125a.3.3 0 0 0-.3-.3H10Z" />
      </g>
    </>
  ),
})

export const NoteIconBarChart = makeIcon({
  displayName: 'NoteIconBarChart',
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M13.25.75A1.75 1.75 0 0 0 11.5 2.5V15c0 .414.336.75.75.75h3A.75.75 0 0 0 16 15V2.5A1.75 1.75 0 0 0 14.25.75h-1ZM13 2.5a.25.25 0 0 1 .25-.25h1a.25.25 0 0 1 .25.25v11.75H13V2.5ZM0 4c0-.966.784-1.75 1.75-1.75h1c.966 0 1.75.784 1.75 1.75v11.002a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75V4Zm1.75-.25A.25.25 0 0 0 1.5 4v10.252H3V4a.25.25 0 0 0-.25-.25h-1ZM5.75 9.145c0-.967.784-1.75 1.75-1.75h1c.966 0 1.75.783 1.75 1.75v5.857a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75V9.145Zm1.75-.25a.25.25 0 0 0-.25.25v5.107h1.5V9.145a.25.25 0 0 0-.25-.25h-1Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconBarChartSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconDollarSmall = makeIcon({
  displayName: 'NoteIconDollarSmall',
  viewBox: 12,
  content: (
    <>
      <path
        d="M6.322 7.28h.009c.11-.026.21-.066.302-.117a.874.874 0 0 0 .32-.298.781.781 0 0 0 .118-.425.703.703 0 0 0-.338-.629 1.25 1.25 0 0 0-.397-.152l-.414-.091a.569.569 0 0 1-.19-.069.084.084 0 0 1-.032-.066c0-.044.019-.082.069-.116a.472.472 0 0 1 .257-.057c.103 0 .184.009.244.023l.003.001a.89.89 0 0 1 .174.054c.083.034.165.05.239.033h.002a.307.307 0 0 0 .17-.11.345.345 0 0 0 .042-.371.316.316 0 0 0-.147-.154 1.084 1.084 0 0 0-.298-.12 1.563 1.563 0 0 0-.133-.03v-.12a.32.32 0 0 0-.329-.328.32.32 0 0 0-.325.329v.137a1.193 1.193 0 0 0-.311.118.905.905 0 0 0-.328.309.8.8 0 0 0-.117.428c0 .206.06.381.183.518v.001c.126.133.31.223.544.276l.41.088c.07.016.12.033.153.051l.003.001c.034.016.05.032.056.042l.005.007c.007.009.013.022.013.044a.1.1 0 0 1-.024.063c-.011.015-.038.035-.092.052a.722.722 0 0 1-.217.025 1.37 1.37 0 0 1-.347-.037 1.104 1.104 0 0 1-.202-.077L5.39 6.51a.351.351 0 0 0-.242-.025.31.31 0 0 0-.17.118.398.398 0 0 0-.076.187v.003a.396.396 0 0 0 .035.201l.001.003c.036.07.095.123.17.158.08.036.18.07.301.105.079.022.165.04.26.05v.111a.32.32 0 0 0 .324.329.32.32 0 0 0 .329-.329v-.14Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.063 10.625c.446 0 .84-.223 1.077-.563h1.36a1.5 1.5 0 0 0 1.5-1.5v-5.25a1.5 1.5 0 0 0-1.5-1.5H9.14a1.311 1.311 0 0 0-1.078-.562H3.939c-.447 0-.84.222-1.078.563H1.5a1.5 1.5 0 0 0-1.5 1.5v5.25a1.5 1.5 0 0 0 1.5 1.5h1.36c.237.34.631.562 1.078.562h4.124Zm-3.938-1.5V2.75h3.75v6.375h-3.75Zm5.25-.563v-5.25H10.5v5.25H9.375ZM1.5 3.313h1.125v5.25H1.5v-5.25Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconDollar = makeIcon({
  displayName: 'NoteIconDollar',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.012 10.65a.51.51 0 0 0 .375-.149.5.5 0 0 0 .152-.368v-.166c.16-.04.306-.096.44-.17.206-.112.371-.259.49-.443a1.15 1.15 0 0 0 .181-.638c0-.302-.094-.56-.29-.76-.19-.2-.475-.333-.832-.41l-.614-.13a.845.845 0 0 1-.267-.092c-.024-.022-.03-.04-.03-.061 0-.046.018-.088.083-.131.07-.045.185-.076.36-.076.152 0 .268.012.353.033l.006.001c.096.02.18.045.251.075h.002a.635.635 0 0 0 .375.05h.005a.497.497 0 0 0 .273-.172.506.506 0 0 0 .12-.276.532.532 0 0 0-.052-.307.503.503 0 0 0-.236-.241 1.673 1.673 0 0 0-.45-.177 2.459 2.459 0 0 0-.168-.038v-.137a.5.5 0 0 0-.153-.37.52.52 0 0 0-.374-.147.514.514 0 0 0-.522.517v.164a1.816 1.816 0 0 0-.44.166c-.21.117-.38.27-.502.461-.121.19-.18.406-.18.642 0 .307.091.571.283.778l.002.003c.193.2.474.332.825.41l.61.125a.955.955 0 0 1 .216.071l.007.003c.046.021.062.04.066.045l.004.007.006.007c.003.004.009.012.009.035 0 .018-.006.038-.026.064h-.001c-.01.012-.039.037-.116.06l-.002.001a1.058 1.058 0 0 1-.31.035c-.206 0-.373-.018-.504-.052a1.626 1.626 0 0 1-.293-.11l-.012-.005a.571.571 0 0 0-.385-.037.5.5 0 0 0-.273.185.611.611 0 0 0-.121.29v.007c-.01.109.01.214.056.313l.003.005a.545.545 0 0 0 .271.247h.001c.12.053.272.105.452.155.108.03.226.053.354.069v.122a.515.515 0 0 0 .522.517Zm.377-.517v-.287a2.057 2.057 0 0 0 .15-.034 1.622 1.622 0 0 0-.15.034v.287ZM6.744 9.65a3.288 3.288 0 0 1 0 0Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.95 2.75A1.5 1.5 0 0 1 5.25 2h5.5a1.5 1.5 0 0 1 1.3.75h2.2c.966 0 1.75.784 1.75 1.75v7a1.75 1.75 0 0 1-1.75 1.75h-2.2a1.5 1.5 0 0 1-1.3.75h-5.5a1.5 1.5 0 0 1-1.3-.75h-2.2A1.75 1.75 0 0 1 0 11.5v-7c0-.966.784-1.75 1.75-1.75h2.2Zm-.2 1.5h-2a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h2v-7.5Zm8.5 7.5h2a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25h-2v7.5Zm-1.5-8.25h-5.5v9h5.5v-9Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconDollarSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconXSmall = makeIcon({
  displayName: 'NoteIconXSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 1.5 6 4.874l3.375-3.373L10.5 2.626 7.125 6 10.5 9.374 9.375 10.5 6.001 7.126 2.625 10.5 1.5 9.375 4.875 6 1.5 2.625 2.625 1.5ZM2.754 6 .439 3.686a1.5 1.5 0 0 1 0-2.122L1.564.44a1.5 1.5 0 0 1 2.122 0L6 2.754 8.314.44a1.5 1.5 0 0 1 2.122 0l1.125 1.125a1.5 1.5 0 0 1 0 2.121L9.247 6l2.314 2.314a1.5 1.5 0 0 1 0 2.121l-1.125 1.125a1.5 1.5 0 0 1-2.122 0L6 9.246l-2.314 2.315a1.5 1.5 0 0 1-2.122 0L.44 10.436a1.5 1.5 0 0 1 0-2.122L2.754 6Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconX = makeIcon({
  displayName: 'NoteIconX',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m8 6.5 4.5-4.499 1.5 1.5L9.5 8l4.5 4.499-1.5 1.5-4.5-4.5L3.5 14 2 12.5 6.5 8 2 3.5 3.5 2 8 6.5ZM4.38 8 .94 4.56a1.5 1.5 0 0 1 0-2.12l1.5-1.5a1.5 1.5 0 0 1 2.12 0L8 4.378 11.44.94a1.5 1.5 0 0 1 2.12 0l1.5 1.5a1.5 1.5 0 0 1 0 2.122L11.623 8l3.439 3.438a1.5 1.5 0 0 1 0 2.122l-1.5 1.5a1.5 1.5 0 0 1-2.122 0L8.001 11.62l-3.44 3.44a1.5 1.5 0 0 1-2.122 0l-1.5-1.5a1.5 1.5 0 0 1 0-2.122L4.38 8Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconXSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconEyesSmall = makeIcon({
  displayName: 'NoteIconEyesSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.375 1.5A3.375 3.375 0 0 0 0 4.875v2.25a3.375 3.375 0 0 0 6 2.121 3.375 3.375 0 0 0 6-2.121v-2.25A3.375 3.375 0 0 0 8.625 1.5c-.453 0-.903.073-1.333.216l-.03.01a.75.75 0 1 0 .475 1.423l.029-.01c.277-.092.567-.139.859-.139 1.036 0 1.875.84 1.875 1.875v2.25a1.875 1.875 0 0 1-3.354 1.152A1.783 1.783 0 1 0 8.38 4.931a.112.112 0 0 0-.148.127A1.012 1.012 0 0 1 6.75 6.136V4.876A3.375 3.375 0 0 0 3.375 1.5ZM5.25 4.875a1.875 1.875 0 0 0-3.75 0V6.19a1.012 1.012 0 0 0 1.37-1.131.112.112 0 0 1 .148-.128 1.784 1.784 0 0 1-1.081 3.397A1.875 1.875 0 0 0 5.25 7.125v-2.25Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconEyes = makeIcon({
  displayName: 'NoteIconEyes',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 2.25A4.25 4.25 0 0 0 .25 6.5v3A4.25 4.25 0 0 0 8 11.912 4.25 4.25 0 0 0 15.75 9.5v-3a4.25 4.25 0 0 0-4.25-4.25c-.577 0-1.15.093-1.699.276l-.038.012a.75.75 0 1 0 .474 1.424l.039-.013A3.871 3.871 0 0 1 11.5 3.75a2.75 2.75 0 0 1 2.75 2.75v3a2.75 2.75 0 0 1-5.17 1.308 2.377 2.377 0 1 0 2.093-4.233.15.15 0 0 0-.197.17 1.35 1.35 0 0 1-2.226 1.26V6.5A4.25 4.25 0 0 0 4.5 2.25ZM7.25 6.5a2.75 2.75 0 0 0-5.5 0v1.621a1.35 1.35 0 0 0 2.076-1.377.15.15 0 0 1 .198-.169 2.378 2.378 0 1 1-1.868 4.363A2.75 2.75 0 0 0 7.25 9.5v-3Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconEyesSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconScrollSmall = makeIcon({
  displayName: 'NoteIconScrollSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M4.56 3.931a.75.75 0 0 1 .75-.75h2.242a.75.75 0 1 1 0 1.5H5.31a.75.75 0 0 1-.75-.75ZM5.31 5.25a.75.75 0 0 0 0 1.5h2.242a.75.75 0 1 0 0-1.5H5.31Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.836 0A1.836 1.836 0 0 0 0 1.836v1.448c0 .415.336.75.75.75h1.422v6.13A1.836 1.836 0 0 0 4.19 11.99V12h5.68A2.13 2.13 0 0 0 12 9.87V9.26a.75.75 0 0 0-.75-.75h-.517v-6.38A2.13 2.13 0 0 0 8.603 0H1.836Zm7.397 8.509v-6.38a.63.63 0 0 0-.63-.629H3.642c.02.109.03.221.03.336v8.328a.336.336 0 1 0 .673 0v-.905a.75.75 0 0 1 .75-.75h4.138Zm-3.388 1.5v.155c0 .115-.01.227-.03.336H9.87c.3 0 .551-.21.614-.491h-4.64ZM1.836 1.5a.336.336 0 0 0-.336.336v.698h.672v-.698a.336.336 0 0 0-.336-.336Z"
        />
      </g>
    </>
  ),
})

export const NoteIconScroll = makeIcon({
  displayName: 'NoteIconScroll',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M6.25 5A.75.75 0 0 1 7 4.25h3.25a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 5ZM7 7.25a.75.75 0 0 0 0 1.5h3.25a.75.75 0 0 0 0-1.5H7Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25 0A2.25 2.25 0 0 0 0 2.25v2c0 .414.336.75.75.75H3v8.75a2.25 2.25 0 0 0 2.5 2.236V16h7.75A2.75 2.75 0 0 0 16 13.25v-.75a.75.75 0 0 0-.75-.75h-1v-9A2.75 2.75 0 0 0 11.5 0H2.25Zm10.5 11.75v-9c0-.69-.56-1.25-1.25-1.25H4.372c.083.235.128.487.128.75v11.5a.75.75 0 0 0 1.5 0V12.5a.75.75 0 0 1 .75-.75h6Zm-5.25 1.5v.5c0 .263-.045.515-.128.75h5.878c.69 0 1.25-.56 1.25-1.25h-7ZM3 2.25V3.5H1.5V2.25a.75.75 0 0 1 1.5 0Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconScrollSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconNoEntrySignSmall = makeIcon({
  displayName: 'NoteIconNoEntrySignSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.027 9.33A4.482 4.482 0 0 0 10.5 6a4.5 4.5 0 1 0-1.473 3.33Zm-.206-1.494a.555.555 0 0 0 .318-.285 3.5 3.5 0 0 0-4.274-4.862.555.555 0 0 0-.324.277.643.643 0 0 0-.044.437c.027.111.081.22.164.314l3.43 3.904.001.001a.735.735 0 0 0 .29.202c.145.055.302.06.44.012Zm-1.316.76a.735.735 0 0 0-.164-.314L3.91 4.377a.735.735 0 0 0-.29-.202.644.644 0 0 0-.439-.012.555.555 0 0 0-.318.284 3.5 3.5 0 0 0 4.275 4.864.555.555 0 0 0 .324-.278.643.643 0 0 0 .044-.437ZM0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconNoEntrySign = makeIcon({
  displayName: 'NoteIconNoEntrySign',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.457 11.534A6.476 6.476 0 0 0 14.5 8a6.5 6.5 0 1 0-1.043 3.534Zm-1.172-.956a.78.78 0 0 0 .205-.253 5.056 5.056 0 0 0-6.22-7.077.78.78 0 0 0-.277.171c-.252.243-.303.638-.146.975.039.083.09.163.155.236l5.083 5.784v.001a.993.993 0 0 0 .215.183c.314.199.711.199.985-.02ZM4.702 5.4c-.314-.2-.712-.2-.985.019a.78.78 0 0 0-.206.253 5.056 5.056 0 0 0 6.222 7.079.779.779 0 0 0 .277-.172c.252-.243.303-.637.145-.974a.992.992 0 0 0-.154-.236L4.917 5.584a.995.995 0 0 0-.215-.184Zm3.137-.952 3.663 4.169a3.556 3.556 0 0 0-3.664-4.169ZM4.499 7.38a3.556 3.556 0 0 0 3.667 4.172L4.497 7.38ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconNoEntrySignSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconCrystalBallSmall = makeIcon({
  displayName: 'NoteIconCrystalBallSmall',
  viewBox: 12,
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M6.354.703a.75.75 0 0 1-.682.811A3.75 3.75 0 0 0 3.79 8.278h4.418a3.753 3.753 0 0 0 1.43-2.123.75.75 0 1 1 1.456.36 5.241 5.241 0 0 1-1.37 2.431l.472.707c.651.976-.05 2.285-1.223 2.285H3.025c-1.174 0-1.874-1.309-1.223-2.285l.47-.707A5.25 5.25 0 0 1 5.543.02a.75.75 0 0 1 .812.683ZM3.521 9.778l-.44.66h5.836l-.44-.66H3.52Z" />
        <path d="M8.856.654a.75.75 0 0 0-1.395 0l-.428 1.08a1.41 1.41 0 0 1-.952.843l-.273.072a.75.75 0 0 0-.158 1.39l.66.346c.282.149.506.39.634.682l.527 1.203a.75.75 0 0 0 1.374 0l.527-1.203a1.41 1.41 0 0 1 .636-.682l.659-.347a.75.75 0 0 0-.159-1.389l-.272-.072a1.41 1.41 0 0 1-.952-.843L8.856.654Zm-1.275 2.8a2.91 2.91 0 0 0 .577-.648c.16.244.355.462.578.647a2.91 2.91 0 0 0-.578.7 2.91 2.91 0 0 0-.577-.7Z" />
      </g>
    </>
  ),
})

export const NoteIconCrystalBall = makeIcon({
  displayName: 'NoteIconCrystalBall',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5a5.5 5.5 0 0 0-3.163 10h6.326a5.496 5.496 0 0 0 2.305-3.906.75.75 0 0 1 1.492.16 6.983 6.983 0 0 1-2.171 4.352c.047.054.091.112.132.173l.667 1c.775 1.163-.059 2.721-1.456 2.721H3.869c-1.398 0-2.232-1.558-1.457-2.72l.667-1c.04-.062.085-.12.132-.174A7 7 0 0 1 8 0a.75.75 0 0 1 0 1.5ZM4.535 13a.25.25 0 0 0-.208.111l-.667 1a.25.25 0 0 0 .209.389h8.262a.25.25 0 0 0 .208-.389l-.666-1a.25.25 0 0 0-.208-.111h-6.93Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.697.724a.75.75 0 0 0-1.394 0l-.595 1.5a2.25 2.25 0 0 1-1.52 1.346l-.379.1a.75.75 0 0 0-.158 1.389l.916.481c.452.238.81.622 1.014 1.09l.732 1.67a.75.75 0 0 0 1.374 0l.732-1.67a2.25 2.25 0 0 1 1.014-1.09l.916-.481a.75.75 0 0 0-.158-1.39l-.38-.099a2.25 2.25 0 0 1-1.52-1.347l-.594-1.5ZM9.722 4.497A3.75 3.75 0 0 0 11 3.011a3.75 3.75 0 0 0 1.278 1.486 3.75 3.75 0 0 0-1.233 1.53L11 6.131l-.045-.104a3.75 3.75 0 0 0-1.233-1.53Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconCrystalBallSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconIphoneSmall = makeIcon({
  displayName: 'NoteIconIphoneSmall',
  viewBox: 12,
  content: (
    <>
      <path
        d="M5.438 2a.75.75 0 0 0 0 1.5h1.125a.75.75 0 0 0 0-1.5H5.438Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.125 0a2.25 2.25 0 0 0-2.25 2.25v7.5A2.25 2.25 0 0 0 4.125 12h3.75a2.25 2.25 0 0 0 2.25-2.25v-7.5A2.25 2.25 0 0 0 7.875 0h-3.75Zm-.75 2.25a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-.75.75h-3.75a.75.75 0 0 1-.75-.75v-7.5Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconIphone = makeIcon({
  displayName: 'NoteIconIphone',
  content: (
    <>
      <path
        d="M7.25 2a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0a2.25 2.25 0 0 0-2.25 2.25v11.5A2.25 2.25 0 0 0 5 16h6a2.25 2.25 0 0 0 2.25-2.25V2.25A2.25 2.25 0 0 0 11 0H5Zm-.75 2.25A.75.75 0 0 1 5 1.5h6a.75.75 0 0 1 .75.75v11.5a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75V2.25Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconIphoneSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBookSmall = makeIcon({
  displayName: 'NoteIconBookSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 2.71v5.585c.285-.041.578-.063.875-.063.895 0 1.745.195 2.5.544V3.39a4.383 4.383 0 0 0-2.5-.765c-.3 0-.594.03-.875.084Zm4.875.68v5.386a5.948 5.948 0 0 1 2.5-.544c.297 0 .59.022.875.063V2.71a4.55 4.55 0 0 0-.875-.084c-.945 0-1.81.288-2.5.765ZM6 2.087a5.891 5.891 0 0 0-3.25-.962c-.649 0-1.274.103-1.857.292a.75.75 0 0 0-.518.713v7.107a.75.75 0 0 0 .982.714 4.496 4.496 0 0 1 1.393-.219 4.35 4.35 0 0 1 2.773.972.75.75 0 0 0 .954 0 4.35 4.35 0 0 1 2.773-.972c.49 0 .96.078 1.393.219a.75.75 0 0 0 .982-.714V2.13a.75.75 0 0 0-.518-.713 5.996 5.996 0 0 0-1.857-.292A5.891 5.891 0 0 0 6 2.087Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconBook = makeIcon({
  displayName: 'NoteIconBook',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 3.41v7.945a7.826 7.826 0 0 1 1.417-.129c1.3 0 2.523.318 3.583.879V4.39A6.082 6.082 0 0 0 3.667 3.25c-.49 0-.965.056-1.417.16Zm6.5.981v7.714a7.653 7.653 0 0 1 3.583-.879c.485 0 .958.044 1.417.129V3.41a6.297 6.297 0 0 0-1.417-.16c-1.36 0-2.604.43-3.583 1.141ZM8 3.084A7.593 7.593 0 0 0 3.667 1.75c-.84 0-1.647.133-2.4.377a.75.75 0 0 0-.517.714v9.476a.75.75 0 0 0 .982.713 6.244 6.244 0 0 1 1.935-.304c1.49 0 2.84.516 3.856 1.353a.75.75 0 0 0 .954 0c1.016-.837 2.365-1.353 3.856-1.353.68 0 1.332.107 1.935.304a.75.75 0 0 0 .982-.713V2.84a.75.75 0 0 0-.518-.714 7.745 7.745 0 0 0-2.399-.377c-1.619 0-3.12.494-4.333 1.334Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconBookSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconDepartmentStoreSmall = makeIcon({
  displayName: 'NoteIconDepartmentStoreSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.943.75a.75.75 0 0 1 .75-.75h8.864a.75.75 0 0 1 .307 1.435V10.5H11a.75.75 0 0 1 0 1.5H1.25a.75.75 0 0 1 0-1.5h.136V1.435A.75.75 0 0 1 .943.75Zm1.943.75v9h.716V9a1.41 1.41 0 0 1 1.415-1.406h2.216c.772 0 1.415.62 1.415 1.406v1.5h.716v-9H2.886Zm4.262 9V9.094H5.102V10.5h2.046ZM3.602 3.25a.75.75 0 0 1 .75-.75H5A.75.75 0 0 1 5 4h-.648a.75.75 0 0 1-.75-.75Zm2.898 0a.75.75 0 0 1 .75-.75h.648a.75.75 0 0 1 0 1.5H7.25a.75.75 0 0 1-.75-.75ZM3.602 5.5a.75.75 0 0 1 .75-.75H5a.75.75 0 0 1 0 1.5h-.648a.75.75 0 0 1-.75-.75Zm2.898 0a.75.75 0 0 1 .75-.75h.648a.75.75 0 0 1 0 1.5H7.25a.75.75 0 0 1-.75-.75Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconDepartmentStore = makeIcon({
  displayName: 'NoteIconDepartmentStore',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.508 1.25a.75.75 0 0 1 .75-.75h11.818a.75.75 0 0 1 .159 1.483V14h.432a.75.75 0 1 1 0 1.5h-13a.75.75 0 0 1 0-1.5h.432V1.983a.75.75 0 0 1-.591-.733Zm2.09.75v12h1.455v-1.781c0-.915.768-1.594 1.636-1.594h2.955c.868 0 1.636.68 1.636 1.594V14h1.455V2H3.599ZM9.78 14v-1.781c0-.014-.004-.032-.026-.054a.157.157 0 0 0-.11-.04H6.689a.157.157 0 0 0-.11.04c-.021.022-.026.04-.026.054V14H9.78ZM5.053 4.062a.75.75 0 0 1 .75-.75h1.182a.75.75 0 0 1 0 1.5H5.803a.75.75 0 0 1-.75-.75Zm3.546 0a.75.75 0 0 1 .75-.75h1.181a.75.75 0 0 1 0 1.5H9.35a.75.75 0 0 1-.75-.75Zm-3.546 2.25a.75.75 0 0 1 .75-.75h1.182a.75.75 0 0 1 0 1.5H5.803a.75.75 0 0 1-.75-.75Zm3.546 0a.75.75 0 0 1 .75-.75h1.181a.75.75 0 0 1 0 1.5H9.35a.75.75 0 0 1-.75-.75Zm-3.546 2.25a.75.75 0 0 1 .75-.75h1.182a.75.75 0 0 1 0 1.5H5.803a.75.75 0 0 1-.75-.75Zm3.546 0a.75.75 0 0 1 .75-.75h1.181a.75.75 0 0 1 0 1.5H9.35a.75.75 0 0 1-.75-.75Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconDepartmentStoreSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconCrossedSwordsSmall = makeIcon({
  displayName: 'NoteIconCrossedSwordsSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.465.417A.65.65 0 0 0 .254.97l.1.926a3.65 3.65 0 0 0 1.048 2.19l2.124 2.125-.76.76A1.576 1.576 0 0 0 .69 9.314a1.588 1.588 0 0 0 2.243 2.243A1.575 1.575 0 0 0 5.277 9.48l.759-.759.759.76a1.576 1.576 0 0 0 2.344 2.078 1.587 1.587 0 0 0 2.244-2.244A1.576 1.576 0 0 0 9.305 6.97l-.759-.759 2.124-2.124a3.65 3.65 0 0 0 1.048-2.19l.1-.927a.65.65 0 0 0-.783-.705l-.94.202a3.65 3.65 0 0 0-1.813.987L6.036 3.701 3.789 1.454A3.65 3.65 0 0 0 1.976.466l-.94-.201a.65.65 0 0 0-.571.152Zm7.906 7.457-.672.672L2.32 3.168a2.35 2.35 0 0 1-.675-1.41l-.003-.033.06.012a2.35 2.35 0 0 1 1.167.636l5.5 5.5Zm-3.254-.072-.672-.672-.744.744.672.672.744-.744ZM6.955 4.62l.672.672 2.124-2.124c.379-.38.617-.877.675-1.41l.003-.033-.06.013a2.35 2.35 0 0 0-1.167.636L6.955 4.62ZM3.923 9.934l-.01-.01-.01-.01-1.57-1.57-.01-.01-.01-.01-.264-.264a.275.275 0 0 0-.39.39l.866.865-.874.875a.288.288 0 0 0 .406.406l.875-.874.866.866a.275.275 0 0 0 .39-.39l-.265-.264Zm6.091.663a.287.287 0 1 0 .407-.407l-.875-.874.866-.866a.275.275 0 1 0-.39-.39L7.885 10.2a.275.275 0 0 0 .39.39l.866-.867.874.875Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconCrossedSwords = makeIcon({
  displayName: 'NoteIconCrossedSwords',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.903.623a.75.75 0 0 0-.243.638l.133 1.236a4.75 4.75 0 0 0 1.364 2.85L4.819 8.01l-1.42 1.42A1.984 1.984 0 0 0 .77 12.39l.012.011-.023.023a2 2 0 0 0 2.828 2.829l.023-.023.012.011a1.984 1.984 0 0 0 2.96-2.63l1.42-1.42 1.418 1.418a1.984 1.984 0 0 0 2.961 2.631l.012-.011.022.023a2 2 0 0 0 2.829-2.829l-.023-.022.011-.012a1.984 1.984 0 0 0-2.63-2.962L11.184 8.01l2.661-2.662a4.75 4.75 0 0 0 1.364-2.85l.133-1.236a.75.75 0 0 0-.903-.814l-1.252.27a4.75 4.75 0 0 0-2.36 1.285L8 4.828 5.175 2.002A4.75 4.75 0 0 0 2.815.717L1.563.447a.75.75 0 0 0-.66.176Zm10.628 9.856-1.06 1.06-7.254-7.252a3.25 3.25 0 0 1-.933-1.95l-.022-.205.238.051a3.25 3.25 0 0 1 1.614.88l7.417 7.416Zm-4.59-.348L5.88 9.07l-1.41 1.41 1.06 1.06 1.41-1.41Zm2.12-4.243 1.061 1.06 2.662-2.66a3.25 3.25 0 0 0 .933-1.95l.022-.205-.238.051a3.25 3.25 0 0 0-1.615.88L9.062 5.887Zm-6.535 8.305a.5.5 0 1 1-.707-.707l1.083-1.084L1.83 11.33a.484.484 0 1 1 .684-.684l2.852 2.851a.484.484 0 0 1-.685.685L3.61 13.11l-1.083 1.083Zm10.95 0a.5.5 0 1 0 .706-.708L13.1 12.402l1.072-1.072a.484.484 0 1 0-.684-.685l-2.852 2.851a.484.484 0 1 0 .684.685l1.073-1.072 1.083 1.083Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconCrossedSwordsSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBuildingConstructionSmall = makeIcon({
  displayName: 'NoteIconBuildingConstructionSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.895 1.5H.75a.75.75 0 0 0 0 1.5h.145a2 2 0 0 0 .335.55L.795 10.5H.75a.75.75 0 0 0 0 1.5H4.5a.75.75 0 0 0 0-1.5h-.015l-.147-7.034c.109-.142.199-.298.267-.466H8.25v3c0 .414.336.75.75.75a.75.75 0 1 1-.726.938.75.75 0 0 0-1.453.374A2.25 2.25 0 1 0 9.75 5.378V3h1.5a.75.75 0 0 0 0-1.5H4.605a2 2 0 0 0-3.71 0Zm1.855.25a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm0 2.5c.035 0 .07 0 .104-.003l.13 6.253h-.686l.391-6.25h.061Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconBuildingConstruction = makeIcon({
  displayName: 'NoteIconBuildingConstruction',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.628 2.25a2.25 2.25 0 0 1 4.244 0h9.378a.75.75 0 0 1 0 1.5h-2.5v3.604a2.751 2.751 0 1 1-3.413 3.333.75.75 0 1 1 1.452-.374A1.25 1.25 0 1 0 12 8.75a.75.75 0 0 1-.75-.75V3.75H5.872a2.237 2.237 0 0 1-.137.31V14.5H6A.75.75 0 0 1 6 16H1a.75.75 0 0 1 0-1.5h.295l.624-10.193a2.243 2.243 0 0 1-.291-.557H.75a.75.75 0 0 1 0-1.5h.878Zm2.122 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 3c.1 0 .199-.007.295-.02l.19 9.27H2.797l.569-9.283c.125.022.253.033.384.033Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconBuildingConstructionSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconConstructionSmall = makeIcon({
  displayName: 'NoteIconConstructionSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.8 1.687a1.637 1.637 0 1 1 3.157.613h4.086a1.637 1.637 0 1 1 3.038 0h.169a.7.7 0 0 1 .7.7v4.5a.7.7 0 0 1-.7.7h-.988v3.05a.7.7 0 1 1-1.4 0V8.2H3.139v3.05a.7.7 0 1 1-1.4 0V8.2H.75a.7.7 0 0 1-.7-.7V3a.7.7 0 0 1 .7-.7h.168A1.633 1.633 0 0 1 .8 1.687Zm1.638-.237a.238.238 0 1 0 0 .475.238.238 0 0 0 0-.475ZM1.45 3.7v2.335L2.617 3.7H1.45Zm2.733 0-1.55 3.1h1.81l1.55-3.1h-1.81Zm3.375 0-1.55 3.1h1.551l1.744-3.1H7.558Zm2.992.639-1.384 2.46h1.384V4.34ZM9.325 1.687a.238.238 0 1 1 .475 0 .238.238 0 0 1-.475 0Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconConstruction = makeIcon({
  displayName: 'NoteIconConstruction',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.25 2a2 2 0 1 1 3.561 1.25h6.378a2 2 0 1 1 3.123 0h.938A.75.75 0 0 1 16 4v6a.75.75 0 0 1-.75.75h-1.5V15a1 1 0 1 1-2 0v-4.25h-7.5V15a1 1 0 1 1-2 0v-4.25H.75A.75.75 0 0 1 0 10V4a.75.75 0 0 1 .75-.75h.939A1.992 1.992 0 0 1 1.25 2Zm2-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM1.5 4.75v4.5h.036l2.25-4.5H1.5Zm3.964 0-2.25 4.5h2.822l2.25-4.5H5.464Zm4.5 0-2.25 4.5h2.472l2.532-4.5H9.964Zm4.475 0-2.532 4.5H14.5v-4.5h-.061ZM12.25 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconConstructionSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMuscleSmall = makeIcon({
  displayName: 'NoteIconMuscleSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.09 1.44a1.476 1.476 0 0 0-1.638 1.816l.029.118c.062.25.074.511.037.767l-.74 5.033a.05.05 0 0 0 .03.054l1.53.636a9.586 9.586 0 0 0 3.682.736h.751c.51 0 1.016-.076 1.503-.225A1.45 1.45 0 0 0 10.3 8.988v-.321c0-.559-.25-1.088-.683-1.441a3.325 3.325 0 0 0-2.456-.732l-.155.017a3.7 3.7 0 0 0-2.303 1.143l-.097.103a.85.85 0 0 1-.006.006l-.504.536a.7.7 0 0 1-1.02-.96l.33-.35.127-2.686a.7.7 0 0 1-.128-1.374l.69-.185m.86 1.149a2.065 2.065 0 0 0 .941-2.409l-.027-.087A1.943 1.943 0 0 0 4.285.054C2.268-.229.605 1.616 1.093 3.592l.029.118a.59.59 0 0 1 .01.227L.393 8.97a1.45 1.45 0 0 0 .878 1.55l1.53.637c1.337.556 2.772.843 4.22.843h.751c.648 0 1.293-.096 1.912-.286A2.85 2.85 0 0 0 11.7 8.988v-.321c0-.979-.44-1.906-1.197-2.525a4.725 4.725 0 0 0-3.49-1.04l-.155.016a5.1 5.1 0 0 0-1.992.644l.088-1.87Zm-.858-1.15a.664.664 0 0 0 .463-.84l-.027-.087a.543.543 0 0 0-.443-.375"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconMuscle = makeIcon({
  displayName: 'NoteIconMuscle',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.168 1.58a2.31 2.31 0 0 0-2.535 2.876c.087.333.105.68.052 1.02l-1.07 6.845a.25.25 0 0 0 .156.271l2.226.872A15.042 15.042 0 0 0 9.482 14.5h1.153c.725 0 1.447-.102 2.143-.302A2.38 2.38 0 0 0 14.5 11.91v-.223c0-.83-.386-1.615-1.045-2.121l-.097-.075a5.024 5.024 0 0 0-3.563-1.017l-.352.035a5.917 5.917 0 0 0-3.596 1.704l-.08.08a.158.158 0 0 1-.004.004l-.733.733a.75.75 0 0 1-1.06-1.06l.53-.53.2-3.967-.017.004a.75.75 0 1 1-.366-1.454l1-.252h.002l.056-.015c.624-.155.983-.81.78-1.42l-.012-.034a1.045 1.045 0 0 0-.854-.705l-.12-.016Zm.9 6.548a7.417 7.417 0 0 1 3.225-1.111l.353-.035a6.524 6.524 0 0 1 4.627 1.32l.097.075a4.177 4.177 0 0 1 1.63 3.31v.223a3.88 3.88 0 0 1-2.807 3.729 9.245 9.245 0 0 1-2.558.361H9.482c-2.064 0-4.11-.386-6.032-1.139l-2.226-.872a1.75 1.75 0 0 1-1.091-1.9l1.07-6.844a.998.998 0 0 0-.021-.408C.494 2.22 2.68-.26 5.365.094l.12.015a2.545 2.545 0 0 1 2.081 1.719l.012.034A2.604 2.604 0 0 1 6.224 5.04l-.156 3.089Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconMuscleSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMicrophoneSmall = makeIcon({
  displayName: 'NoteIconMicrophoneSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M5.258 7.777a.7.7 0 0 0-.99-.99l-.303.303a.7.7 0 1 0 .99.99l.303-.303Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.48 1.334a3.7 3.7 0 1 1 2.898 6.305l-5.541 3.958A1.712 1.712 0 0 1 .449 9.21l3.958-5.541A3.685 3.685 0 0 1 5.48 1.334Zm4.661 3.67a2.301 2.301 0 0 0-3.1-3.099l3.1 3.1Zm-4.09-2.109a2.301 2.301 0 0 0 3.1 3.1l-3.1-3.1Zm-.57 3.671c.298.3.635.536.995.711l-4.453 3.181a.312.312 0 0 1-.435-.435l3.18-4.453c.176.36.413.697.712.996Z"
        />
      </g>
    </>
  ),
})

export const NoteIconMicrophone = makeIcon({
  displayName: 'NoteIconMicrophone',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M6.997 10.131a.75.75 0 0 0-1.06-1.06l-.413.412a.75.75 0 1 0 1.06 1.06l.413-.412Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.585 1.655a4.83 4.83 0 1 1 3.727 8.235L3.73 15.306A2.126 2.126 0 0 1 .764 12.34L6.18 4.757a4.812 4.812 0 0 1 1.405-3.102Zm6.24 5.18a3.331 3.331 0 0 0-4.59-4.59l4.59 4.59Zm-5.65-3.53a3.331 3.331 0 0 0 4.59 4.59l-4.59-4.59Zm-.59 5.18a4.814 4.814 0 0 0 1.617 1.07l-6.344 4.53a.626.626 0 0 1-.874-.873l4.532-6.344c.236.589.592 1.14 1.069 1.617Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconMicrophoneSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBoomSmall = makeIcon({
  displayName: 'NoteIconBoomSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.018.004A1.5 1.5 0 0 1 6.561 1.05l.281.892 1.012-.707a1.5 1.5 0 0 1 2.215 1.873l-.626 1.316 1.454.507a1.5 1.5 0 0 1-.314 2.905l-1.713.206v.564a1.5 1.5 0 0 1-2.61 1.01l-.652 1.487a1.5 1.5 0 0 1-2.87-.705l.125-1.828-.586.22A1.5 1.5 0 0 1 .674 6.34l1.013-1.041-.658-.667a1.5 1.5 0 0 1 1.493-2.492l.945.28.181-1.153A1.5 1.5 0 0 1 5.018.004Zm1.008 4.338L5.13 1.5l-.448 2.842-2.586-.765 1.69 1.713L1.75 7.385l2.77-1.039-.286 4.154 1.67-3.808L7.37 8.605V6.711l3.034-.365L7.37 5.29l1.344-2.827-2.688 1.88Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconBoom = makeIcon({
  displayName: 'NoteIconBoom',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.77.004A1.5 1.5 0 0 1 8.314 1.05l.68 2.155 2.206-1.543a1.5 1.5 0 0 1 2.215 1.874L12.19 6.107l2.802.976a1.5 1.5 0 0 1-.314 2.906l-3.061.368v1.406a1.5 1.5 0 0 1-2.69.913l-.574-.748-1.392 3.174a1.5 1.5 0 0 1-2.87-.705l.252-3.674-1.817.681a1.5 1.5 0 0 1-1.603-2.45l1.918-1.972-1.41-1.428a1.5 1.5 0 0 1 1.494-2.492l2.094.62.38-2.416A1.5 1.5 0 0 1 6.77.004Zm-.535 5.601L2.5 4.5l2.441 2.474L2 10l4-1.5-.412 6L8 9l2.118 2.763V9.026L14.5 8.5l-4.382-1.526 1.94-4.083-3.882 2.714L6.882 1.5l-.647 4.105Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconBoomSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconEarthAmericasSmall = makeIcon({
  displayName: 'NoteIconEarthAmericasSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.276 1.295a6 6 0 0 0 3.148 10.678.75.75 0 0 0 .298.02A6 6 0 1 0 2.333 1.25l-.035-.012a4.22 4.22 0 0 0-.022.058ZM2.15 3.67a4.502 4.502 0 0 0 2.52 6.63 2.25 2.25 0 0 0-.512-1.033l-.416-.477c-.74-.844-.663-2.008-.04-2.768A4.154 4.154 0 0 1 2.15 3.67Zm1.428-1.463c-.165.876.127 1.77.75 2.38a2.025 2.025 0 0 1 1.738-1.41 1.818 1.818 0 0 0 1.567-1.31l.016-.055A4.488 4.488 0 0 0 6 1.5c-.892 0-1.723.26-2.422.707Zm5.383.404A3.318 3.318 0 0 1 6.215 4.67a.535.535 0 0 0-.48.58h1.553c1.798 0 2.843 2.032 1.799 3.494-.175.245-.37.474-.582.687l-.687.687A4.501 4.501 0 0 0 8.961 2.61ZM5.303 6.75l-.044.006a.635.635 0 0 0-.388 1.047l.416.476c.37.422.639.92.79 1.459L7.444 8.37c.154-.154.295-.32.422-.498a.71.71 0 0 0-.578-1.122H5.303Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconEarthAmericas = makeIcon({
  displayName: 'NoteIconEarthAmericas',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm2.968-4.115A6.502 6.502 0 0 0 6.605 14.35l-.131-.656a3.25 3.25 0 0 0-.741-1.503l-.556-.635c-.966-1.105-.786-2.66.136-3.568a5.29 5.29 0 0 1-2.345-4.103Zm1.675-1.452A3.786 3.786 0 0 0 5.92 6.578a2.46 2.46 0 0 1 2.192-2.093 2.674 2.674 0 0 0 2.305-1.926l.152-.531A6.479 6.479 0 0 0 8 1.5a6.47 6.47 0 0 0-3.357.933Zm7.264.372-.047.166a4.174 4.174 0 0 1-3.598 3.007.963.963 0 0 0-.814 1.272h2.27c2.193 0 3.469 2.479 2.194 4.264-.225.314-.475.61-.749.883l-1.998 1.999a6.502 6.502 0 0 0 2.742-11.591ZM7.053 8.75l-.077.011a1.096 1.096 0 0 0-.67 1.807l.556.635a4.75 4.75 0 0 1 1.083 2.196l.016.08 2.142-2.142c.215-.215.412-.448.588-.695.566-.792 0-1.892-.973-1.892H7.053Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconEarthAmericasSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconPencil2Small = makeIcon({
  displayName: 'NoteIconPencil2Small',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.025 5.054A2.95 2.95 0 1 1 5.197.882l5.445 5.445a.749.749 0 0 1 .197.348l1.037 4.148a.75.75 0 0 1-.91.91l-4.148-1.037a.75.75 0 0 1-.348-.197L1.025 5.053Zm.794-1.428 1.95-1.95a1.45 1.45 0 0 0-1.95 1.95Zm3.061-.94-.495.495 3.8 3.8.66-.33L4.88 2.686Zm4.73 5.26-1.014.507-.507 1.014 1.119.28.682-.683-.28-1.118Zm-2.815.756L2.83 4.737l.495-.495 3.8 3.8-.33.66Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconPencil2 = makeIcon({
  displayName: 'NoteIconPencil2',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.25 6.664A3.828 3.828 0 0 1 6.665 1.25l7.618 7.618a.75.75 0 0 1 .197.348l1.451 5.805a.75.75 0 0 1-.91.909l-5.803-1.451a.75.75 0 0 1-.349-.197L1.251 6.664Zm.845-1.309 3.26-3.26a2.329 2.329 0 0 0-3.26 3.26ZM6.432 3.14 5.316 4.255l5.682 5.682 1.488-.744L6.432 3.14Zm6.819 7.347-1.842.921-.921 1.843 2.09.522 1.196-1.194-.523-2.092Zm-4.058 1.998L3.14 6.432l1.116-1.116 5.681 5.681-.744 1.488Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconPencil2Small,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconSunnySmall = makeIcon({
  displayName: 'NoteIconSunnySmall',
  viewBox: 12,
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M6 3.3a2.7 2.7 0 1 0 0 5.4 2.7 2.7 0 0 0 0-5.4ZM4.7 6a1.3 1.3 0 1 1 2.6 0 1.3 1.3 0 0 1-2.6 0Z" />
        <path d="M6.55.316a.7.7 0 0 0-1.1 0l-.906 1.148a.8.8 0 0 1-.721.299l-1.454-.17a.7.7 0 0 0-.776.776l.17 1.453a.8.8 0 0 1-.298.722L.316 5.45a.7.7 0 0 0 0 1.1l1.149.906a.8.8 0 0 1 .298.721l-.17 1.453a.7.7 0 0 0 .776.777l1.454-.17a.8.8 0 0 1 .72.298l.908 1.149a.7.7 0 0 0 1.098 0l.907-1.149a.8.8 0 0 1 .721-.298l1.454.17a.7.7 0 0 0 .777-.777l-.171-1.453a.8.8 0 0 1 .299-.721l1.148-.907a.7.7 0 0 0 0-1.099l-1.148-.906a.8.8 0 0 1-.3-.722l.172-1.453a.7.7 0 0 0-.777-.777l-1.454.171a.8.8 0 0 1-.72-.299L6.548.316Zm-.907 2.016L6 1.879l.358.453a2.2 2.2 0 0 0 1.983.821l.573-.067-.068.573a2.2 2.2 0 0 0 .822 1.983L10.12 6l-.453.357a2.2 2.2 0 0 0-.822 1.984l.068.572-.573-.067a2.2 2.2 0 0 0-1.983.822L6 10.12l-.357-.452a2.2 2.2 0 0 0-1.984-.822l-.573.067.068-.572a2.2 2.2 0 0 0-.822-1.984L1.88 6l.452-.358a2.2 2.2 0 0 0 .822-1.983l-.068-.573.573.067a2.2 2.2 0 0 0 1.984-.821Z" />
      </g>
    </>
  ),
})

export const NoteIconSunny = makeIcon({
  displayName: 'NoteIconSunny',
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M8 4.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z" />
        <path d="M8.589.285a.75.75 0 0 0-1.178 0L6.134 1.902a1.25 1.25 0 0 1-1.127.467l-2.046-.24a.75.75 0 0 0-.832.832l.24 2.046a1.25 1.25 0 0 1-.467 1.127L.285 7.411a.75.75 0 0 0 0 1.178l1.617 1.277c.341.269.518.695.467 1.127l-.24 2.046a.75.75 0 0 0 .832.832l2.046-.24a1.25 1.25 0 0 1 1.127.467l1.277 1.617a.75.75 0 0 0 1.178 0l1.277-1.617a1.25 1.25 0 0 1 1.127-.467l2.046.24a.75.75 0 0 0 .832-.832l-.24-2.046a1.25 1.25 0 0 1 .467-1.127l1.617-1.277a.75.75 0 0 0 0-1.178l-1.617-1.277a1.25 1.25 0 0 1-.467-1.127l.24-2.046a.75.75 0 0 0-.832-.832l-2.046.24a1.25 1.25 0 0 1-1.127-.467L8.589.285ZM7.31 2.832 8 1.96l.688.872a2.75 2.75 0 0 0 2.48 1.027l1.103-.13-.13 1.103a2.75 2.75 0 0 0 1.027 2.48L14.04 8l-.872.688a2.75 2.75 0 0 0-1.027 2.48l.13 1.103-1.104-.13a2.75 2.75 0 0 0-2.479 1.027L8 14.04l-.689-.872a2.75 2.75 0 0 0-2.479-1.027l-1.103.13.13-1.104a2.75 2.75 0 0 0-1.027-2.479L1.96 8l.872-.689a2.75 2.75 0 0 0 1.027-2.479l-.13-1.103 1.103.13a2.75 2.75 0 0 0 2.48-1.027Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconSunnySmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconExclamationSmall = makeIcon({
  displayName: 'NoteIconExclamationSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3 0a1.5 1.5 0 0 0-1.496 1.598l.277 4.25A1.5 1.5 0 0 0 5.578 7.25h.844A1.5 1.5 0 0 0 7.92 5.848l.277-4.25A1.5 1.5 0 0 0 6.7 0H5.3Zm0 1.5h1.4l-.278 4.25h-.844L5.3 1.5ZM5.438 7.75a1.5 1.5 0 0 0-1.5 1.5v1.125a1.5 1.5 0 0 0 1.5 1.5h1.125a1.5 1.5 0 0 0 1.5-1.5V9.25a1.5 1.5 0 0 0-1.5-1.5H5.438Zm0 1.5h1.125v1.125H5.438V9.25Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconExclamation = makeIcon({
  displayName: 'NoteIconExclamation',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.059 0A1.75 1.75 0 0 0 5.31 1.85l.386 6.75a1.75 1.75 0 0 0 1.747 1.65h1.111a1.75 1.75 0 0 0 1.748-1.65l.385-6.75A1.75 1.75 0 0 0 8.941 0H7.06Zm-.25 1.764a.25.25 0 0 1 .25-.264H8.94a.25.25 0 0 1 .25.264l-.386 6.75a.25.25 0 0 1-.25.236h-1.11a.25.25 0 0 1-.25-.236l-.386-6.75ZM7.25 11a1.75 1.75 0 0 0-1.75 1.75v1.5c0 .966.783 1.75 1.75 1.75h1.5a1.75 1.75 0 0 0 1.75-1.75v-1.5A1.75 1.75 0 0 0 8.75 11h-1.5ZM7 12.75a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconExclamationSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMoneyWithWingsSmall = makeIcon({
  displayName: 'NoteIconMoneyWithWingsSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.015 8.484a1.5 1.5 0 0 1 0-2.122l1.21-1.21a3.4 3.4 0 0 1-1.77-.938 1.083 1.083 0 0 1 0-1.532l1.326-1.326A3.417 3.417 0 0 1 6.3 1.078l.549-.55a1.5 1.5 0 0 1 2.121 0l2.387 2.387a1.5 1.5 0 0 1 0 2.122l-.548.548a3.417 3.417 0 0 1-.277 4.519L9.206 11.43a1.083 1.083 0 0 1-1.532 0 3.401 3.401 0 0 1-.94-1.771L5.523 10.87a1.5 1.5 0 0 1-2.121 0L1.015 8.484Zm4.2-4.2.072-.07.35-.35 2.361 2.41-.324.324-.02.02-.893.893-2.336-2.437.79-.79Zm.01-2.131a1.917 1.917 0 0 0-2.383.263l-1 1c.722.459 1.683.389 2.33-.21l1.052-1.053ZM9.733 6.66 8.72 7.673a1.917 1.917 0 0 0-.248 2.37l.999-1a1.917 1.917 0 0 0 .263-2.383Zm-6.37-.525L2.076 7.423l2.386 2.386L5.7 8.571 3.364 6.135Zm3.333-3.334L9.06 5.213l1.237-1.237-2.387-2.387-1.212 1.212Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconMoneyWithWings = makeIcon({
  displayName: 'NoteIconMoneyWithWings',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 6.69 1.53 8.662a1.75 1.75 0 0 0 0 2.475l3.182 3.182a1.75 1.75 0 0 0 2.475 0l1.973-1.972c.074.99.49 1.96 1.248 2.718a1.195 1.195 0 0 0 1.69 0l1.767-1.767a4.306 4.306 0 0 0 .209-5.866l.891-.891a1.75 1.75 0 0 0 0-2.475L11.783.883a1.75 1.75 0 0 0-2.474 0l-.893.893a4.306 4.306 0 0 0-5.864.21L.784 3.752a1.194 1.194 0 0 0 0 1.69A4.289 4.289 0 0 0 3.5 6.69Zm-.909 3.032a.25.25 0 0 0 0 .354l3.182 3.181a.25.25 0 0 0 .354 0l1.823-1.823-3.461-3.61L2.59 9.722ZM5.55 6.763l3.461 3.61 1.37-1.37.027-.028.608-.607-3.498-3.571-.645.645a4.335 4.335 0 0 1-.082.08L5.55 6.763ZM7.35 2.841 5.746 4.446a2.806 2.806 0 0 1-3.674.14l1.54-1.54a2.806 2.806 0 0 1 3.74-.205Zm1.228.895.062-.062.041-.043 1.687-1.687a.25.25 0 0 1 .354 0l3.182 3.182a.25.25 0 0 1 0 .353L12.19 7.193l-.015.015-.1.1L8.58 3.735Zm2.686 10.04a2.806 2.806 0 0 1 .182-3.717l1.562-1.563a2.806 2.806 0 0 1-.204 3.74l-1.54 1.54Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconMoneyWithWingsSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconTestTubeSmall = makeIcon({
  displayName: 'NoteIconTestTubeSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 1.553a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .375 1.4v2.216l2.273 2.762a.688.688 0 0 1 .02.025l.522.635c1.007 1.223.137 3.066-1.448 3.066H2.757c-1.584 0-2.454-1.843-1.447-3.066L4.125 4.42V2.202a.75.75 0 0 1-.375-.65Zm1.875.75v2.385a.75.75 0 0 1-.17.477L4.53 6.288c.543.071 1.102.247 1.758.52.742.31 1.339.388 1.899.351L6.546 5.165a.75.75 0 0 1-.171-.477V2.303h-.75Zm3.67 6.204c-.988.214-2.102.303-3.584-.314-.64-.267-1.083-.39-1.46-.428a3.06 3.06 0 0 0-.996.073l-.787.956a.375.375 0 0 0 .29.613h6.484c.317 0 .491-.368.29-.613l-.236-.287Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconTestTube = makeIcon({
  displayName: 'NoteIconTestTube',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 2.07A.75.75 0 0 1 6 1.32h4a.75.75 0 0 1 .25 1.458v3.204l3.09 3.756a.79.79 0 0 1 .02.025l.7.85c1.209 1.469.164 3.68-1.737 3.68H3.677c-1.901 0-2.946-2.211-1.738-3.68l3.811-4.63V2.777a.75.75 0 0 1-.5-.708Zm2 .75v3.431a.75.75 0 0 1-.17.476L5.545 8.59c.099.005.199.012.3.023.742.075 1.51.307 2.442.696 1.244.518 2.201.567 3.116.437L8.921 6.727a.75.75 0 0 1-.171-.476v-3.43h-1.5Zm5.24 8.245c-1.328.302-2.794.455-4.779-.372-.866-.36-1.48-.534-2.017-.588-.479-.049-.933-.008-1.493.12l-1.104 1.342a.75.75 0 0 0 .58 1.226h8.646a.75.75 0 0 0 .58-1.226l-.413-.502Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconTestTubeSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconCouchAndLampSmall = makeIcon({
  displayName: 'NoteIconCouchAndLampSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.875 5.457A2.016 2.016 0 0 1 12 7.266v2.109a1.5 1.5 0 0 1-1.5 1.5H10v.375a.75.75 0 0 1-1.5 0v-.375h-5v.375a.75.75 0 0 1-1.5 0v-.375h-.5a1.5 1.5 0 0 1-1.5-1.5v-2.11c0-.793.458-1.48 1.125-1.808v-.582a4.875 4.875 0 1 1 9.75 0v.582Zm-1.5-.113A2.019 2.019 0 0 0 8.002 6.9H3.998a2.019 2.019 0 0 0-1.373-1.556v-.469a3.375 3.375 0 0 1 6.75 0v.469ZM2.015 6.75a.516.516 0 0 0-.515.516v2.109h9v-2.11a.516.516 0 0 0-1.031 0V8.4H2.53V7.266a.516.516 0 0 0-.515-.516Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconCouchAndLamp = makeIcon({
  displayName: 'NoteIconCouchAndLamp',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 7.48V6.5a6.5 6.5 0 0 1 13 0v.98A2.563 2.563 0 0 1 16 9.812V12.5a1.75 1.75 0 0 1-1.75 1.75H13v1a.75.75 0 0 1-1.5 0v-1h-7v1a.75.75 0 0 1-1.5 0v-1H1.75A1.75 1.75 0 0 1 0 12.5V9.812C0 8.777.615 7.885 1.5 7.48ZM8 1.5a5 5 0 0 1 5 5v.787a2.565 2.565 0 0 0-2.1 2.163H5.1A2.564 2.564 0 0 0 3 7.287V6.5a5 5 0 0 1 5-5ZM1.5 9.813a1.063 1.063 0 0 1 2.125 0v1.137h8.75V9.813a1.063 1.063 0 0 1 2.125 0V12.5a.25.25 0 0 1-.25.25H1.75a.25.25 0 0 1-.25-.25V9.812Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconCouchAndLampSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconTennisSmall = makeIcon({
  displayName: 'NoteIconTennisSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.129 8.813a5.625 5.625 0 1 1 9.742-5.625A5.625 5.625 0 0 1 1.13 8.813Zm2.808-6.385a4.106 4.106 0 0 0-1.642 1.757 5.373 5.373 0 0 1 3.423 5.931 4.105 4.105 0 0 0 2.344-.543 4.106 4.106 0 0 0 1.644-1.76 5.374 5.374 0 0 1-3.425-5.928 4.106 4.106 0 0 0-2.344.543Zm3.805-.167A3.872 3.872 0 0 0 10.11 6.36a4.106 4.106 0 0 0-.538-2.422 4.106 4.106 0 0 0-1.83-1.677ZM2.428 8.063a4.106 4.106 0 0 1-.537-2.425A3.872 3.872 0 0 1 4.258 9.74a4.106 4.106 0 0 1-1.83-1.677Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconTennis = makeIcon({
  displayName: 'NoteIconTennis',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.721 11.626a7.25 7.25 0 1 1 12.558-7.25 7.25 7.25 0 0 1-12.558 7.25ZM5.125 3.02a5.724 5.724 0 0 0-2.407 2.706c3.335 1.078 5.343 4.557 4.608 7.984a5.725 5.725 0 0 0 3.549-.73 5.725 5.725 0 0 0 2.408-2.71C9.95 9.193 7.94 5.715 8.673 2.29a5.724 5.724 0 0 0-3.548.73Zm5.004-.362c-.533 2.641 1.007 5.308 3.562 6.166a5.725 5.725 0 0 0-.711-3.7 5.725 5.725 0 0 0-2.85-2.466ZM3.02 10.875a5.726 5.726 0 0 1-.71-3.703c2.556.858 4.096 3.527 3.56 6.17a5.725 5.725 0 0 1-2.85-2.466Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconTennisSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBalloonSmall = makeIcon({
  displayName: 'NoteIconBalloonSmall',
  viewBox: 12,
  content: (
    <>
      <path
        d="M6.124 2.5a.7.7 0 0 1 .94-.314A2.057 2.057 0 0 1 8.2 4.026v.099a.7.7 0 1 1-1.4 0v-.099a.657.657 0 0 0-.363-.587.7.7 0 0 1-.313-.94Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.682.814a4.055 4.055 0 0 0-1.275 5.208l.105.2a7.367 7.367 0 0 0 2.406 2.691l.05.034c.099.067.207.117.321.149a.425.425 0 0 1-.414.329h-.75A1.825 1.825 0 0 0 2.3 11.25a.7.7 0 1 0 1.4 0c0-.235.19-.425.425-.425h.75c.975 0 1.77-.764 1.822-1.725.12-.032.232-.084.335-.153l.05-.034a7.367 7.367 0 0 0 2.406-2.69l.105-.2a4.055 4.055 0 0 0-5.91-5.21Zm2.64 6.923a5.967 5.967 0 0 0 1.926-2.163l.105-.201a2.655 2.655 0 1 0-4.706 0l.106.2a5.967 5.967 0 0 0 1.925 2.164h.644Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconBalloon = makeIcon({
  displayName: 'NoteIconBalloon',
  content: (
    <>
      <path
        d="M8.33 3.415a.75.75 0 0 1 1.005-.336 2.56 2.56 0 0 1 1.415 2.29V5.5a.75.75 0 0 1-1.5 0v-.132c0-.4-.227-.768-.585-.947a.75.75 0 0 1-.336-1.006Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.91 1.152a5.407 5.407 0 0 0-1.7 6.944l.14.268a9.823 9.823 0 0 0 3.207 3.587l.067.045c.188.127.403.209.626.24v.014a.75.75 0 0 1-.75.75h-1a2.25 2.25 0 0 0-2.25 2.25.75.75 0 0 0 1.5 0 .75.75 0 0 1 .75-.75h1a2.25 2.25 0 0 0 2.25-2.264c.223-.031.438-.113.626-.24l.067-.045a9.822 9.822 0 0 0 3.207-3.587l.14-.268a5.407 5.407 0 0 0-7.88-6.944ZM8.54 10.75l.063-.042a8.323 8.323 0 0 0 2.718-3.04l.14-.267a3.907 3.907 0 1 0-6.924 0l.14.268a8.323 8.323 0 0 0 2.718 3.039l.063.042H8.54Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconBalloonSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconAnchorSmall = makeIcon({
  displayName: 'NoteIconAnchorSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.75 3.855a2 2 0 1 0-1.5 0v6.558a3.065 3.065 0 0 1-2.306-2.566.75.75 0 0 0 .987-1.128L2.573 5.453a.75.75 0 0 0-1.06.037L.247 6.847A.75.75 0 1 0 1.344 7.87l.085-.09A4.563 4.563 0 0 0 5.98 12H6.014a4.563 4.563 0 0 0 4.517-4.235l.098.106a.75.75 0 1 0 1.097-1.023L10.46 5.49a.75.75 0 0 0-1.06-.037L8.043 6.72a.75.75 0 0 0 .97 1.142 3.066 3.066 0 0 1-2.263 2.541V3.855ZM6 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconAnchor = makeIcon({
  displayName: 'NoteIconAnchor',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.742 4.888a2.501 2.501 0 1 0-1.484 0A.756.756 0 0 0 7.25 5v9.191a4.752 4.752 0 0 1-3.993-4.43l.51.477a.75.75 0 0 0 1.024-1.097L2.98 7.453a.75.75 0 0 0-1.06.037L.233 9.3a.75.75 0 0 0 1.097 1.023l.43-.461A6.25 6.25 0 0 0 8 15.75H8a6.25 6.25 0 0 0 6.24-5.888l.43.462A.75.75 0 1 0 15.767 9.3l-1.688-1.81a.75.75 0 0 0-1.06-.037l-1.81 1.688a.75.75 0 0 0 1.023 1.097l.51-.477a4.752 4.752 0 0 1-3.992 4.43V5a.756.756 0 0 0-.008-.112ZM8 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconAnchorSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconSchoolSatchelSmall = makeIcon({
  displayName: 'NoteIconSchoolSatchelSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M5.438 4.5a.563.563 0 0 0 0 1.125h1.125a.563.563 0 0 0 0-1.125H5.438Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.85 2.2a2.15 2.15 0 1 1 4.3 0v.028a5.063 5.063 0 0 1 2.912 4.584V10.5a1.5 1.5 0 0 1-1.5 1.5H2.439a1.5 1.5 0 0 1-1.5-1.5V6.812A5.063 5.063 0 0 1 3.85 2.229V2.2ZM6 1.35a.85.85 0 0 1 .753.456 5.103 5.103 0 0 0-1.506 0A.85.85 0 0 1 6 1.35Zm3.563 9.15V6.812a3.563 3.563 0 0 0-7.126 0V10.5h7.126Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 7.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-1.5Zm1.3.95v-.4h1.9v.4h-1.9Z"
        />
      </g>
    </>
  ),
})

export const NoteIconSchoolSatchel = makeIcon({
  displayName: 'NoteIconSchoolSatchel',
  content: (
    <>
      <path
        d="M6.5 6.75A.75.75 0 0 1 7.25 6h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2Zm1.5 1.5v-1h3v1h-3Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0a2.25 2.25 0 0 0-2.25 2.25v.134a6.753 6.753 0 0 0-4.5 6.366V14a2 2 0 0 0 2 2h9.5a2 2 0 0 0 2-2V8.75a6.753 6.753 0 0 0-4.5-6.366V2.25A2.25 2.25 0 0 0 8 0Zm.72 2.038a.75.75 0 0 0-1.44 0 6.828 6.828 0 0 1 1.44 0Zm4.53 6.712V14a.5.5 0 0 1-.5.5h-9.5a.5.5 0 0 1-.5-.5V8.75a5.25 5.25 0 0 1 10.5 0Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconSchoolSatchelSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconAppleSmall = makeIcon({
  displayName: 'NoteIconAppleSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.541 1.374A.75.75 0 0 0 6.709.126a3.274 3.274 0 0 0-.875.858A2.166 2.166 0 0 0 4.571.178a1.948 1.948 0 0 0-2.308 2.366c.064.265.177.51.328.726a3.45 3.45 0 0 0-1.543 4.555l.333.7a7.578 7.578 0 0 0 1.274 1.882l.738.8c.44.478 1.13.634 1.734.392a2.351 2.351 0 0 1 1.746 0l.025.01a1.574 1.574 0 0 0 1.712-.363l.73-.748a7.288 7.288 0 0 0 1.442-2.13l.243-.547A3.5 3.5 0 0 0 6.75 3.07v-.218c0-.594.297-1.148.791-1.478Zm-2.614 1.46-.17-.697a.666.666 0 0 0-.506-.493.448.448 0 0 0-.53.544c.06.248.256.44.505.494l.7.153ZM4.93 4.55l.424.181c.412.177.878.177 1.29 0l.393-.168a2 2 0 0 1 2.616 2.65l-.243.548a5.787 5.787 0 0 1-1.146 1.69l-.73.75a.074.074 0 0 1-.08.016l-.025-.01a3.85 3.85 0 0 0-2.86 0 .067.067 0 0 1-.075-.016l-.738-.8a6.08 6.08 0 0 1-1.022-1.51l-.333-.7a1.95 1.95 0 0 1 2.53-2.631Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconApple = makeIcon({
  displayName: 'NoteIconApple',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.124.584a.75.75 0 0 1-.208 1.04 2.618 2.618 0 0 0-1.165 2.13 5.05 5.05 0 0 1 5.08 1.169l.214.207a4.63 4.63 0 0 1 .99 5.261 14.462 14.462 0 0 1-2.959 4.233l-.704.699c-.514.51-1.28.67-1.955.409l-.598-.232a2.27 2.27 0 0 0-1.638 0l-.503.195a1.955 1.955 0 0 1-2.12-.474l-.668-.7a15.745 15.745 0 0 1-2.736-3.915 4.993 4.993 0 0 1 .911-5.698l.076-.077c.318-.326.7-.58 1.12-.75l-.001-.003c-.41-1.686 1.086-3.22 2.781-2.85.622.136 1.16.487 1.533.974A4.118 4.118 0 0 1 9.084.376a.75.75 0 0 1 1.04.208ZM8.53 5.452a1.136 1.136 0 0 1-1.371.993l-1.897-.413a2.636 2.636 0 0 1-1.22-.632 1.786 1.786 0 0 0-.83.48l-.075.077A3.493 3.493 0 0 0 2.5 9.944c.64 1.3 1.475 2.494 2.475 3.542l.668.7a.455.455 0 0 0 .494.11l.503-.195a3.77 3.77 0 0 1 2.72 0l.598.231a.336.336 0 0 0 .357-.074l.705-.699a12.963 12.963 0 0 0 2.651-3.794 3.131 3.131 0 0 0-.668-3.557L12.788 6a3.55 3.55 0 0 0-3.828-.727l-.43.178ZM6.586 3.537l.32 1.318-1.325-.29a1.139 1.139 0 0 1-.864-.842.848.848 0 0 1 1.005-1.03c.425.094.76.42.864.844Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconAppleSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconRadioSmall = makeIcon({
  displayName: 'NoteIconRadioSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 7.25a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z"
        />
        <path d="M7.75 5.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM7.75 7.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.099.378a.75.75 0 0 1 1.023-.28L9.2 3h.926C11.161 3 12 3.84 12 4.875v4.75c0 1.035-.84 1.875-1.875 1.875h-8.25A1.875 1.875 0 0 1 0 9.625v-4.75C0 3.839.84 3 1.875 3h4.301L3.378 1.4a.75.75 0 0 1-.28-1.022ZM1.875 4.5a.375.375 0 0 0-.375.375v4.75c0 .207.168.375.375.375h8.25a.375.375 0 0 0 .375-.375v-4.75a.375.375 0 0 0-.375-.375h-8.25Z"
        />
      </g>
    </>
  ),
})

export const NoteIconRadio = makeIcon({
  displayName: 'NoteIconRadio',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 9.5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Zm2.75-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
        fill="currentcolor"
      />
      <path
        d="M10 7.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2ZM10 10a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.349.628a.75.75 0 0 1 1.023-.28L12.2 4.25h1.551A2.25 2.25 0 0 1 16 6.5v6a2.25 2.25 0 0 1-2.25 2.25H2.25A2.25 2.25 0 0 1 0 12.5v-6a2.25 2.25 0 0 1 2.25-2.25h6.926l-4.548-2.6a.75.75 0 0 1-.28-1.022ZM2.25 5.75a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75H2.25Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconRadioSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconBasketSmall = makeIcon({
  displayName: 'NoteIconBasketSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.999 8.887A5.775 5.775 0 1 1 11 3.113 5.775 5.775 0 0 1 .999 8.887Zm.915-4.713a4.45 4.45 0 0 1 1.31-1.684L5.113 5.76l-.566.327a5.448 5.448 0 0 0-2.633-1.914Zm1.497 2.57a4.155 4.155 0 0 0-1.85-1.315c-.095.736-.008 1.5.28 2.222l1.57-.907Zm-.92 2.033 1.57-.907c.273.702.36 1.481.216 2.26A4.453 4.453 0 0 1 2.49 8.777Zm2.707-1.563.565-.327 1.89 3.272a4.451 4.451 0 0 1-2.113.292 5.448 5.448 0 0 0-.342-3.237Zm1.69-.977 1.89 3.272a4.45 4.45 0 0 0 1.307-1.684 5.448 5.448 0 0 1-2.632-1.913l-.564.325Zm1.7-.981a4.155 4.155 0 0 0 1.85 1.315c.095-.736.009-1.5-.279-2.222l-1.57.907Zm.921-2.033-1.57.907a4.155 4.155 0 0 1-.216-2.26 4.453 4.453 0 0 1 1.786 1.353ZM6.802 4.786l-.563.325-1.889-3.27a4.45 4.45 0 0 1 2.11-.292 5.448 5.448 0 0 0 .342 3.237Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconBasket = makeIcon({
  displayName: 'NoteIconBasket',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.723 11.626a7.25 7.25 0 1 1 12.557-7.25 7.25 7.25 0 0 1-12.557 7.25Zm.995-5.896a5.72 5.72 0 0 1 1.784-2.293l2.476 4.289-.84.485a6.837 6.837 0 0 0-3.42-2.48ZM4.83 8.966a5.345 5.345 0 0 0-2.52-1.79 5.723 5.723 0 0 0 .379 3.027l2.14-1.237Zm-1.391 2.536 2.141-1.237c.387.95.507 2.016.293 3.078a5.722 5.722 0 0 1-2.434-1.841Zm3.45-1.993.84-.484 2.475 4.288a5.72 5.72 0 0 1-2.875.4 6.837 6.837 0 0 0-.44-4.204Zm2.138-1.234 2.476 4.288a5.72 5.72 0 0 0 1.782-2.292 6.837 6.837 0 0 1-3.42-2.48l-.838.484Zm2.147-1.24a5.346 5.346 0 0 0 2.518 1.79c.146-1 .03-2.045-.378-3.025l-2.14 1.236Zm1.39-2.534-2.14 1.236a5.346 5.346 0 0 1-.293-3.077c.94.374 1.787.997 2.433 1.841Zm-3.45 1.992-.837.483-2.475-4.288a5.72 5.72 0 0 1 2.873-.398 6.837 6.837 0 0 0 .44 4.203Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconBasketSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconScalesSmall = makeIcon({
  displayName: 'NoteIconScalesSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 .287a.65.65 0 0 1 .65.65v.475H10a.65.65 0 0 1 .63.489l1.25 4.875c.013.053.02.107.02.161v.438a2.275 2.275 0 0 1-4.55 0v-.438a.65.65 0 0 1 .02-.161l1.042-4.064H6.65V10.6h.85a.65.65 0 1 1 0 1.3h-3a.65.65 0 0 1 0-1.3h.85V2.712H3.588L4.63 6.776a.65.65 0 0 1 .02.161v.438a2.275 2.275 0 0 1-4.55 0v-.438a.65.65 0 0 1 .02-.161L1.37 1.9A.65.65 0 0 1 2 1.412h3.35V.937A.65.65 0 0 1 6 .287ZM2.375 8.35a.975.975 0 0 0 .952-.763H1.423a.975.975 0 0 0 .952.763Zm-.787-2.063h1.574l-.787-3.07-.787 3.07Zm8.989 1.3a.975.975 0 0 1-1.904 0h1.904Zm-.165-1.3H8.838l.787-3.07.787 3.07Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconScales = makeIcon({
  displayName: 'NoteIconScales',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 .5a.75.75 0 0 1 .75.75V2h4.5c.33 0 .62.215.717.53l2 6.5a.75.75 0 0 1 .033.22V10a2.25 2.25 0 0 1-2.25 2.25h-2A2.25 2.25 0 0 1 9.5 10v-.75a.75.75 0 0 1 .033-.22l1.702-5.53H8.75v11H10a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.25v-11H4.765l1.702 5.53a.75.75 0 0 1 .033.22V10a2.25 2.25 0 0 1-2.25 2.25h-2A2.25 2.25 0 0 1 0 10v-.75a.75.75 0 0 1 .033-.22l2-6.5A.75.75 0 0 1 2.75 2h4.5v-.75A.75.75 0 0 1 8 .5ZM3.25 3.675 1.765 8.5h2.97L3.25 3.675ZM1.5 10c0 .414.336.75.75.75h2A.75.75 0 0 0 5 10H1.5Zm9.765-1.5 1.485-4.825L14.235 8.5h-2.97Zm.485 2.25A.75.75 0 0 1 11 10h3.5a.75.75 0 0 1-.75.75h-2Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconScalesSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconClipboardSmall = makeIcon({
  displayName: 'NoteIconClipboardSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.125 1.5A1.872 1.872 0 0 0 7.678.75 2.244 2.244 0 0 0 6 0c-.667 0-1.266.29-1.678.75a1.872 1.872 0 0 0-1.447.75H2.25A1.5 1.5 0 0 0 .75 3v7.5a1.5 1.5 0 0 0 1.5 1.5h4.212a1.5 1.5 0 0 0 1.004-.385l3.287-2.96a1.5 1.5 0 0 0 .497-1.114V3a1.5 1.5 0 0 0-1.5-1.5h-.625ZM4 2.625c0 .207.168.375.375.375h3.25a.375.375 0 1 0 0-.75H6.75A.748.748 0 0 0 6 1.5a.75.75 0 0 0-.75.75h-.875A.375.375 0 0 0 4 2.625ZM9.462 3c-.173.856-.93 1.5-1.837 1.5h-3.25A1.876 1.876 0 0 1 2.538 3H2.25v7.5h3V8.25c0-1.036.84-1.875 1.875-1.875H9.75V3h-.288ZM7.125 7.875h2.254L6.75 10.241V8.25c0-.207.168-.375.375-.375Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconClipboard = makeIcon({
  displayName: 'NoteIconClipboard',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 1H10a2.496 2.496 0 0 0-2-1c-.818 0-1.544.393-2 1h-.5a2 2 0 0 0-1.855 1.25H3A1.75 1.75 0 0 0 1.25 4v10.25c0 .966.784 1.75 1.75 1.75h5.6c.45 0 .88-.172 1.206-.481l4.4-4.18a1.75 1.75 0 0 0 .544-1.268V4A1.75 1.75 0 0 0 13 2.25h-.645A2 2 0 0 0 10.5 1ZM5 3a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H9a1 1 0 1 0-2 0H5.5A.5.5 0 0 0 5 3Zm7.355.75A2 2 0 0 1 10.5 5h-5a2 2 0 0 1-1.855-1.25H3a.25.25 0 0 0-.25.25v10.25c0 .138.112.25.25.25h4.25V11A2.25 2.25 0 0 1 9.5 8.75h3.75V4a.25.25 0 0 0-.25-.25h-.645ZM9.5 10.25h3.674l-.002.002-4.4 4.18a.232.232 0 0 1-.022.018V11a.75.75 0 0 1 .75-.75Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconClipboardSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconPushpinSmall = makeIcon({
  displayName: 'NoteIconPushpinSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.51.407a.75.75 0 0 0-1.06 1.06l.046.047-2.111 2.112a3.196 3.196 0 0 0-3.127.817l-.288.289a.75.75 0 0 0 0 1.06l2.065 2.066L.97 9.923a.75.75 0 1 0 1.06 1.06l2.066-2.065 2.065 2.066a.75.75 0 0 0 1.06 0l.289-.289a3.196 3.196 0 0 0 .818-3.124l2.113-2.112.046.046a.75.75 0 0 0 1.06-1.06L7.51.407ZM4.677 5.464 6.49 7.276c.542.58.601 1.449.177 2.092L2.585 5.286a1.698 1.698 0 0 1 2.092.178Zm2.88.758L9.38 4.398 7.557 2.575 5.734 4.398l.046.045 1.73 1.73.047.049Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconPushpin = makeIcon({
  displayName: 'NoteIconPushpin',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.337 1.22a.75.75 0 0 0-1.06 1.06l.238.24-3.098 3.097a4.013 4.013 0 0 0-4.063.984l-.384.385a.75.75 0 0 0 0 1.06l2.93 2.93-2.93 2.931a.75.75 0 0 0 1.06 1.061l2.93-2.93 2.931 2.93a.75.75 0 0 0 1.061 0l.384-.384a4.013 4.013 0 0 0 .986-4.06l3.1-3.099.238.239a.75.75 0 1 0 1.06-1.06L9.337 1.22ZM5.912 7.607l2.419 2.418c.879.935.907 2.378.085 3.346l-5.85-5.85a2.513 2.513 0 0 1 3.346.086ZM9.406 8.98l.17.17 2.784-2.786L9.576 3.58 6.79 6.364l.167.168c.024.022.048.046.071.07l2.307 2.306.07.072Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconPushpinSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconAirplaneSmall = makeIcon({
  displayName: 'NoteIconAirplaneSmall',
  viewBox: 12,
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="m4.31 8.8.41 1.203c.128.378-.364.651-.617.343l-1.06-1.293-1.27-1.035c-.307-.251-.039-.742.338-.619l1.185.387 5.397-5.397a2.435 2.435 0 0 1 1.728-.712v.02a2.437 2.437 0 0 1-.714 1.706L4.31 8.8Zm7.611-7.122A1.5 1.5 0 0 0 10.426.177 3.935 3.935 0 0 0 7.63 1.329L2.886 6.074l-.309-.1C.62 5.333-.77 7.877.825 9.18l1.153.94.965 1.177c1.312 1.6 3.862.182 3.196-1.777l-.108-.32 4.737-4.737a3.937 3.937 0 0 0 1.153-2.785ZM4.673 8.676l-.066-.08.066.08Z" />
        <path d="M9.04 4.48a.75.75 0 0 1 .882.588l.69 3.453a2.184 2.184 0 0 1-.597 1.973l-.471.471a.75.75 0 0 1-1.149-.106L6.382 7.924a.75.75 0 1 1 1.236-.848l1.478 2.152a.684.684 0 0 0 .046-.413l-.69-3.453a.75.75 0 0 1 .588-.882ZM7.65 3.064a.75.75 0 0 0-.589-.882l-3.485-.697a2.184 2.184 0 0 0-1.973.597l-.471.471a.75.75 0 0 0 .108 1.15l3.066 2.085a.75.75 0 0 0 .843-1.24L2.872 3a.684.684 0 0 1 .41-.044l3.485.697a.75.75 0 0 0 .883-.589Z" />
      </g>
    </>
  ),
})

export const NoteIconAirplane = makeIcon({
  displayName: 'NoteIconAirplane',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m9.676 3.102 1.138-1.139A4.996 4.996 0 0 1 14.362.5a1.6 1.6 0 0 1 1.595 1.598 4.998 4.998 0 0 1-1.464 3.54L13.35 6.781l.984 4.921a2.75 2.75 0 0 1-.752 2.484l-.657.657a.75.75 0 0 1-1.15-.108l-2.582-3.796L7.67 12.46l.25.736c.752 2.213-2.13 3.815-3.612 2.008l-1.377-1.679-1.646-1.343c-1.802-1.47-.231-4.345 1.98-3.623l.718.234L5.518 7.26 1.719 4.677a.75.75 0 0 1-.108-1.15l.657-.658a2.75 2.75 0 0 1 2.484-.752l4.924.985Zm3.032-.58a3.396 3.396 0 0 1 1.62-.422h.029v.029a3.397 3.397 0 0 1-.995 2.378l-7.528 7.527.571 1.678c.18.527-.507.909-.86.478l-1.478-1.802-1.77-1.445c-.43-.35-.055-1.034.471-.862l1.652.539 7.525-7.525c.228-.228.485-.42.763-.573ZM8.4 4.376l-3.943-.788a1.25 1.25 0 0 0-1.13.342l-.016.016L6.597 6.18l1.804-1.804Zm1.871 5.483 1.803-1.803.788 3.94a1.25 1.25 0 0 1-.342 1.13l-.016.016-2.233-3.283Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconAirplaneSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconThoughtBalloonSmall = makeIcon({
  displayName: 'NoteIconThoughtBalloonSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.722 2.732a3.23 3.23 0 0 1-2.189 5.796A3.565 3.565 0 0 1 6 9.58a3.565 3.565 0 0 1-2.534-1.053 3.23 3.23 0 0 1-2.188-5.796A3.405 3.405 0 0 1 6 .294a3.405 3.405 0 0 1 4.722 2.438ZM6.16 1.946a1.904 1.904 0 0 1 3.113 1.703A1.732 1.732 0 1 1 7.914 6.81 2.074 2.074 0 0 1 6 8.08a2.074 2.074 0 0 1-1.914-1.27 1.721 1.721 0 0 1-.855.226 1.73 1.73 0 0 1-.504-3.387A1.904 1.904 0 0 1 6 2.098c.05-.054.104-.105.16-.152Z"
        fill="currentcolor"
      />
      <path d="M3 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentcolor" />
    </>
  ),
})

export const NoteIconThoughtBalloon = makeIcon({
  displayName: 'NoteIconThoughtBalloon',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8a3.995 3.995 0 0 0-1.79-3.334A4.25 4.25 0 0 0 8 1.499a4.25 4.25 0 0 0-6.21 3.167 4 4 0 0 0 2.816 7.288A4.489 4.489 0 0 0 8 13.5c1.356 0 2.57-.6 3.394-1.546A4 4 0 0 0 16 8Zm-6-5.5a2.739 2.739 0 0 0-2 .863A2.739 2.739 0 0 0 6 2.5a2.75 2.75 0 0 0-2.727 3.107 2.501 2.501 0 1 0 1.965 4.566A3 3 0 0 0 8 12a2.996 2.996 0 0 0 2.762-1.827A2.49 2.49 0 0 0 12 10.5a2.5 2.5 0 0 0 .727-4.893A2.75 2.75 0 0 0 10 2.5Z"
        fill="currentcolor"
      />
      <path
        d="M2.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconThoughtBalloonSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconRobotFaceSmall = makeIcon({
  displayName: 'NoteIconRobotFaceSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M4.875 4.5a.75.75 0 0 1 .75.75V6.5a.75.75 0 0 1-1.5 0V5.25a.75.75 0 0 1 .75-.75ZM7.875 5.25a.75.75 0 0 0-1.5 0V6.5a.75.75 0 0 0 1.5 0V5.25ZM7.25 8.5a.5.5 0 0 0-.5-.5h-1.5a.5.5 0 0 0-.5.5 1.25 1.25 0 1 0 2.5 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.837 2.25a1.875 1.875 0 1 0-3.675 0H3A2.25 2.25 0 0 0 .75 4.5v.75A.75.75 0 0 0 0 6v1.5c0 .414.336.75.75.75v1.5A2.25 2.25 0 0 0 3 12h6a2.25 2.25 0 0 0 2.25-2.25v-1.5A.75.75 0 0 0 12 7.5V6a.75.75 0 0 0-.75-.75V4.5A2.25 2.25 0 0 0 9 2.25H7.837Zm-2.212-.375a.375.375 0 1 1 .75 0 .375.375 0 0 1-.75 0ZM3 3.75a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75V4.5A.75.75 0 0 0 9 3.75H3Z"
        />
      </g>
    </>
  ),
})

export const NoteIconRobotFace = makeIcon({
  displayName: 'NoteIconRobotFace',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M6.5 6.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75ZM10.25 7a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0V7ZM9.5 11.5A.5.5 0 0 0 9 11H7a.5.5 0 0 0-.5.5 1.5 1.5 0 0 0 3 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 0a2.25 2.25 0 0 0-2.016 3.25H4A2.75 2.75 0 0 0 1.25 6v1.293A.749.749 0 0 0 .25 8v2a.75.75 0 0 0 1 .707v2.543A2.75 2.75 0 0 0 4 16h8a2.75 2.75 0 0 0 2.75-2.75v-2.543a.75.75 0 0 0 1-.707V8a.75.75 0 0 0-1-.707V6A2.75 2.75 0 0 0 12 3.25h-1.984A2.25 2.25 0 0 0 8 0Zm-.75 2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM2.75 6c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v7.25c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V6Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconRobotFaceSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconPeachSmall = makeIcon({
  displayName: 'NoteIconPeachSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.461 1.03A3.035 3.035 0 0 0 1.076.934 1.167 1.167 0 0 0 1.6 2.886l.05.014a3.195 3.195 0 0 0-.412.453C-.307 5.413.659 7.566 1.215 8.4a9.086 9.086 0 0 0 4.107 3.352c.444.178.928.167 1.358-.009.942-.384 3.331-1.536 4.482-3.841.92-1.842.465-4.312-1.288-5.35-.516-.306-1.077-.521-1.726-.542a3.82 3.82 0 0 0-1.448.258v-.28c0-.302.09-.598.257-.85A.7.7 0 1 0 5.793.362c-.14.208-.25.433-.332.668Zm-1.175.807a1.638 1.638 0 0 0-1.869-.181l.213.057c.307.082.623.124.94.124h.716Zm-.21 1.509c-.707.074-1.338.338-1.719.846-1 1.334-.422 2.766.022 3.432a7.688 7.688 0 0 0 3.463 2.829.407.407 0 0 0 .309-.006C7.032 10.087 9 9.1 9.91 7.277c.667-1.337.236-2.937-.75-3.521-.376-.223-.707-.335-1.056-.346a2.05 2.05 0 0 0-.466.041c.49.746.796 1.808.796 3.29 0 .348-.028.667-.071.952a.7.7 0 1 1-1.385-.208c.034-.222.056-.472.056-.744 0-1.898-.564-2.676-1.036-3.024a1.856 1.856 0 0 0-.273-.167c-.28-.14-.93-.279-1.649-.204Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconPeach = makeIcon({
  displayName: 'NoteIconPeach',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.17 1.086A.75.75 0 0 0 7.83.415L7.75.57a4.75 4.75 0 0 0-.438 1.356l-.076-.083a3.658 3.658 0 0 0-4.732-.581 1.332 1.332 0 0 0 .243 2.344l.054.022c-.372.25-.714.562-1.006.952-1.988 2.651-.75 5.428-.024 6.518 1.743 2.616 4.083 3.984 5.239 4.54a2.278 2.278 0 0 0 1.973 0c1.303-.618 4.282-2.275 5.735-5.185 1.193-2.389.59-5.568-1.648-6.894-.669-.396-1.386-.67-2.213-.696-.667-.02-1.36.12-2.108.428v-.597c0-.504.117-1.002.343-1.453l.078-.155ZM7.667 4.422Zm-.08.09L2.811 9.92c.07.128.14.243.209.345 1.539 2.31 3.618 3.528 4.642 4.021a.778.778 0 0 0 .68-.004c1.242-.59 3.819-2.064 5.035-4.5.923-1.847.345-4.095-1.07-4.933-.52-.308-.992-.471-1.496-.487a3.113 3.113 0 0 0-.932.122c.716.965 1.183 2.4 1.183 4.502 0 .454-.037.871-.093 1.243a.75.75 0 0 1-1.483-.223c.045-.304.075-.647.076-1.02 0-2.568-.765-3.67-1.456-4.18a2.658 2.658 0 0 0-.391-.238 1.702 1.702 0 0 0-.129-.057Zm0 0c-.453-.18-1.278-.326-2.17-.233-.973.1-1.87.468-2.42 1.2-1.247 1.664-.74 3.43-.185 4.442l4.775-5.41Zm-1.62-1.819a2.159 2.159 0 0 0-2.333-.349l.25.1a3.794 3.794 0 0 0 1.552.27l.531-.02Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconPeachSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconPackageSmall = makeIcon({
  displayName: 'NoteIconPackageSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.744.099a.7.7 0 0 1 .512 0l5.244 2.06a.699.699 0 0 1 .45.668v5.91a.7.7 0 0 1-.398.632l-5.25 2.513a.699.699 0 0 1-.604 0L.448 9.369a.7.7 0 0 1-.398-.631V2.813a.7.7 0 0 1 .444-.652L5.744.1ZM6 4.726 2.447 2.898l1.027-.403 3.571 1.693L6 4.726Zm3.325-.136v1.785a.7.7 0 1 1-1.4 0V5.31L6.7 5.94v4.2l3.85-1.843V3.96l-1.225.63Zm-.712-1.208L5.26 1.792 6 1.503l3.553 1.396-.94.484ZM5.3 5.94 1.45 3.96v4.337l3.85 1.842v-4.2Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconPackage = makeIcon({
  displayName: 'NoteIconPackage',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.705.06a.75.75 0 0 1 .59 0l7 3a.75.75 0 0 1 .455.71v7.88a.75.75 0 0 1-.407.667l-6.994 3.597a.75.75 0 0 1-.698 0L.657 12.317a.75.75 0 0 1-.407-.667v-7.9c0-.3.179-.571.455-.69l7-3ZM7.25 14.02l-5.5-2.828V4.98l5.5 2.829v6.213ZM8 6.508 2.76 3.812l1.937-.83 5.146 2.577L8 6.507Zm4.25-.5V8.5a.75.75 0 0 1-1.5 0V6.78l-2 1.028v6.213l5.5-2.829V4.98l-2 1.029Zm-.755-1.298L6.502 2.208 8 1.566l5.24 2.246-1.745.897Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconPackageSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconKeySmall = makeIcon({
  displayName: 'NoteIconKeySmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M9.475 3.637a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.963 7.926a3.888 3.888 0 1 0-2.59-2.432L.925 8.472c-.16.138-.276.32-.333.524L.154 10.56c-.2.713.365 1.41 1.105 1.362l1.51-.097c.413-.027.774-.287.928-.67l.13-.32.478-.173a.7.7 0 0 0 .428-.443l.141-.433.443-.194a.7.7 0 0 0 .227-.161l1.42-1.505ZM8.035 1.7a2.487 2.487 0 0 0-2.207 3.637.7.7 0 0 1-.189.912L1.914 9.468l-.288 1.029.85-.055.17-.42a.7.7 0 0 1 .41-.397l.452-.163.132-.406a.7.7 0 0 1 .384-.425l.6-.263L6.2 6.694a.706.706 0 0 1 .06-.056.7.7 0 0 1 .79-.165A2.488 2.488 0 1 0 8.035 1.7Z"
        />
      </g>
    </>
  ),
})

export const NoteIconKey = makeIcon({
  displayName: 'NoteIconKey',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M13.11 4.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.375 10.276a5 5 0 1 0-3.182-2.979l-4.694 4.054a1.25 1.25 0 0 0-.387.609l-.565 2.018a1.25 1.25 0 0 0 1.394 1.573l1.703-.261a1.25 1.25 0 0 0 1.024-.936l.086-.35h.816a.75.75 0 0 0 .75-.726l.019-.61.61-.073a.75.75 0 0 0 .456-.23l1.97-2.09ZM10.86 2a3.5 3.5 0 0 0-3.104 5.12.75.75 0 0 1-.205.986l-5.015 4.33-.44 1.573 1.155-.177.188-.758a.75.75 0 0 1 .728-.57h.676l.017-.528a.75.75 0 0 1 .66-.72l.98-.118 2.047-2.17A.757.757 0 0 1 8.62 8.9a.75.75 0 0 1 .853-.185A3.5 3.5 0 1 0 10.86 2Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconKeySmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconSeedlingSmall = makeIcon({
  displayName: 'NoteIconSeedlingSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m7.399 6.163.018.041c.215.483.408 1.187.408 2.148 0 .908-.091 1.6-.186 2.076a6.062 6.062 0 0 1-.185.703 1.989 1.989 0 0 1-.016.046l-.006.015-.002.006-.001.002v.002a.75.75 0 0 1-1.396-.552l.006-.014.028-.089c.026-.085.063-.223.1-.413.077-.382.158-.975.158-1.782 0-.607-.097-1.046-.202-1.345a4.532 4.532 0 0 1-.142.108c-.525.383-1.32.787-2.335.787a3.923 3.923 0 0 1-2.38-.793 4.042 4.042 0 0 1-.748-.733 2.293 2.293 0 0 1-.045-.061l-.014-.02-.005-.008-.002-.003H.45L.45 6.281l.624-.416C.45 5.45.451 5.449.451 5.449v-.002l.003-.003.005-.007.014-.02.045-.06c.037-.05.089-.115.156-.19.134-.151.331-.348.593-.544a3.923 3.923 0 0 1 2.379-.793c.9 0 1.612.29 2.128.62a4.557 4.557 0 0 1 1.331-2.846A4.557 4.557 0 0 1 9.712.3a4.7 4.7 0 0 1 1.216-.014l.085.013.027.005.01.002h.005l-.146.736.735-.147v.002l.001.001v.004l.003.01.004.026.013.085c.01.07.02.165.027.282.014.234.013.558-.04.935a4.557 4.557 0 0 1-1.304 2.606C9.516 5.679 8.532 6 7.782 6.117a5.302 5.302 0 0 1-.383.046Zm2.795-4.405a3.058 3.058 0 0 0-2.028.906 3.058 3.058 0 0 0-.905 2.005c.09-.007.187-.018.29-.034.543-.084 1.195-.308 1.737-.85a3.058 3.058 0 0 0 .906-2.027ZM2.11 5.866l.056.043c.332.249.82.493 1.479.493.604 0 1.095-.24 1.45-.499.024-.017.046-.033.067-.05a2.423 2.423 0 0 0-1.518-.523 2.423 2.423 0 0 0-1.534.536Zm3.505-.448v-.001l.002-.002-.002.003Z"
        />
        <path d="m11.644.895-.091.019-.644.128.147-.735a.75.75 0 0 1 .588.588ZM.45 5.45l.624.416-.546.364-.078.052a.75.75 0 0 1 0-.832Z" />
      </g>
    </>
  ),
})

export const NoteIconSeedling = makeIcon({
  displayName: 'NoteIconSeedling',
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M1.742 7.843c.109.105.24.221.396.337a3.877 3.877 0 0 0 2.362.788c.975 0 1.76-.386 2.318-.793.164-.12.306-.24.423-.348a4.14 4.14 0 0 0-.378-.322A3.877 3.877 0 0 0 4.5 6.718c-1.05 0-1.834.391-2.362.787a4.136 4.136 0 0 0-.396.338Zm6.02-1.538A5.377 5.377 0 0 0 4.5 5.218c-1.45 0-2.54.546-3.263 1.087-.36.27-.63.54-.813.747a4.425 4.425 0 0 0-.27.335l-.018.025-.006.009-.002.003-.001.002.623.417-.624-.416a.75.75 0 0 0 0 .832l.624-.416-.624.416v.001l.002.002.002.003.006.008.017.026.059.079A5.551 5.551 0 0 0 1.237 9.38 5.377 5.377 0 0 0 4.5 10.468c1.386 0 2.476-.551 3.203-1.082 1.23-.897 1.437-2.048.06-3.08Z" />
        <path d="M14.4 1.5a5.07 5.07 0 0 1-.052.794 4.802 4.802 0 0 1-1.378 2.758c-.857.856-1.884 1.205-2.724 1.336-.315.049-.598.067-.828.07a5.09 5.09 0 0 1 .051-.77 4.802 4.802 0 0 1 1.38-2.758 4.802 4.802 0 0 1 2.757-1.379c.304-.043.575-.054.793-.05ZM7.984 5.477A6.302 6.302 0 0 1 9.788 1.87 6.302 6.302 0 0 1 13.394.066a6.511 6.511 0 0 1 1.294-.055 5.16 5.16 0 0 1 .531.059l.012.002h.004l.002.001-.146.736.147-.736a.75.75 0 0 1 .588.589l-.735.147.735-.147v.001l.001.002v.004l.003.011a4.246 4.246 0 0 1 .023.147c.013.093.027.224.036.385a6.51 6.51 0 0 1-.055 1.294 6.302 6.302 0 0 1-1.804 3.606c-1.147 1.148-2.506 1.594-3.552 1.758-1.959.306-2.753-.575-2.493-2.394Z" />
        <path d="M9.777 7.935c.299.673.573 1.666.573 3.033 0 1.305-.13 2.415-.262 3.202a15.423 15.423 0 0 1-.244 1.181 5.78 5.78 0 0 1-.018.07l-.006.02-.002.007v.003l-.808-.23.807.23a.85.85 0 0 1-1.635-.466l.004-.011.013-.05a13.748 13.748 0 0 0 .213-1.034c.118-.713.238-1.728.238-2.922 0-1.133-.226-1.89-.427-2.342-.782-1.761.867-2.235 1.554-.69Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconSeedlingSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconPalmTreeSmall = makeIcon({
  displayName: 'NoteIconPalmTreeSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.737.213a3.934 3.934 0 0 0-3.75 1.084A3.934 3.934 0 0 0 2.234.213C1.459.406.925.818.586 1.255c-.32.413-.49.882-.49 1.234 0 .36.29.65.65.65H1.9c-.265.262-.502.56-.7.89-.487.81-.588 1.596-.506 2.238.077.61.326 1.133.602 1.41a.65.65 0 0 0 .94-.023l2.431-2.67-.544 5.848a.65.65 0 0 0 .468.697 5.311 5.311 0 0 0 2.918 0 .65.65 0 0 0 .468-.697l-.53-5.689 2.287 2.511a.65.65 0 0 0 .94.022c.277-.276.526-.798.603-1.41.08-.641-.02-1.428-.506-2.237a4.534 4.534 0 0 0-.7-.89h1.155a.65.65 0 0 0 .65-.65c0-.352-.17-.821-.49-1.234-.34-.437-.874-.849-1.65-1.042Zm-2.36 1.612.102.014h2.678a1.756 1.756 0 0 0-.734-.365 2.638 2.638 0 0 0-2.047.351Zm-2.883.014H1.816c.172-.148.41-.284.733-.365a2.638 2.638 0 0 1 2.047.351 4.55 4.55 0 0 0-.102.014Zm.977 8.552c.385.056.776.056 1.16 0l-.58-6.238-.58 6.238Zm-.883-7.25A3.38 3.38 0 0 0 2.315 4.7c-.301.5-.368.954-.34 1.312l2.613-2.87Zm2.796 0A3.38 3.38 0 0 1 9.658 4.7c.3.5.367.954.34 1.312l-2.614-2.87Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconPalmTree = makeIcon({
  displayName: 'NoteIconPalmTree',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.675 4H.75A.75.75 0 0 1 0 3.25c0-.443.218-1.056.642-1.602.445-.575 1.15-1.12 2.177-1.375a5.233 5.233 0 0 1 5.093 1.552 5.233 5.233 0 0 1 5.092-1.55c1.028.255 1.732.8 2.177 1.374.424.546.642 1.16.642 1.602a.75.75 0 0 1-.75.75h-1.926c.456.404.86.88 1.186 1.422.648 1.078.78 2.12.672 2.97-.102.812-.433 1.494-.784 1.845a.75.75 0 0 1-1.085-.025L9.735 6.475l.761 8.192a.75.75 0 0 1-.539.803 7.12 7.12 0 0 1-3.912 0 .75.75 0 0 1-.54-.803l.783-8.41-3.6 3.953a.75.75 0 0 1-1.085.026C1.25 9.885.92 9.203.816 8.39c-.107-.849.025-1.891.673-2.969A6.074 6.074 0 0 1 2.675 4Zm3.71-1.56a6.027 6.027 0 0 0-.53.06H1.882c.257-.305.666-.613 1.3-.771 1.151-.287 2.353.031 3.204.71Zm3.114 1.513.004.04 3.987 4.38c.01-.054.02-.11.027-.169.068-.535-.006-1.236-.47-2.008-.783-1.301-2.16-2.097-3.548-2.243Zm-.062-1.51c.85-.681 2.053-1 3.205-.713.634.158 1.043.467 1.3.771H9.96a6.023 6.023 0 0 0-.524-.059Zm-2.38 11.722a5.62 5.62 0 0 0 1.885 0l-.876-9.417h-.133l-.875 9.417ZM6.362 3.947c-1.4.135-2.796.934-3.585 2.247-.464.771-.538 1.472-.47 2.008.007.059.016.115.026.169l4.029-4.424Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconPalmTreeSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconHouseSmall = makeIcon({
  displayName: 'NoteIconHouseSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.48.2A.75.75 0 0 1 6.5.2l5.25 4.875a.75.75 0 0 1-.75 1.26v3.79C11 11.161 10.16 12 9.125 12h-6.25A1.875 1.875 0 0 1 1 10.125V6.329a.75.75 0 0 1-.77-1.254L5.48.2Zm-.23 10.3h1.5V8.25a.75.75 0 0 0-1.5 0v2.25Zm3 0V8.25a2.25 2.25 0 0 0-4.5 0v2.25h-.875a.375.375 0 0 1-.375-.375v-5.11l3.49-3.242 3.51 3.26v5.092a.375.375 0 0 1-.375.375H8.25Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconHouse = makeIcon({
  displayName: 'NoteIconHouse',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5.442a.75.75 0 0 1 1 0l7.25 6.5a.75.75 0 0 1-1 1.116l-.25-.223V13.5a2.25 2.25 0 0 1-2.25 2.25h-8.5A2.25 2.25 0 0 1 1.5 13.5V7.835l-.25.223a.75.75 0 0 1-1-1.116L7.5.442ZM6.75 14.25h2.5V11a1.25 1.25 0 1 0-2.5 0v3.25Zm4 0V11a2.75 2.75 0 0 0-5.5 0v3.25h-1.5A.75.75 0 0 1 3 13.5V6.49l5-4.483 5 4.483v7.01a.75.75 0 0 1-.75.75h-1.5Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconHouseSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconHeartSmall = makeIcon({
  displayName: 'NoteIconHeartSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.43 2.75c-1.112 0-1.93.834-1.93 1.763 0 .92.671 2.038 1.725 3.085.92.915 1.996 1.64 2.772 1.99.762-.356 1.837-1.133 2.77-2.09.513-.528.958-1.085 1.27-1.62.317-.543.463-1.007.463-1.365 0-.929-.818-1.763-1.93-1.763-.438 0-.811.2-1.136.548-.333.358-.579.84-.72 1.282a.75.75 0 0 1-1.429 0c-.14-.442-.386-.924-.719-1.282-.325-.349-.698-.548-1.135-.548ZM0 4.513C0 2.666 1.583 1.25 3.43 1.25c.96 0 1.706.458 2.234 1.026.122.131.234.27.336.412.102-.143.214-.28.336-.412.528-.568 1.275-1.026 2.233-1.026C10.417 1.25 12 2.666 12 4.513c0 .73-.284 1.462-.668 2.121-.39.669-.918 1.322-1.49 1.91-1.13 1.16-2.533 2.17-3.581 2.56a.75.75 0 0 1-.522 0c-1.03-.383-2.43-1.307-3.571-2.442C1.048 7.551 0 6.061 0 4.512Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconHeart = makeIcon({
  displayName: 'NoteIconHeart',
  content: (
    <>
      <path
        d="M14.5 5.74c0-1.658-1.329-2.99-2.952-2.99-.682 0-1.263.339-1.758.911-.5.58-.864 1.351-1.071 2.052a.75.75 0 0 1-1.438 0c-.207-.7-.57-1.472-1.071-2.052-.495-.572-1.076-.911-1.758-.911C2.83 2.75 1.5 4.082 1.5 5.74c0 1.544 1.022 3.304 2.485 4.87 1.331 1.425 2.897 2.55 4.012 3.07 1.1-.528 2.665-1.736 4.009-3.223.721-.799 1.355-1.65 1.804-2.48.453-.837.69-1.6.69-2.238Zm1.5 0c0 .982-.357 1.999-.872 2.951-.52.961-1.23 1.91-2.009 2.77-1.54 1.705-3.443 3.176-4.84 3.735a.75.75 0 0 1-.557 0c-1.38-.551-3.28-1.9-4.832-3.562C1.353 9.988 0 7.869 0 5.739 0 3.267 1.986 1.25 4.452 1.25c1.246 0 2.21.64 2.894 1.432.248.287.466.601.654.925.188-.324.406-.638.654-.925.684-.792 1.648-1.432 2.894-1.432C14.014 1.25 16 3.267 16 5.74Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconHeartSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconCreditCardSmall = makeIcon({
  displayName: 'NoteIconCreditCardSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 1.5C.839 1.5 0 2.34 0 3.375v5.25C0 9.661.84 10.5 1.875 10.5h8.25C11.161 10.5 12 9.66 12 8.625v-5.25c0-1.036-.84-1.875-1.875-1.875h-8.25ZM1.5 3.375c0-.207.168-.375.375-.375h8.25c.207 0 .375.168.375.375v.75h-9v-.75Zm0 2.75v2.5c0 .207.168.375.375.375h8.25a.375.375 0 0 0 .375-.375v-2.5h-9Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconCreditCard = makeIcon({
  displayName: 'NoteIconCreditCard',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 2.25A2.25 2.25 0 0 0 0 4.5v7a2.25 2.25 0 0 0 2.25 2.25h11.5A2.25 2.25 0 0 0 16 11.5v-7a2.25 2.25 0 0 0-2.25-2.25H2.25ZM1.5 4.5a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 .75.75v1h-13v-1Zm0 3.5v3.5c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75V8h-13Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconCreditCardSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconCarSmall = makeIcon({
  displayName: 'NoteIconCarSmall',
  viewBox: 12,
  content: (
    <>
      <path
        d="M3.61 7.6a.68.68 0 1 1-1.36 0 .68.68 0 0 1 1.36 0ZM9.05 8.28a.68.68 0 1 0 0-1.36.68.68 0 0 0 0 1.36ZM4.29 7.6a.68.68 0 0 1 .68-.68h2.04a.68.68 0 0 1 0 1.36H4.97a.68.68 0 0 1-.68-.68Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.72 1.2H4.17a3 3 0 0 0-2.992 2.778L1.08 5.28a2.66 2.66 0 0 0-.81 1.912v1.283c0 .723.47 1.343 1.13 1.559v.896c0 .375.304.68.68.68h.68a.68.68 0 0 0 .68-.68v-.698c1.698.103 3.401.103 5.1 0v.698c0 .375.304.68.68.68h.68a.68.68 0 0 0 .68-.68v-.896a1.64 1.64 0 0 0 1.13-1.56v-.981a3.34 3.34 0 0 0-.828-2.201l-.185-1.467A3 3 0 0 0 7.72 1.2ZM2.028 6.174l.152-.134H9.8c.389.382.609.905.609 1.453v.982a.34.34 0 0 1-.314.339l-.977.075a40.8 40.8 0 0 1-6.258 0l-.977-.075a.34.34 0 0 1-.314-.34V7.193c0-.39.167-.76.458-1.018ZM5.522 4.74H2.424l.05-.666A1.7 1.7 0 0 1 4.168 2.5H7.72a1.7 1.7 0 0 1 1.687 1.487l.095.753H8.498a1.52 1.52 0 0 0-2.976 0Zm1.07 0h.836a.52.52 0 0 0-.836 0Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconCar = makeIcon({
  displayName: 'NoteIconCar',
  content: (
    <>
      <path
        d="M4.5 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM12.5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5.5 10a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 5.5 10Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.545 1H5.322a4 4 0 0 0-3.99 3.705L1.18 6.78A3.5 3.5 0 0 0 0 9.401v1.886a2 2 0 0 0 1.25 1.854V14a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.542c2.498.153 5.002.153 7.5 0V14a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.858A2 2 0 0 0 16 11.287V9.843a4.5 4.5 0 0 0-1.198-3.057L14.514 4.5A4 4 0 0 0 10.545 1Zm-8.37 6.903L2.63 7.5h10.75l.118.105A3 3 0 0 1 14.5 9.843v1.444a.5.5 0 0 1-.462.498l-1.436.111c-3.064.236-6.14.236-9.204 0l-1.436-.11a.5.5 0 0 1-.462-.499V9.401a2 2 0 0 1 .675-1.498ZM7.264 6H2.74l.088-1.184A2.5 2.5 0 0 1 5.322 2.5h5.223a2.5 2.5 0 0 1 2.48 2.187L13.192 6h-1.455a2.25 2.25 0 0 0-4.472 0Zm1.529 0h1.414a.75.75 0 0 0-1.414 0Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconCarSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconTrophySmall = makeIcon({
  displayName: 'NoteIconTrophySmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.895.317A.65.65 0 0 1 2.38.1H9.62a.65.65 0 0 1 .646.724l-.02.181h1.003a.65.65 0 0 1 .65.65V2.75a2.901 2.901 0 0 1-2.429 2.862 3.907 3.907 0 0 1-2.013 1.842l.131 1.208a1.65 1.65 0 0 1 1.234 1.597v.341h.074a.65.65 0 1 1 0 1.3H3.103a.65.65 0 1 1 0-1.3h.075v-.341a1.65 1.65 0 0 1 1.233-1.597l.132-1.208a3.907 3.907 0 0 1-2.014-1.842A2.9 2.9 0 0 1 .1 2.75V1.655a.65.65 0 0 1 .65-.65h1.004l-.02-.181a.65.65 0 0 1 .16-.507ZM4.478 10.6v-.341a.35.35 0 0 1 .35-.35h2.345a.35.35 0 0 1 .35.35v.341H4.478ZM5.82 7.732l-.095.877h.55l-.095-.877a3.95 3.95 0 0 1-.36 0ZM1.903 2.305H1.4v.445c0 .552.28 1.04.706 1.327l-.203-1.772Zm7.992 1.772.203-1.772h.502v.445c0 .552-.28 1.039-.705 1.327ZM3.108 1.4l.313 2.735a2.596 2.596 0 0 0 5.159 0L8.892 1.4H3.108Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconTrophy = makeIcon({
  displayName: 'NoteIconTrophy',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.44.25A.75.75 0 0 1 3 0h10a.75.75 0 0 1 .745.835l-.047.415h1.552A.75.75 0 0 1 16 2v1.75a3.5 3.5 0 0 1-3.262 3.492A5.245 5.245 0 0 1 9.886 9.9l.265 1.858A1.75 1.75 0 0 1 11.75 13.5v1H12a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.25v-1a1.75 1.75 0 0 1 1.599-1.743l.265-1.858a5.246 5.246 0 0 1-2.851-2.657A3.5 3.5 0 0 1 0 3.75V2a.75.75 0 0 1 .75-.75h1.552L2.255.835A.75.75 0 0 1 2.44.251ZM5.75 14.5h4.5v-1a.25.25 0 0 0-.25-.25H6a.25.25 0 0 0-.25.25v1Zm1.831-4.267-.216 1.517h1.27l-.216-1.517a5.274 5.274 0 0 1-.838 0ZM2.474 2.75H1.5v1a2 2 0 0 0 1.302 1.875l-.001-.014-.327-2.861Zm10.725 2.861.327-2.861h.974v1a2 2 0 0 1-1.302 1.875l.001-.014ZM3.841 1.5l.45 3.94a3.733 3.733 0 0 0 7.418 0l.45-3.94H3.841Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconTrophySmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconEmailSmall = makeIcon({
  displayName: 'NoteIconEmailSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.125 1.7c.925 0 1.675.75 1.675 1.675v5.25c0 .925-.75 1.675-1.675 1.675h-8.25C.95 10.3.2 9.55.2 8.625v-5.25C.2 2.45.95 1.7 1.875 1.7h8.25Zm-2.82 5.86a2.046 2.046 0 0 1-2.61 0L1.682 9.165c.06.022.124.035.192.035h8.25a.57.57 0 0 0 .191-.035L7.305 7.56ZM1.3 8.123l2.52-1.345L1.3 4.51v3.613Zm6.879-1.345L10.7 8.123V4.51L8.18 6.778ZM1.875 2.8a.573.573 0 0 0-.501.297l3.99 3.591a.95.95 0 0 0 1.272 0l3.989-3.591a.572.572 0 0 0-.5-.297h-8.25Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconEmail = makeIcon({
  displayName: 'NoteIconEmail',
  content: (
    <>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.5a2.25 2.25 0 0 1 2.25-2.25h11.5A2.25 2.25 0 0 1 16 4.5v.036l.012.012L16 4.56V11.5a2.25 2.25 0 0 1-2.25 2.25H2.25A2.25 2.25 0 0 1 0 11.5V4.56l-.012-.012L0 4.536V4.5Zm13.75-.75c.245 0 .462.117.599.298l-5.496 5.13a1.25 1.25 0 0 1-1.706 0l-5.496-5.13a.749.749 0 0 1 .599-.298h11.5ZM1.5 10.025V5.96l2.652 2.475L1.5 10.025Zm.042 1.724c.103.292.381.501.708.501h11.5a.75.75 0 0 0 .709-.504L10.727 9.48l-.85.794a2.75 2.75 0 0 1-3.753 0l-.831-.776-3.75 2.25Zm10.324-3.331 2.634 1.598V5.959l-2.634 2.459Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconEmailSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconPhoneSmall = makeIcon({
  displayName: 'NoteIconPhoneSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M3.526 6.088c0-.196.159-.356.355-.356h.712c.197 0 .356.16.356.356v.356c0 .197-.16.356-.356.356h-.712a.356.356 0 0 1-.355-.356v-.356ZM3.881 7.156a.356.356 0 0 0-.355.356v.356c0 .197.159.356.355.356h.712c.197 0 .356-.16.356-.356v-.356a.356.356 0 0 0-.356-.356h-.712ZM3.526 8.936c0-.197.159-.356.355-.356h.712c.197 0 .356.16.356.356v.356c0 .197-.16.356-.356.356h-.712a.356.356 0 0 1-.355-.356v-.356ZM5.661 5.732a.356.356 0 0 0-.356.356v.356c0 .197.16.356.356.356h.712c.197 0 .356-.16.356-.356v-.356a.356.356 0 0 0-.356-.356h-.712ZM5.305 7.512c0-.196.16-.356.356-.356h.712c.197 0 .356.16.356.356v.356c0 .197-.16.356-.356.356h-.712a.356.356 0 0 1-.356-.356v-.356ZM5.661 8.58a.356.356 0 0 0-.356.356v.356c0 .197.16.356.356.356h.712c.197 0 .356-.16.356-.356v-.356a.356.356 0 0 0-.356-.356h-.712ZM7.085 6.088c0-.196.16-.356.356-.356h.712c.196 0 .356.16.356.356v.356c0 .197-.16.356-.356.356H7.44a.356.356 0 0 1-.356-.356v-.356ZM7.44 7.156a.356.356 0 0 0-.355.356v.356c0 .197.16.356.356.356h.712c.196 0 .356-.16.356-.356v-.356a.356.356 0 0 0-.356-.356H7.44ZM7.085 8.936c0-.197.16-.356.356-.356h.712c.196 0 .356.16.356.356v.356c0 .197-.16.356-.356.356H7.44a.356.356 0 0 1-.356-.356v-.356Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.295.668a18.322 18.322 0 0 0-6.555 0l-.187.034A2.874 2.874 0 0 0 .24 4.045l.114.625c.09.494.43.874.862 1.04l-.93 2.657a1.735 1.735 0 0 0-.097.573v1.242c0 .958.777 1.735 1.735 1.735h8.186c.959 0 1.735-.777 1.735-1.735V8.94c0-.195-.033-.389-.097-.573l-.928-2.65c.43-.168.77-.548.86-1.04l.114-.632A2.874 2.874 0 0 0 9.481.702L9.295.668ZM2.978 1.98a16.987 16.987 0 0 1 6.078 0l.187.034a1.54 1.54 0 0 1 1.239 1.791l-.116.633a.045.045 0 0 1-.055.035l-1.215-.317a.045.045 0 0 1-.033-.049l.108-.846a.667.667 0 0 0-.662-.751H3.526a.667.667 0 0 0-.666.708l.055.888a.045.045 0 0 1-.033.046l-1.16.314a.045.045 0 0 1-.055-.035l-.114-.626a1.54 1.54 0 0 1 1.239-1.79l.186-.035Zm6.39 3.626-.609-.159A1.38 1.38 0 0 1 7.74 3.94l.012-.095H4.235l.011.18a1.379 1.379 0 0 1-1.015 1.415l-.56.152-1.125 3.217a.4.4 0 0 0-.023.132v1.242c0 .221.18.4.4.4h8.187a.4.4 0 0 0 .401-.4V8.94a.4.4 0 0 0-.022-.132L9.367 5.606Z"
        />
      </g>
    </>
  ),
})

export const NoteIconPhone = makeIcon({
  displayName: 'NoteIconPhone',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M4.5 8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.5A.5.5 0 0 1 6 9H5a.5.5 0 0 1-.5-.5V8ZM5 9.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V10a.5.5 0 0 0-.5-.5H5ZM4.5 12a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V12ZM7.5 7.5A.5.5 0 0 0 7 8v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5h-1ZM7 10a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V10ZM7.5 11.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V12a.5.5 0 0 0-.5-.5h-1ZM9.5 8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V8ZM10 9.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V10a.5.5 0 0 0-.5-.5h-1ZM9.5 12a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V12Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.57.569a25.55 25.55 0 0 0-9.14 0l-.263.048A3.85 3.85 0 0 0 .068 5.095l.16.878A1.75 1.75 0 0 0 1.497 7.35l-1.37 3.912a2.25 2.25 0 0 0-.126.743v1.745A2.25 2.25 0 0 0 2.25 16h11.5A2.25 2.25 0 0 0 16 13.75v-1.745a2.25 2.25 0 0 0-.126-.743l-1.366-3.903a1.75 1.75 0 0 0 1.261-1.375l.162-.889A3.85 3.85 0 0 0 12.833.617L12.57.569ZM3.698 2.045a24.05 24.05 0 0 1 8.604 0l.262.047a2.35 2.35 0 0 1 1.892 2.734l-.162.889a.25.25 0 0 1-.31.197l-1.707-.446a.25.25 0 0 1-.184-.273l.15-1.189a.75.75 0 0 0-.743-.845h-7a.75.75 0 0 0-.749.797l.078 1.247a.25.25 0 0 1-.185.256l-1.628.442a.25.25 0 0 1-.312-.197l-.16-.878a2.35 2.35 0 0 1 1.892-2.734l.262-.047Zm9.153 5.121-.952-.248a1.75 1.75 0 0 1-1.294-1.915l.043-.344h-5.35l.028.451a1.75 1.75 0 0 1-1.29 1.797l-.88.239-1.614 4.611a.75.75 0 0 0-.042.248v1.745c0 .415.336.75.75.75h11.5a.75.75 0 0 0 .75-.75v-1.745a.749.749 0 0 0-.042-.248L12.85 7.166Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconPhoneSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconOneSmall = makeIcon({
  displayName: 'NoteIconOneSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M6.938 4a.75.75 0 0 0-1.28-.53L4.344 4.782a.75.75 0 0 0 1.06 1.06l.032-.031v2.252a.75.75 0 1 0 1.5 0V4Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75-.01A2.75 2.75 0 0 0 0 2.74v6.5a2.75 2.75 0 0 0 2.75 2.75h6.5A2.75 2.75 0 0 0 12 9.24v-6.5A2.75 2.75 0 0 0 9.25-.01h-6.5ZM1.5 2.74c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v6.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-6.5Z"
        />
      </g>
    </>
  ),
})

export const NoteIconOne = makeIcon({
  displayName: 'NoteIconOne',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M9 5a.75.75 0 0 0-1.28-.53L5.97 6.22a.75.75 0 0 0 1.06 1.06l.47-.47V11A.75.75 0 0 0 9 11V5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0A3.75 3.75 0 0 0 0 3.75v8.5A3.75 3.75 0 0 0 3.75 16h8.5A3.75 3.75 0 0 0 16 12.25v-8.5A3.75 3.75 0 0 0 12.25 0h-8.5ZM1.5 3.75A2.25 2.25 0 0 1 3.75 1.5h8.5a2.25 2.25 0 0 1 2.25 2.25v8.5a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25v-8.5Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconOneSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconTwoSmall = makeIcon({
  displayName: 'NoteIconTwoSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M5.534 5.07c.14-.219.289-.32.466-.32.18 0 .275.09.313.195.036.1.045.293-.169.516L4.16 7.281a.75.75 0 0 0-.243.552V8c0 .414.336.75.75.75h2.666a.75.75 0 0 0 0-1.5h-.92l.76-.697a.759.759 0 0 0 .027-.026c.599-.605.774-1.406.522-2.097A1.8 1.8 0 0 0 6 3.25c-.918 0-1.465.599-1.73 1.013a.75.75 0 0 0 1.264.808Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75-.01A2.75 2.75 0 0 0 0 2.74v6.5a2.75 2.75 0 0 0 2.75 2.75h6.5A2.75 2.75 0 0 0 12 9.24v-6.5A2.75 2.75 0 0 0 9.25-.01h-6.5ZM1.5 2.74c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v6.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-6.5Z"
        />
      </g>
    </>
  ),
})

export const NoteIconTwo = makeIcon({
  displayName: 'NoteIconTwo',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M6.985 6.404c.241-.378.564-.654 1.015-.654.43 0 .711.237.821.539.109.296.077.74-.343 1.172l-2.985 2.736a.75.75 0 0 0-.243.553V11c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5H7.655l1.852-1.697a.75.75 0 0 0 .026-.026c.805-.814 1.022-1.865.697-2.753C9.907 4.888 9.07 4.25 8 4.25c-1.192 0-1.913.774-2.279 1.346a.75.75 0 0 0 1.264.808Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0A3.75 3.75 0 0 0 0 3.75v8.5A3.75 3.75 0 0 0 3.75 16h8.5A3.75 3.75 0 0 0 16 12.25v-8.5A3.75 3.75 0 0 0 12.25 0h-8.5ZM1.5 3.75A2.25 2.25 0 0 1 3.75 1.5h8.5a2.25 2.25 0 0 1 2.25 2.25v8.5a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25v-8.5Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconTwoSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconThreeSmall = makeIcon({
  displayName: 'NoteIconThreeSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M5.1 7.26h-.002a.752.752 0 0 0-.518-.212c-.437 0-.78.39-.78.824a.86.86 0 0 0 .268.61c.485.448 1.122.728 1.956.728.657 0 1.205-.221 1.589-.607.383-.386.587-.921.587-1.523v-.017c0-.597-.201-1.031-.52-1.332a1.968 1.968 0 0 0-.767-.43l.83-.855c.228-.235.418-.461.418-.863a.75.75 0 0 0-.24-.568.84.84 0 0 0-.572-.205H4.675c-.407 0-.718.356-.718.756s.311.756.718.756h1.229l-.757.818c-.206.222-.312.42-.312.667 0 .4.312.756.718.756h.188c.315 0 .538.064.677.16.129.09.198.214.198.39v.017c0 .168-.06.291-.152.375a.62.62 0 0 1-.425.142c-.374 0-.656-.128-.94-.386Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 0A2.75 2.75 0 0 0 0 2.75v6.5A2.75 2.75 0 0 0 2.75 12h6.5A2.75 2.75 0 0 0 12 9.25v-6.5A2.75 2.75 0 0 0 9.25 0h-6.5ZM1.5 2.75c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v6.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-6.5Z"
        />
      </g>
    </>
  ),
})

export const NoteIconThree = makeIcon({
  displayName: 'NoteIconThree',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M5.312 11.584c.684.588 1.584.96 2.784.96 1.872 0 3.024-1.164 3.024-2.748v-.024c0-1.56-1.116-2.16-2.256-2.352l1.644-1.572c.336-.324.552-.576.552-1.032 0-.504-.396-.816-.936-.816H6.032a.799.799 0 0 0-.792.792c0 .432.36.792.792.792h2.58L6.98 7.228c-.288.288-.396.504-.396.756 0 .432.36.792.792.792h.288c1.032 0 1.644.384 1.644 1.068v.024c0 .624-.492 1.02-1.188 1.02-.66 0-1.164-.216-1.644-.624a.878.878 0 0 0-.588-.228.902.902 0 0 0-.888.888c0 .264.144.516.312.66Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0A3.75 3.75 0 0 0 0 3.75v8.5A3.75 3.75 0 0 0 3.75 16h8.5A3.75 3.75 0 0 0 16 12.25v-8.5A3.75 3.75 0 0 0 12.25 0h-8.5ZM1.5 3.75A2.25 2.25 0 0 1 3.75 1.5h8.5a2.25 2.25 0 0 1 2.25 2.25v8.5a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25v-8.5Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconThreeSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMotorwaySmall = makeIcon({
  displayName: 'NoteIconMotorwaySmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.125.05C.56.05.1.509.1 1.075v1.687c0 .566.459 1.025 1.025 1.025h.225V6a.65.65 0 0 0 1.3 0V3.787h6.7V6a.65.65 0 0 0 1.3 0V3.787h.225c.566 0 1.025-.459 1.025-1.025V1.075C11.9.509 11.441.05 10.875.05h-9.75ZM1.4 2.487V1.35h9.2v1.137H1.4Z"
        />
        <path d="M.405 11.801a.65.65 0 0 1-.206-.896l3.75-6a.65.65 0 0 1 .573-.305h2.956a.65.65 0 0 1 .573.305l3.75 6a.65.65 0 1 1-1.102.69L7.14 5.9h-.49V6a.65.65 0 1 1-1.3 0v-.1h-.49l-3.559 5.694a.65.65 0 0 1-.896.207Z" />
        <path d="M5.35 11.25a.65.65 0 1 0 1.3 0v-.75a.65.65 0 1 0-1.3 0v.75ZM6 9.275a.65.65 0 0 1-.65-.65v-.75a.65.65 0 0 1 1.3 0v.75a.65.65 0 0 1-.65.65Z" />
      </g>
    </>
  ),
})

export const NoteIconMotorway = makeIcon({
  displayName: 'NoteIconMotorway',
  content: (
    <>
      <g fill="currentcolor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 0C.81 0 .25.56.25 1.25V3.5c0 .69.56 1.25 1.25 1.25H2V8a.75.75 0 0 0 1.5 0V4.75h9V8A.75.75 0 0 0 14 8V4.75h.5c.69 0 1.25-.56 1.25-1.25V1.25C15.75.56 15.19 0 14.5 0h-13Zm.25 3.25V1.5h12.5v1.75H1.75Z"
        />
        <path d="M15.398 15.636a.75.75 0 0 0 .238-1.034L10.64 6.608a.75.75 0 0 0-.662-.358H6.022a.75.75 0 0 0-.663.358L.364 14.602a.75.75 0 0 0 1.272.795l4.78-7.647h.834V8a.75.75 0 0 0 1.5 0v-.25h.834l4.78 7.647a.75.75 0 0 0 1.034.239Z" />
        <path d="M7.25 15a.75.75 0 0 0 1.5 0v-1a.75.75 0 0 0-1.5 0v1ZM8 12.25a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 1.5 0v1a.75.75 0 0 1-.75.75Z" />
      </g>
    </>
  ),
  smallAlternative: NoteIconMotorwaySmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconArrowsCounterclockwiseSmall = makeIcon({
  displayName: 'NoteIconArrowsCounterclockwiseSmall',
  viewBox: 12,
  content: (
    <>
      <g fill="currentcolor">
        <path d="M2.35 5.138c0 .36.291.65.65.65h1.934a.65.65 0 0 0 0-1.3h-.626a2.158 2.158 0 0 1 3.702.497.65.65 0 1 0 1.202-.495A3.458 3.458 0 0 0 3.65 3.286v-.082a.65.65 0 0 0-1.3 0v1.934ZM9.65 6.863a.65.65 0 0 0-.65-.65H7.066a.65.65 0 0 0 0 1.3h.626a2.158 2.158 0 0 1-3.724-.553.65.65 0 0 0-1.215.463A3.458 3.458 0 0 0 8.35 8.715v.082a.65.65 0 0 0 1.3 0V6.863Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.1 2.75A2.65 2.65 0 0 1 2.75.1h6.5a2.65 2.65 0 0 1 2.65 2.65v6.5a2.65 2.65 0 0 1-2.65 2.65h-6.5A2.65 2.65 0 0 1 .1 9.25v-6.5ZM2.75 1.4A1.35 1.35 0 0 0 1.4 2.75v6.5c0 .746.605 1.35 1.35 1.35h6.5a1.35 1.35 0 0 0 1.35-1.35v-6.5A1.35 1.35 0 0 0 9.25 1.4h-6.5Z"
        />
      </g>
    </>
  ),
})

export const NoteIconArrowsCounterclockwise = makeIcon({
  displayName: 'NoteIconArrowsCounterclockwise',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M3.252 6.864c0 .414.336.75.75.75h2.591a.75.75 0 0 0 0-1.5H5.52a3.012 3.012 0 0 1 5.445.928.75.75 0 0 0 1.457-.357 4.512 4.512 0 0 0-7.67-2.01v-.403a.75.75 0 0 0-1.5 0v2.592ZM12.79 9.137a.75.75 0 0 0-.75-.75H9.449a.75.75 0 0 0 0 1.5h1.072a3.012 3.012 0 0 1-5.445-.928.75.75 0 1 0-1.457.357 4.512 4.512 0 0 0 7.67 2.01v.402a.75.75 0 0 0 1.5 0V9.137Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.75A3.75 3.75 0 0 1 3.75 0h8.5A3.75 3.75 0 0 1 16 3.75v8.5A3.75 3.75 0 0 1 12.25 16h-8.5A3.75 3.75 0 0 1 0 12.25v-8.5ZM3.75 1.5A2.25 2.25 0 0 0 1.5 3.75v8.5a2.25 2.25 0 0 0 2.25 2.25h8.5a2.25 2.25 0 0 0 2.25-2.25v-8.5a2.25 2.25 0 0 0-2.25-2.25h-8.5Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconArrowsCounterclockwiseSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconMortarBoardSmall = makeIcon({
  displayName: 'NoteIconMortarBoardSmall',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.962 1.629a2.15 2.15 0 0 0-1.923 0l-4.58 2.29a.65.65 0 0 0 0 1.162l.103.052v4.292a.375.375 0 0 0-.184.278l-.188 1.5a.375.375 0 0 0 .373.422h.75a.375.375 0 0 0 .372-.421l-.188-1.5a.375.375 0 0 0-.185-.279V5.508l1.038.519V8.76c0 .393.222.753.575.93a6.877 6.877 0 0 0 6.15 0 1.04 1.04 0 0 0 .575-.93V6.027l1.89-.946a.65.65 0 0 0 0-1.163l-4.578-2.29ZM5.62 2.792a.85.85 0 0 1 .76 0L9.797 4.5 6.38 6.208a.85.85 0 0 1-.76 0L2.204 4.5 5.62 2.792Zm2.73 3.885-1.388.694a2.15 2.15 0 0 1-1.923 0L3.65 6.677v1.919c1.49.692 3.21.692 4.7 0v-1.92Z"
        fill="currentcolor"
      />
    </>
  ),
})

export const NoteIconMortarBoard = makeIcon({
  displayName: 'NoteIconMortarBoard',
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.196 2.244a2.75 2.75 0 0 0-2.392 0l-6.38 3.08a.75.75 0 0 0 0 1.351l.326.158v5.709a.5.5 0 0 0-.296.396l-.25 2A.5.5 0 0 0 .7 15.5h1a.5.5 0 0 0 .496-.562l-.25-2a.5.5 0 0 0-.196-.338V7.315l1.5.725v3.64c0 .48.272.92.701 1.134a9.052 9.052 0 0 0 8.098 0c.43-.215.701-.654.701-1.135V8.04l2.826-1.364a.75.75 0 0 0 0-1.35l-6.38-3.08Zm-1.74 1.351a1.25 1.25 0 0 1 1.087 0L13.525 6 8.543 8.405a1.25 1.25 0 0 1-1.086 0L2.475 6l4.982-2.405Zm3.794 5.169-2.054.992a2.75 2.75 0 0 1-2.392 0L4.75 8.764v2.771c2.056.98 4.444.98 6.5 0V8.764Z"
        fill="currentcolor"
      />
    </>
  ),
  smallAlternative: NoteIconMortarBoardSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconHeavyDollarSignSmall = makeIcon({
  displayName: 'NoteIconHeavyDollarSignSmall',
  viewBox: 12,
  content: (
    <>
      <g fillRule="evenodd" clipRule="evenodd" fill="currentcolor">
        <path d="M4.743 8.72c.236.083.478.14.725.173v.291c0 .174.055.328.176.445.117.12.267.177.437.177a.58.58 0 0 0 .439-.178.597.597 0 0 0 .174-.444V8.86c.451-.097.823-.288 1.106-.577.317-.323.475-.72.475-1.184 0-.38-.093-.7-.296-.944a1.598 1.598 0 0 0-.677-.509 6.672 6.672 0 0 0-.937-.297 7.646 7.646 0 0 1-.612-.178.919.919 0 0 1-.317-.18.332.332 0 0 1-.1-.253c0-.163.061-.287.187-.384.137-.1.326-.158.581-.158.229 0 .411.032.552.09l.002.001c.158.064.34.161.545.294l.004.003c.09.053.167.094.23.115l.004.002a.7.7 0 0 0 .206.03c.159 0 .289-.08.387-.206a.678.678 0 0 0 .156-.44.667.667 0 0 0-.069-.31.594.594 0 0 0-.21-.238c-.387-.279-.8-.46-1.24-.54v-.305a.597.597 0 0 0-.174-.443.58.58 0 0 0-.439-.18c-.17 0-.32.059-.437.178a.597.597 0 0 0-.176.445v.325c-.45.1-.825.299-1.122.601v.001c-.32.332-.482.735-.482 1.198 0 .386.093.711.296.96l.001.002c.195.233.428.406.7.515.254.103.573.204.957.305.26.073.458.132.593.178.122.042.22.098.294.166l.003.003c.064.055.095.12.095.209a.44.44 0 0 1-.185.381c-.129.09-.33.145-.622.145-.217 0-.426-.029-.627-.087a3.15 3.15 0 0 1-.638-.3l-.001-.001c-.153-.09-.302-.147-.439-.147-.158 0-.29.08-.393.204l-.003.004a.7.7 0 0 0-.147.438c0 .114.018.22.06.314l.003.006.003.006c.05.09.129.162.223.223.212.155.457.281.729.38Zm1.778-5.596Zm-.131-.771Zm-.64 7.17Z" />
        <path d="M0 2.74A2.75 2.75 0 0 1 2.75-.01h6.5A2.75 2.75 0 0 1 12 2.74v6.5a2.75 2.75 0 0 1-2.75 2.75h-6.5A2.75 2.75 0 0 1 0 9.24v-6.5Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25h-6.5Z" />
      </g>
    </>
  ),
})

export const NoteIconHeavyDollarSign = makeIcon({
  displayName: 'NoteIconHeavyDollarSign',
  content: (
    <>
      <g fill="currentcolor">
        <path d="M10.39 11.01c.407-.394.61-.878.61-1.45 0-.479-.123-.86-.37-1.142a2.04 2.04 0 0 0-.871-.624 9.537 9.537 0 0 0-1.296-.392 11.408 11.408 0 0 1-.882-.243 1.524 1.524 0 0 1-.523-.286.632.632 0 0 1-.207-.487c0-.282.116-.508.349-.677.24-.17.555-.254.947-.254.341 0 .628.046.86.138.24.091.508.229.806.412.123.07.218.117.283.138a.813.813 0 0 0 .229.032c.145 0 .272-.067.381-.201a.69.69 0 0 0 .174-.466.667.667 0 0 0-.076-.328.608.608 0 0 0-.229-.243 4.15 4.15 0 0 0-1.84-.72v-.582a.587.587 0 0 0-.185-.455.622.622 0 0 0-.468-.18.644.644 0 0 0-.469.18.587.587 0 0 0-.185.455v.603c-.675.113-1.223.374-1.644.783-.414.41-.62.9-.62 1.471 0 .487.123.875.37 1.164.254.29.555.501.903.635.349.134.792.268 1.329.402.37.099.653.18.85.244.195.063.359.151.49.264a.536.536 0 0 1 .206.434.78.78 0 0 1-.348.677c-.233.155-.567.233-1.002.233-.327 0-.643-.042-.947-.127a4.761 4.761 0 0 1-.948-.423c-.203-.113-.374-.17-.512-.17-.145 0-.276.067-.392.202a.717.717 0 0 0-.163.465c0 .134.022.247.065.339.051.084.135.162.25.232.284.198.61.36.98.487.378.127.767.208 1.166.244v.571c0 .19.062.342.185.455.124.12.28.18.468.18.196 0 .352-.06.469-.18a.586.586 0 0 0 .185-.455v-.603c.682-.113 1.223-.363 1.622-.751Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0A3.75 3.75 0 0 0 0 3.75v8.5A3.75 3.75 0 0 0 3.75 16h8.5A3.75 3.75 0 0 0 16 12.25v-8.5A3.75 3.75 0 0 0 12.25 0h-8.5ZM1.5 3.75A2.25 2.25 0 0 1 3.75 1.5h8.5a2.25 2.25 0 0 1 2.25 2.25v8.5a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25v-8.5Z"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconHeavyDollarSignSmall,
})

// !!! THIS IS A GENERATED FILE BY packages/icons/bin/sprite.ts
const NoteIconHeavyPlusSignSmall = makeIcon({
  displayName: 'NoteIconHeavyPlusSignSmall',
  viewBox: 12,
  content: (
    <>
      <g>
        <path
          d="M.154 5.243a1.5 1.5 0 0 1 1.492-1.346l2.25-.001.001-2.25.007-.152A1.5 1.5 0 0 1 5.397.147h1.25a1.5 1.5 0 0 1 1.5 1.5v2.249h2.249a1.5 1.5 0 0 1 1.5 1.5v1.25a1.5 1.5 0 0 1-1.5 1.5h-2.25v2.25a1.5 1.5 0 0 1-1.5 1.5h-1.25a1.5 1.5 0 0 1-1.5-1.5v-2.25h-2.25a1.5 1.5 0 0 1-1.5-1.5v-1.25l.008-.153Zm1.492 1.403h3.25a.5.5 0 0 1 .5.5v3.25h1.25v-3.25a.5.5 0 0 1 .5-.5h3.25v-1.25h-3.25a.5.5 0 0 1-.5-.5l.001-3.25h-1.25v3.25a.5.5 0 0 1-.5.5h-3.25v1.25Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
})

export const NoteIconHeavyPlusSign = makeIcon({
  displayName: 'NoteIconHeavyPlusSign',
  content: (
    <>
      <g>
        <path
          d="M.185 6.94a1.5 1.5 0 0 1 1.492-1.346h3.936l.001-3.935.008-.154A1.5 1.5 0 0 1 7.114.159h1.812a1.5 1.5 0 0 1 1.5 1.5v3.934h3.934a1.5 1.5 0 0 1 1.5 1.5v1.812a1.5 1.5 0 0 1-1.5 1.5h-3.935v3.937a1.5 1.5 0 0 1-1.5 1.5H7.113a1.5 1.5 0 0 1-1.5-1.5v-3.936H1.677a1.5 1.5 0 0 1-1.5-1.5V7.094l.008-.154Zm1.492 1.966h4.936a.5.5 0 0 1 .5.5v4.936h1.812V9.406c0-.276.225-.5.5-.5h4.935V7.092H9.426a.5.5 0 0 1-.5-.5V1.66H7.114v4.934l-.01.102a.5.5 0 0 1-.49.399H1.676v1.812Z"
          fill="currentcolor"
        />
      </g>
    </>
  ),
  smallAlternative: NoteIconHeavyPlusSignSmall,
})
